
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("lw7p7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5izcQ = parcelRequire("5izcQ");

var $2Fndw = parcelRequire("2Fndw");


var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");


var $inPa6 = parcelRequire("inPa6");


var $lzcvT = parcelRequire("lzcvT");


var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gWF6I = parcelRequire("gWF6I");




/**
 * @generated SignedSource<<88a6e3e5bd5b9b42e6701da9bb6ce108>>
 * @relayHash edd863f14a15d733e302fb5f4b7e2308
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8c3ecce0aec8f270bf98e0d88b202a9a261475df10e29bc6bd1b1e0634b05ed5
const $6e87170c9009b0c9$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "applicationKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "chargeElement"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entitlementFilter"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "onboardingStateKeys"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "productKey"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForAddPaymentDetails"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForChargeQuantities"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForDirectBuyChangeOffering"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForPaymentDetails"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForStorageLimit"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForStorageUsageJira"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForTrial"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForUserEmail"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckUserPreferences"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldSkip"
    }, v17 = [
        {
            "kind": "Variable",
            "name": "applicationKey",
            "variableName": "applicationKey"
        },
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v18 = {
        "condition": "shouldCheckForStorageUsageJira",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "condition": "shouldCheckForStorageLimit",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": v17 /*: any*/ ,
                                "kind": "ScalarField",
                                "name": "attachmentStorageAllowed"
                            },
                            {
                                "args": v17 /*: any*/ ,
                                "kind": "ScalarField",
                                "name": "attachmentStorageIsUnlimited"
                            }
                        ]
                    },
                    {
                        "args": v17 /*: any*/ ,
                        "kind": "ScalarField",
                        "name": "attachmentStorageUsed"
                    }
                ]
            }
        ]
    }, v19 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v20 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "productKey"
        }
    ], v21 = {
        "kind": "ScalarField",
        "name": "entitlementId"
    }, v22 = [
        {
            "kind": "Variable",
            "name": "where",
            "variableName": "entitlementFilter"
        }
    ], v23 = {
        "kind": "ScalarField",
        "name": "id"
    }, v24 = {
        "kind": "Literal",
        "name": "offeringName",
        "value": "Standard"
    }, v25 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v26 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v27 = [
        v25 /*: any*/ ,
        v26 /*: any*/ 
    ], v28 = {
        "concreteType": "CcpEntitlementExperienceCapabilities",
        "kind": "LinkedField",
        "name": "experienceCapabilities",
        "plural": false,
        "selections": [
            {
                "args": [
                    v24 /*: any*/ 
                ],
                "concreteType": "CcpChangeOfferingExperienceCapability",
                "kind": "LinkedField",
                "name": "changeOfferingV2",
                "plural": false,
                "selections": v27 /*: any*/ ,
                "storageKey": "changeOfferingV2(offeringName:\"Standard\")"
            },
            {
                "condition": "shouldCheckForDirectBuyChangeOffering",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "alias": "changeOfferingV2WithSkipTrial",
                        "args": [
                            v24 /*: any*/ ,
                            {
                                "kind": "Literal",
                                "name": "skipTrial",
                                "value": true
                            }
                        ],
                        "concreteType": "CcpChangeOfferingExperienceCapability",
                        "kind": "LinkedField",
                        "name": "changeOfferingV2",
                        "plural": false,
                        "selections": v27 /*: any*/ ,
                        "storageKey": "changeOfferingV2(offeringName:\"Standard\",skipTrial:true)"
                    }
                ]
            }
        ]
    }, v29 = {
        "condition": "shouldCheckForChargeQuantities",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "chargeElement",
                        "variableName": "chargeElement"
                    }
                ],
                "kind": "ScalarField",
                "name": "latestUsageForChargeElement"
            }
        ]
    }, v30 = {
        "concreteType": "CcpEntitlementPreDunning",
        "kind": "LinkedField",
        "name": "preDunning",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "status"
            }
        ]
    }, v31 = {
        "concreteType": "CcpTrial",
        "kind": "LinkedField",
        "name": "trial",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "timeLeft"
            },
            {
                "kind": "ScalarField",
                "name": "startTimestamp"
            },
            {
                "kind": "ScalarField",
                "name": "endTimestamp"
            }
        ]
    }, v32 = {
        "kind": "ScalarField",
        "name": "invoiceable"
    }, v33 = {
        "concreteType": "CcpInvoiceGroupExperienceCapabilities",
        "kind": "LinkedField",
        "name": "experienceCapabilities",
        "plural": false,
        "selections": [
            {
                "concreteType": "CcpConfigurePaymentMethodExperienceCapability",
                "kind": "LinkedField",
                "name": "configurePaymentV2",
                "plural": false,
                "selections": [
                    v26 /*: any*/ ,
                    v25 /*: any*/ 
                ]
            }
        ]
    }, v34 = {
        "concreteType": "CcpOfferingTrial",
        "kind": "LinkedField",
        "name": "trial",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "lengthDays"
            }
        ]
    }, v35 = {
        "kind": "ScalarField",
        "name": "key"
    }, v36 = {
        "kind": "ScalarField",
        "name": "isCurrentUserBillingAdmin"
    }, v37 = {
        "condition": "shouldCheckForPaymentDetails",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "CcpTransactionAccount",
                "kind": "LinkedField",
                "name": "transactionAccount",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isBillToPresent"
                    }
                ]
            }
        ]
    }, v38 = {
        "condition": "shouldCheckForAddPaymentDetails",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "CcpTransactionAccount",
                "kind": "LinkedField",
                "name": "transactionAccount",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "CcpTransactionAccountExperienceCapabilities",
                        "kind": "LinkedField",
                        "name": "experienceCapabilities",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "CcpAddPaymentMethodExperienceCapability",
                                "kind": "LinkedField",
                                "name": "addPaymentMethodV2",
                                "plural": false,
                                "selections": v27 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ]
    }, v39 = {
        "concreteType": "CcpEntitlementRelationship",
        "kind": "LinkedField",
        "name": "relatesFromEntitlements",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "relationshipType"
            },
            v21 /*: any*/ 
        ]
    }, v40 = [
        {
            "kind": "Literal",
            "name": "relationshipTypes",
            "value": "COLLECTION"
        }
    ], v41 = {
        "concreteType": "GrowthUnifiedProfileEntitlementProfileResult",
        "kind": "LinkedField",
        "name": "entitlementProfile",
        "plural": false,
        "selections": [
            {
                "concreteType": "GrowthUnifiedProfileEntitlementContextTrialResult",
                "kind": "LinkedField",
                "name": "lastKnownTrial",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "trialType"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "trialTrigger"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "trialEndTimeStamp"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "createdAt"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "offeringId"
                    }
                ]
            }
        ]
    }, v42 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "accountId"
        }
    ], v43 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "email"
            }
        ],
        "type": "AtlassianAccountUser"
    }, v44 = {
        "condition": "shouldCheckUserPreferences",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "UserPreferences",
                "kind": "LinkedField",
                "name": "userPreferences",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "key",
                                "variableName": "onboardingStateKeys"
                            }
                        ],
                        "concreteType": "UserOnboardingState",
                        "kind": "LinkedField",
                        "name": "onboardingState",
                        "plural": true,
                        "selections": [
                            v35 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v45 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "editionAwarenessQuery",
            "selections": [
                v18 /*: any*/ ,
                {
                    "condition": "shouldSkip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v19 /*: any*/ ,
                            "concreteType": "TenantContext",
                            "kind": "LinkedField",
                            "name": "tenantContexts",
                            "plural": true,
                            "selections": [
                                {
                                    "args": v20 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlementInfo",
                                    "plural": false,
                                    "selections": [
                                        v21 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "args": v22 /*: any*/ ,
                                                    "concreteType": "CcpEntitlement",
                                                    "kind": "LinkedField",
                                                    "name": "entitlement",
                                                    "plural": false,
                                                    "selections": [
                                                        v23 /*: any*/ ,
                                                        v28 /*: any*/ ,
                                                        v29 /*: any*/ ,
                                                        {
                                                            "condition": "shouldCheckForTrial",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                v30 /*: any*/ ,
                                                                {
                                                                    "concreteType": "CcpSubscription",
                                                                    "kind": "LinkedField",
                                                                    "name": "subscription",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v31 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "CcpAccountDetails",
                                                                            "kind": "LinkedField",
                                                                            "name": "accountDetails",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "CcpInvoiceGroup",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "invoiceGroup",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v32 /*: any*/ ,
                                                                                        v33 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "CcpOffering",
                                                                    "kind": "LinkedField",
                                                                    "name": "offering",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v34 /*: any*/ ,
                                                                        v35 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "CcpTransactionAccount",
                                                            "kind": "LinkedField",
                                                            "name": "transactionAccount",
                                                            "plural": false,
                                                            "selections": [
                                                                v35 /*: any*/ ,
                                                                v36 /*: any*/ 
                                                            ]
                                                        },
                                                        v37 /*: any*/ ,
                                                        v38 /*: any*/ ,
                                                        v39 /*: any*/ ,
                                                        {
                                                            "alias": "relatesFromEntitlementsWithCollectionType",
                                                            "args": v40 /*: any*/ ,
                                                            "concreteType": "CcpEntitlementRelationship",
                                                            "kind": "LinkedField",
                                                            "name": "relatesFromEntitlements",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "CcpEntitlement",
                                                                    "kind": "LinkedField",
                                                                    "name": "entitlement",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v30 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "relatesFromEntitlements(relationshipTypes:\"COLLECTION\")"
                                                        },
                                                        v41 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "CommerceEntitlementInfoCcp"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "shouldCheckForUserEmail",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v42 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v43 /*: any*/ 
                            ]
                        }
                    ]
                },
                v44 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v6 /*: any*/ ,
                v9 /*: any*/ ,
                v13 /*: any*/ ,
                v16 /*: any*/ ,
                v8 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v12 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v14 /*: any*/ ,
                v11 /*: any*/ ,
                v10 /*: any*/ ,
                v15 /*: any*/ ,
                v5 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "editionAwarenessQuery",
            "selections": [
                v18 /*: any*/ ,
                {
                    "condition": "shouldSkip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v19 /*: any*/ ,
                            "concreteType": "TenantContext",
                            "kind": "LinkedField",
                            "name": "tenantContexts",
                            "plural": true,
                            "selections": [
                                {
                                    "args": v20 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlementInfo",
                                    "plural": false,
                                    "selections": [
                                        v45 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "args": v22 /*: any*/ ,
                                                    "concreteType": "CcpEntitlement",
                                                    "kind": "LinkedField",
                                                    "name": "entitlement",
                                                    "plural": false,
                                                    "selections": [
                                                        v23 /*: any*/ ,
                                                        v28 /*: any*/ ,
                                                        {
                                                            "concreteType": "CcpTransactionAccount",
                                                            "kind": "LinkedField",
                                                            "name": "transactionAccount",
                                                            "plural": false,
                                                            "selections": [
                                                                v35 /*: any*/ ,
                                                                v36 /*: any*/ ,
                                                                v23 /*: any*/ 
                                                            ]
                                                        },
                                                        v39 /*: any*/ ,
                                                        {
                                                            "alias": "relatesFromEntitlementsWithCollectionType",
                                                            "args": v40 /*: any*/ ,
                                                            "concreteType": "CcpEntitlementRelationship",
                                                            "kind": "LinkedField",
                                                            "name": "relatesFromEntitlements",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "CcpEntitlement",
                                                                    "kind": "LinkedField",
                                                                    "name": "entitlement",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v30 /*: any*/ ,
                                                                        v23 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "relatesFromEntitlements(relationshipTypes:\"COLLECTION\")"
                                                        },
                                                        v41 /*: any*/ ,
                                                        v29 /*: any*/ ,
                                                        {
                                                            "condition": "shouldCheckForTrial",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                v30 /*: any*/ ,
                                                                {
                                                                    "concreteType": "CcpSubscription",
                                                                    "kind": "LinkedField",
                                                                    "name": "subscription",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v31 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "CcpAccountDetails",
                                                                            "kind": "LinkedField",
                                                                            "name": "accountDetails",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "CcpInvoiceGroup",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "invoiceGroup",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v32 /*: any*/ ,
                                                                                        v33 /*: any*/ ,
                                                                                        v23 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v23 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "CcpOffering",
                                                                    "kind": "LinkedField",
                                                                    "name": "offering",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v34 /*: any*/ ,
                                                                        v35 /*: any*/ ,
                                                                        v23 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v37 /*: any*/ ,
                                                        v38 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "CommerceEntitlementInfoCcp"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "shouldCheckForUserEmail",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v42 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v45 /*: any*/ ,
                                v43 /*: any*/ ,
                                v23 /*: any*/ 
                            ]
                        }
                    ]
                },
                v44 /*: any*/ 
            ]
        },
        "params": {
            "id": "8c3ecce0aec8f270bf98e0d88b202a9a261475df10e29bc6bd1b1e0634b05ed5",
            "metadata": {},
            "name": "editionAwarenessQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6e87170c9009b0c9$var$node.hash = "fb1691b41e33c680ea18494afac09d0e";
var $6e87170c9009b0c9$export$2e2bcd8739ae039 = $6e87170c9009b0c9$var$node;






var $irOoi = parcelRequire("irOoi");


var $dh538 = parcelRequire("dh538");


var $fwDOR = parcelRequire("fwDOR");


var $hnvzE = parcelRequire("hnvzE");


var $1o4fX = parcelRequire("1o4fX");


var $9CFT2 = parcelRequire("9CFT2");


var $eoBBJ = parcelRequire("eoBBJ");


var $dv2kx = parcelRequire("dv2kx");


var $fgLLK = parcelRequire("fgLLK");




const $4b00699181955ef3$export$6cf5f13af3dcd5bf = (product)=>{
    switch(product){
        case 'jira-service-management':
            return {
                collectionType: 'Service Collection',
                isEnabled: (0, $dh538.fg)('servco-xflow-ga')
            };
        case 'jira':
        case 'confluence':
            return {
                collectionType: 'Teamwork Collection',
                isEnabled: true
            };
        default:
            return undefined;
    }
};





const $8d37867ef9911324$var$PRODUCT_TO_CHARGE_ELEMENT = {
    ['confluence']: 'user',
    ['jira']: 'user',
    ['jira-product-discovery']: 'user',
    ['jira-service-management']: 'agent'
};
const $8d37867ef9911324$export$58e4e89574623b4 = (product)=>{
    return $8d37867ef9911324$var$PRODUCT_TO_CHARGE_ELEMENT[product];
};


// We're explicitly excluding 'confluence' from this mapping as it's handled separately
const $c5924b8ca71db57a$var$PRODUCT_TO_JIRA_APPLICATION_KEY = {
    ['jira']: 'JIRA_SOFTWARE',
    ['jira-product-discovery']: 'JIRA_PRODUCT_DISCOVERY',
    ['jira-service-management']: 'JIRA_SERVICE_DESK'
};
const $c5924b8ca71db57a$export$2fd6994252e4887f = (product)=>{
    return $c5924b8ca71db57a$var$PRODUCT_TO_JIRA_APPLICATION_KEY[product];
};



var $ecqMk = parcelRequire("ecqMk");

/**
 * @generated SignedSource<<9e6c2ddb4cdab642478fec1a9416c6ef>>
 * @relayHash f6314aa271413378cc6a907956a8f3c4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d89be6ac69ec20e87d353edcd9c7b4d2e8e5fc3a46a9555ba2d5ceb8bf352a12
const $3feab6ba4bf7ad3d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "key"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "value"
        }
    ], v1 = [
        {
            "args": [
                {
                    "items": [
                        {
                            "fields": [
                                {
                                    "kind": "Variable",
                                    "name": "key",
                                    "variableName": "key"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "value",
                                    "variableName": "value"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "states.0"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "states"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "setOnboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useMarkDialogAsSeenMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useMarkDialogAsSeenMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "d89be6ac69ec20e87d353edcd9c7b4d2e8e5fc3a46a9555ba2d5ceb8bf352a12",
            "metadata": {},
            "name": "useMarkDialogAsSeenMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$3feab6ba4bf7ad3d$var$node.hash = "3dadf7831715f454e511403477edc50d";
var $3feab6ba4bf7ad3d$export$2e2bcd8739ae039 = $3feab6ba4bf7ad3d$var$node;








function $a979d2c30a666dd9$export$423571b0238e9b3e(dialogId, product, edition) {
    return `edition-awareness:${dialogId}:${product}:${edition}:has-auto-opened`;
}
function $a979d2c30a666dd9$export$64bdfecd0a02bd78() {
    const [commit] = (0, $irOoi.useMutation)((0, $3feab6ba4bf7ad3d$export$2e2bcd8739ae039));
    return (0, $42omo.useCallback)((dialogId, product, edition)=>{
        commit({
            variables: {
                key: $a979d2c30a666dd9$export$423571b0238e9b3e(dialogId, product, edition),
                value: 'true'
            }
        });
        localStorage.setItem($a979d2c30a666dd9$export$423571b0238e9b3e(dialogId, product, edition), 'true');
    }, [
        commit
    ]);
}


function $41131f5950265612$export$bac5bb66ae1b635d(product, edition, cloudId, accountId, userRolesFromProduct) {
    const isProductJiraFree = product === 'jira' && edition === 'free';
    const isSpecialOfferSixtyEnabled = product === 'jira' && edition === 'free' && !!(0, $dh538.fg)('special_offer_60_days_jira_standard_kill_switch');
    const shouldCheckForPaymentDetails = edition === 'free' && product === 'confluence';
    const shouldCheckUserPreferences = product === 'confluence';
    const isSiteAdmin = userRolesFromProduct?.includes('SITE_ADMIN') ?? false;
    const onboardingStateKeys = [
        (0, $a979d2c30a666dd9$export$423571b0238e9b3e)('feature-onboarding-modal', product, edition)
    ];
    // Entitlement filter controls which entitlements are fetched from the API.
    // The filter is based on the trial end timestamp in TCS - if a customer downgrades to free while
    // on a trial, they still show up when inTrialOrPreDunning is true as the filter assumes they're still on trial.
    //
    //   - Site admin + non-free edition:
    //       Returns entitlements that are (in trial/predunning) OR (in a collection)
    //
    //   - Non-site admin + non-free edition:
    //       Returns entitlements that are (in trial/predunning)
    //
    //   - Free edition (any user):
    //       Returns all entitlements (no filter)
    //
    // GATE OFF (standard behavior):
    //   - Non-free edition: Returns trial/predunning entitlements
    const getEntitlementFilter = ()=>{
        if (isSiteAdmin && edition !== 'free') return {
            OR: [
                {
                    inTrialOrPreDunning: true
                },
                {
                    hasRelationshipFromWithType: 'COLLECTION'
                }
            ]
        };
        else return edition !== 'free' ? {
            inTrialOrPreDunning: true
        } : null;
    };
    const entitlementFilter = getEntitlementFilter();
    return {
        shouldSkip: product === 'jira-product-discovery' && (0, $dh538.fg)('jpd_disable_edition_awareness') === true,
        shouldCheckForDirectBuyChangeOffering: isProductJiraFree || isSpecialOfferSixtyEnabled,
        shouldCheckForTrial: edition === 'premium' || edition === 'standard',
        cloudId: cloudId,
        productKey: (0, $ecqMk.getHamsKey)(product),
        shouldCheckForChargeQuantities: edition === 'free',
        entitlementFilter: entitlementFilter,
        chargeElement: (0, $8d37867ef9911324$export$58e4e89574623b4)(product),
        shouldCheckForStorageUsageJira: isProductJiraFree,
        applicationKey: (0, $c5924b8ca71db57a$export$2fd6994252e4887f)(product) ?? 'JIRA_SOFTWARE',
        // AccountID is a required value, but the condition will ensure it is not used if undefined/null
        accountId: accountId ?? '',
        shouldCheckForUserEmail: !!accountId && product === 'jira' && edition === 'standard',
        shouldCheckForStorageLimit: isProductJiraFree,
        shouldCheckForPaymentDetails: shouldCheckForPaymentDetails,
        shouldCheckUserPreferences: shouldCheckUserPreferences,
        onboardingStateKeys: onboardingStateKeys,
        shouldCheckForAddPaymentDetails: edition === 'free' && (0, $dh538.fg)('ea_check_txa_add_payment_details_fg')
    };
}


const $a16ccc20b9b7a957$export$2a16c85f3c5d2302 = (traits)=>{
    if (traits.length === 0) return {
        automationUsage: 0,
        lastAutomationFreeLimitBreachDate: null,
        isSiteEligibleToServcoUplift: false
    };
    const automationUsageTrait = traits.find((trait)=>trait.name === 'growth_automation_limits_current_usage');
    const lastAutomationFreeLimitBreachDateTrait = traits.find((trait)=>trait.name === 'growth_automation_limits_usage_latest_breach_date');
    const servcoUpliftTrait = traits.find((trait)=>trait.name === 'is_site_eligible_to_servco_uplift');
    const automationUsage = automationUsageTrait && automationUsageTrait.value !== undefined && !isNaN(Number(automationUsageTrait.value)) ? Number(automationUsageTrait.value) : 0;
    const lastAutomationFreeLimitBreachDate = lastAutomationFreeLimitBreachDateTrait && typeof lastAutomationFreeLimitBreachDateTrait.value === 'string' && !isNaN(Date.parse(lastAutomationFreeLimitBreachDateTrait.value)) ? new Date(lastAutomationFreeLimitBreachDateTrait.value) : null;
    const isSiteEligibleToServcoUplift = Boolean(servcoUpliftTrait && typeof servcoUpliftTrait.value === 'boolean' && servcoUpliftTrait.value);
    return {
        automationUsage: automationUsage,
        lastAutomationFreeLimitBreachDate: lastAutomationFreeLimitBreachDate,
        isSiteEligibleToServcoUplift: isSiteEligibleToServcoUplift
    };
};





function $14e213b8e8fc1cca$var$hasConfluenceUpgradeFreePoolTargetExperimentCohort() {
    // We don't have the AAID of the user, so we need to look through all the local storage keys
    // An example key would be: `localStorage/atlassian.762020:646a2652-9f79-4152-9368-d6e5g1dbf8a3.frontend.atl-UPFTConfluenceStandardOfferCohort`
    for(let i = 0; i < localStorage.length; i++){
        const key = localStorage.key(i);
        if (key && key.startsWith('localStorage/atlassian.') && key.endsWith('.atl-UPFTConfluenceStandardOfferCohort') && localStorage.getItem(key) !== 'not-enrolled') return true;
    }
    return false;
}
function $14e213b8e8fc1cca$export$f31114036914eca1() {
    if (!(0, $dh538.fg)('twcg-206_confluence_upgrade_permanent_free_fg')) return false;
    return $14e213b8e8fc1cca$var$hasConfluenceUpgradeFreePoolTargetExperimentCohort();
}



var $3uYxt = parcelRequire("3uYxt");


/**
 * @generated SignedSource<<b75b92ce536fd9e7fcd698c92577a59d>>
 * @relayHash f3e4eb6cbc15671c025448a6b8f3386a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 097d25120462db2fc5b530f09b21ab8a20b6e4505b7830695f84979384461086
const $c60589317c35a3ba$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "entitlementId"
        }
    ], v1 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Editions",
                    "kind": "LinkedField",
                    "name": "editions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "confluence"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "entitlementId",
                    "variableName": "entitlementId"
                }
            ],
            "concreteType": "GrowthUnifiedProfileEntitlementProfileResult",
            "kind": "LinkedField",
            "name": "growthUnifiedProfile_getEntitlementProfile",
            "plural": false,
            "selections": [
                {
                    "concreteType": "GrowthUnifiedProfileEntitlementContextTrialResult",
                    "kind": "LinkedField",
                    "name": "lastKnownTrial",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "trialEndTimeStamp"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "trialType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "offeringId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "createdAt"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useOnAttemptToUpgradeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useOnAttemptToUpgradeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "097d25120462db2fc5b530f09b21ab8a20b6e4505b7830695f84979384461086",
            "metadata": {},
            "name": "useOnAttemptToUpgradeQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c60589317c35a3ba$var$node.hash = "534e6ffeac5ad7e96470d5b9f9681151";
var $c60589317c35a3ba$export$2e2bcd8739ae039 = $c60589317c35a3ba$var$node;






var $8C5kA = parcelRequire("8C5kA");





var $c6GJD = parcelRequire("c6GJD");


var $cNaCU = parcelRequire("cNaCU");








var $ac7kz = parcelRequire("ac7kz");

function $6d56e3b6b092f01c$export$b8462e385dedb052({ product: product, edition: edition }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return (0, $42omo.useCallback)(({ action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes })=>{
        const event = createAnalyticsEvent({
            eventType: 'ui',
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                ...(0, $ac7kz.defaultAttributes),
                product: product,
                currentProductEdition: edition,
                ...attributes
            }
        });
        const contextAttributes = (0, $ac7kz.getAttributesFromContexts)(event.context);
        event.update({
            attributes: {
                ...contextAttributes,
                ...event.payload.attributes
            }
        }).fire((0, $ac7kz.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        product,
        edition
    ]);
}



var $6m14E = parcelRequire("6m14E");







const $43b34477bd88ddd4$export$da9ab7b2fd5998e8 = 48;
const $43b34477bd88ddd4$var$TIME_BETWEEN_ATTEMPTS_MS = 5000; // 5 seconds
async function $43b34477bd88ddd4$var$getHasJiraUpgraded(product) {
    // TODO: Add the query for GUPs to find out if the customer is on a manual trial
    const response = await fetch('/rest/internal/latest/meta/edition');
    if (!response.ok) throw new Error(`Fetching upgrade status failed with ${response.status}`);
    const data = await response.json();
    const key = (0, $ecqMk.getHamsKey)(product);
    const productHasUpgraded = data[key] === 'standard' || data[key] === 'premium';
    return {
        productHasUpgraded: productHasUpgraded,
        customerHasUpgraded: false
    };
}
const $43b34477bd88ddd4$var$editionMap = {
    STANDARD: 'standard',
    PREMIUM: 'premium'
};
const $43b34477bd88ddd4$var$offeringKeyToEditionMap = {
    '7547cfd6-a804-4e42-8bed-e656d49ea09e': 'free',
    '2eda1119-fab4-4699-ab37-ff8f12052cde': 'standard',
    '06ef245c-5fa3-473b-8822-5e6fe072ae4b': 'premium'
};
async function $43b34477bd88ddd4$var$getConfluenceTrialAndEditionInformation(environment, entitlementId) {
    const response = await (0, $irOoi.fetchQuery)(environment, (0, $c60589317c35a3ba$export$2e2bcd8739ae039), {
        entitlementId: entitlementId
    }).toPromise();
    return {
        confluenceEdition: response?.confluence_tenantContext?.editions?.confluence,
        lastKnownTrial: response?.growthUnifiedProfile_getEntitlementProfile?.lastKnownTrial
    };
}
async function $43b34477bd88ddd4$var$getHasConfluenceUpgraded({ environment: environment, entitlementId: entitlementId }) {
    const { confluenceEdition: confluenceEdition, lastKnownTrial: lastKnownTrial } = await $43b34477bd88ddd4$var$getConfluenceTrialAndEditionInformation(environment, entitlementId);
    const upgradedEdition = confluenceEdition ? $43b34477bd88ddd4$var$editionMap?.[confluenceEdition] : undefined;
    const gupsEdition = lastKnownTrial?.offeringId ? $43b34477bd88ddd4$var$offeringKeyToEditionMap[lastKnownTrial?.offeringId] : undefined;
    const customerHasUpgraded = $43b34477bd88ddd4$var$hasTrialManuallyStarted(lastKnownTrial);
    // Ten minutes ago in milliseconds since epoch
    const tenMinutesAgo = Date.now() - 600000;
    // if GUPS entitlement profile is older than 10 minutes, then return false as we cannot infer that they have upgraded
    if (!lastKnownTrial?.createdAt || lastKnownTrial?.createdAt < tenMinutesAgo) return {
        productHasUpgraded: false,
        customerHasUpgraded: customerHasUpgraded,
        upgradedEdition: upgradedEdition
    };
    return {
        productHasUpgraded: Boolean(upgradedEdition && gupsEdition && upgradedEdition === gupsEdition),
        customerHasUpgraded: customerHasUpgraded,
        upgradedEdition: upgradedEdition
    };
}
function $43b34477bd88ddd4$var$hasTrialManuallyStarted(lastTrialInfo) {
    const trialEndTimeStamp = lastTrialInfo?.trialEndTimeStamp;
    const trialType = lastTrialInfo?.trialType;
    return Boolean(trialEndTimeStamp && trialEndTimeStamp >= Date.now() && trialType === 'MANUAL_TRIAL');
}
async function $43b34477bd88ddd4$var$getHasProductUpgraded({ product: product, environment: environment, entitlementId: entitlementId }) {
    if (product === 'confluence') return $43b34477bd88ddd4$var$getHasConfluenceUpgraded({
        environment: environment,
        entitlementId: entitlementId
    });
    if ((0, $3uYxt.isProductOneOf)(product, [
        'jira',
        'jira-product-discovery',
        'jira-service-management'
    ])) return $43b34477bd88ddd4$var$getHasJiraUpgraded(product);
    throw new Error(`Unsupported product ${product}`);
}
async function $43b34477bd88ddd4$var$linearRetry(fn, sendOperationalEvent) {
    const sendAnalytics = (action, additionalAttributes = {})=>{
        sendOperationalEvent({
            action: action,
            actionSubject: 'pollForUpgrade',
            actionSubjectId: 'editionAwareness',
            attributes: {
                ...additionalAttributes
            }
        });
    };
    const waitForInterval = ()=>new Promise((resolve)=>setTimeout(resolve, $43b34477bd88ddd4$var$TIME_BETWEEN_ATTEMPTS_MS));
    sendAnalytics('started');
    for(let attempts = 0; attempts < $43b34477bd88ddd4$export$da9ab7b2fd5998e8; attempts++)try {
        const result = await fn();
        if (result) {
            sendAnalytics('success', {
                attempt: attempts + 1
            });
            return true;
        }
        if (attempts < $43b34477bd88ddd4$export$da9ab7b2fd5998e8 - 1) await waitForInterval();
    } catch (error) {
        sendAnalytics('error', {
            attempt: attempts + 1,
            error: error instanceof Error ? error.message : 'Unknown error'
        });
        if (attempts < $43b34477bd88ddd4$export$da9ab7b2fd5998e8 - 1) await waitForInterval();
    }
    sendAnalytics('timeout', {
        attempts: $43b34477bd88ddd4$export$da9ab7b2fd5998e8
    });
    return false;
}
function $43b34477bd88ddd4$export$6ce8b9d5e852c5a9({ product: product, edition: edition, isInCollection: isInCollection, showFlag: showFlag, hideFlag: hideFlag, entitlementId: entitlementId, lastKnownTrial: lastKnownTrial }) {
    const sendOperationalEvent = (0, $cNaCU.useOperationalAnalytics)({
        product: product,
        edition: edition
    });
    const sendUIEvent = (0, $6d56e3b6b092f01c$export$b8462e385dedb052)({
        product: product,
        edition: edition
    });
    const intl = (0, $8C5kA.default)();
    const environment = (0, $irOoi.useRelayEnvironment)();
    const showUpgradeInProgressFlag = (0, $42omo.useCallback)(function() {
        if (product !== 'confluence' || isInCollection) // Currently we're only targeting confluence upgrades
        return;
        const cohort = (0, $c6GJD.default).getExperimentValue('manual_trial_w_pde_onboarding', 'cohort', 'not-enrolled');
        sendUIEvent({
            action: 'show',
            actionSubject: 'editionAwarenessUpgradePolling',
            actionSubjectId: 'upgradeInProgressFlag',
            attributes: {
                trackEventGrowthInitiative: 'transmuters'
            }
        });
        if (cohort === 'variation') showFlag?.({
            id: '@atlassian/edition-awareness.upgrade-in-progress-flag',
            title: intl.formatMessage({
                id: "@atlassian/edition-awareness.upgrade-in-progress-flag.title",
                defaultMessage: "Upgrading your plan"
            }),
            description: intl.formatMessage({
                id: "@atlassian/edition-awareness.upgrade-in-progress-flag.description",
                defaultMessage: "This may take a couple of minutes. We'll let you know when it's finished."
            })
        });
    }, [
        product,
        sendUIEvent,
        showFlag,
        intl,
        isInCollection
    ]);
    const showUpgradedFlag = (0, $42omo.useCallback)(function(edition) {
        if (product !== 'confluence' || isInCollection) // Currently we're only targeting confluence upgrades
        return;
        const cohort = (0, $c6GJD.default).getExperimentValue('manual_trial_w_pde_onboarding', 'cohort', 'not-enrolled');
        sendUIEvent({
            action: 'show',
            actionSubject: 'editionAwarenessUpgradePolling',
            actionSubjectId: 'upgradeCompleteFlag',
            attributes: {
                trackEventGrowthInitiative: 'transmuters'
            }
        });
        if (cohort === 'variation') {
            hideFlag?.('@atlassian/edition-awareness.upgrade-in-progress-flag');
            showFlag?.({
                id: '@atlassian/edition-awareness.upgrade-complete-flag',
                title: intl.formatMessage({
                    id: "@atlassian/edition-awareness.upgrade-complete-flag.title",
                    defaultMessage: "Refresh to start using new features"
                }),
                description: intl.formatMessage({
                    id: "@atlassian/edition-awareness.upgrade-complete-flag.description2",
                    defaultMessage: "Your upgrade to {product, select, confluence {Confluence} jira {Jira} jpd {Jira Product Discovery} jsm {Jira Service Management} other {}} {edition, select, standard {Standard} premium {Premium} other {}} is complete."
                }, {
                    edition: edition,
                    product: (0, $6m14E.getProductForTranslation)(product)
                }),
                actions: [
                    {
                        onClick: ()=>{
                            window.location.reload();
                        },
                        content: intl.formatMessage({
                            id: "@atlassian/edition-awareness.upgrade-complete-flag.action",
                            defaultMessage: "Refresh"
                        })
                    }
                ]
            });
        }
    }, [
        product,
        sendUIEvent,
        showFlag,
        hideFlag,
        intl,
        isInCollection
    ]);
    const hasRunOnPageLoad = (0, $42omo.useRef)(false);
    // Five minutes ago in milliseconds since epoch
    const fiveMinutesAgo = Date.now() - 300000;
    const lastKnowTrialCreatedAt = lastKnownTrial?.createdAt || 0;
    const gupsEdition = lastKnownTrial?.offeringId ? $43b34477bd88ddd4$var$offeringKeyToEditionMap[lastKnownTrial?.offeringId] : undefined;
    // check if the FG is on and the edition is different from the edition in GUPS profile and
    // that the GUPS profile was created less than 5 minutes ago and it says that the trial has manually started
    // then we need to poll for the latest edition from TCS
    const shouldCheckOnPageLoad = !isInCollection && gupsEdition && edition !== gupsEdition && lastKnowTrialCreatedAt > fiveMinutesAgo && $43b34477bd88ddd4$var$hasTrialManuallyStarted(lastKnownTrial);
    (0, $42omo.useEffect)(()=>{
        if (shouldCheckOnPageLoad) // check that GUPS is updated
        $43b34477bd88ddd4$var$linearRetry(async ()=>{
            const { productHasUpgraded: productHasUpgraded, upgradedEdition: upgradedEdition } = await $43b34477bd88ddd4$var$getHasProductUpgraded({
                product: product,
                environment: environment,
                entitlementId: entitlementId
            });
            if (productHasUpgraded) showUpgradedFlag(upgradedEdition);
            return productHasUpgraded;
        }, sendOperationalEvent);
        hasRunOnPageLoad.current = true;
    }, [
        hasRunOnPageLoad,
        shouldCheckOnPageLoad,
        entitlementId,
        environment,
        product,
        sendOperationalEvent,
        showUpgradedFlag
    ]);
    const startCheckingForAttemptToUpgrade = (0, $42omo.useCallback)(async ()=>{
        let hasSeenInProgressFlag = false;
        return $43b34477bd88ddd4$var$linearRetry(async ()=>{
            const { productHasUpgraded: productHasUpgraded, customerHasUpgraded: customerHasUpgraded, upgradedEdition: upgradedEdition } = await $43b34477bd88ddd4$var$getHasProductUpgraded({
                product: product,
                environment: environment,
                entitlementId: entitlementId
            });
            if (!productHasUpgraded && customerHasUpgraded && !hasSeenInProgressFlag) {
                // Customer has upgraded, but product does not reflect the change
                hasSeenInProgressFlag = true;
                showUpgradeInProgressFlag();
                return false;
            }
            if (productHasUpgraded) showUpgradedFlag(upgradedEdition);
            return productHasUpgraded;
        }, sendOperationalEvent);
    }, [
        environment,
        product,
        sendOperationalEvent,
        entitlementId,
        showUpgradedFlag,
        showUpgradeInProgressFlag
    ]);
    // At a later stage there will be a useEffect which checks if the customer has started a manual trial but is not on
    // a trial yet (aka in product doesn't reflect the action they performed). This polling will show a flag too
    return {
        startCheckingForAttemptToUpgrade: startCheckingForAttemptToUpgrade
    };
}


















var $59Upg = parcelRequire("59Upg");


var $7cyOE = parcelRequire("7cyOE");


var $4WriN = parcelRequire("4WriN");























var $c6WWz = parcelRequire("c6WWz");


var $fTb0L = parcelRequire("fTb0L");











var $2wRpZ = parcelRequire("2wRpZ");


var $7iPhi = parcelRequire("7iPhi");















var $fVYKU = parcelRequire("fVYKU");


var $go59p = parcelRequire("go59p");

const $7e720d3bf4774c51$export$212eac90358facd0 = {
    touchpointIntent: 'directBuy',
    dialogId: 'automation-free-limit-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $go59p.Edition).STANDARD_EDITION
};



var $aH9Q1 = parcelRequire("aH9Q1");


var $cab2i = parcelRequire("cab2i");


const $10571b361a5a1c15$var$AutomationLimitsEntryPoint = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>(parcelRequire("5dr3h")), {
        moduleId: "fda1ad3d",
        priority: "interaction",
        moduleId: 'edition-awareness-automation-free-limit-modal'
    }),
    getPreloadProps: ()=>({
            entryPoints: {},
            extraProps: {},
            queries: {}
        })
});
var $10571b361a5a1c15$export$2e2bcd8739ae039 = $10571b361a5a1c15$var$AutomationLimitsEntryPoint;


function $0a0495b2b072edca$export$b124b7369c64df7c() {
    const { edition: edition } = (0, $eoBBJ.useEditionAwareness)();
    const DIALOG_CONFIG = (0, $42omo.useMemo)(()=>{
        if (edition === 'free') return 0, $7e720d3bf4774c51$export$212eac90358facd0;
        throw new Error(`Unsupported edition: ${edition}`);
    }, [
        edition
    ]);
    const modalProps = (0, $42omo.useMemo)(()=>({
            width: 968
        }), []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVYKU.ModalEntryPoint), {
        modalProps: modalProps,
        entryPoint: (0, $10571b361a5a1c15$export$2e2bcd8739ae039),
        dialogConfig: DIALOG_CONFIG
    });
}





parcelRequire("42omo");








var $bYRk6 = parcelRequire("bYRk6");


var $gdv5Z = parcelRequire("gdv5Z");


var $9hlns = parcelRequire("9hlns");


var $l83yi = parcelRequire("l83yi");


var $gLwIY = parcelRequire("gLwIY");


var $70Blk = parcelRequire("70Blk");


var $4hFod = parcelRequire("4hFod");


var $aKQ5r = parcelRequire("aKQ5r");

function $8dd6a9e21dfd7f7c$export$e14c42e99b209c4d(props) {
    const { dialogConfig: dialogConfig, ...rest } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gLwIY.DialogContext).Provider, {
        value: dialogConfig,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
            data: dialogConfig,
            children: /*#__PURE__*/ (0, $l998X.jsx)($8dd6a9e21dfd7f7c$export$dece147acb9eddff, {
                ...rest
            })
        })
    });
}
function $8dd6a9e21dfd7f7c$export$dece147acb9eddff(props) {
    const { onClose: onClose, ...rest } = props;
    const onError = (0, $70Blk.useEntrypointErrorAnalytics)();
    const onCloseDialog = (0, $4hFod.useOnCloseDialog)();
    const onClosePopup = (0, $42omo.useCallback)((event, currentLevel)=>{
        onClose?.(event, currentLevel);
        onCloseDialog();
    }, [
        onClose,
        onCloseDialog
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l83yi.PopupTrigger), {
        ...rest,
        shouldFitContainer: false,
        trigger: ({ ref: ref })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $aKQ5r.EditionAwarenessButton), {
                ref: ref
            }),
        fallback: /*#__PURE__*/ (0, $l998X.jsx)($8dd6a9e21dfd7f7c$var$PopupFallback, {}),
        onError: onError,
        onClose: onClosePopup,
        preloadOnFocus: true
    });
}
const $8dd6a9e21dfd7f7c$var$PopupFallback = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        padding: "space.200",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {})
    });


const $fc89475c5301071a$export$d6f7f679ada50a33 = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'collection-add-payment-details-popup',
    dialogType: 'pop-up'
};









const $0fb5d6d28c291c8e$export$6333901e831d7af0 = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>(parcelRequire("3akMv")), {
        moduleId: "732c33d7",
        priority: "interaction",
        moduleId: 'edition-awareness-collection-add-payment-details-popup'
    }),
    getPreloadProps: ()=>({
            entryPoints: {},
            extraProps: {},
            queries: {}
        })
});


const $31122e1275a76a4a$export$7c1c66d41188536 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $8dd6a9e21dfd7f7c$export$e14c42e99b209c4d), {
        entryPoint: (0, $0fb5d6d28c291c8e$export$6333901e831d7af0),
        entryPointProps: {},
        placement: 'bottom-end',
        dialogConfig: (0, $fc89475c5301071a$export$d6f7f679ada50a33)
    });
};















const $64ca64fbd66bcdf8$export$3b6761b6086f6dfd = {
    touchpointIntent: 'changePlan',
    dialogId: 'collection-change-plan-popup',
    dialogType: 'pop-up',
    targetProductEdition: (0, $go59p.Edition).SELECTION
};









var $gGWKv = parcelRequire("gGWKv");


const $99c6698834a34c04$export$6333901e831d7af0 = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>(parcelRequire("5SCVY")), {
        moduleId: "47830478",
        priority: "interaction",
        moduleId: 'edition-awareness-collection-change-plan-popup'
    }),
    getPreloadProps: ({ collectionEntitlementId: collectionEntitlementId })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                collectionChangePlanPopupQuery: {
                    parameters: $gGWKv.default,
                    variables: {
                        collectionEntitlementId: collectionEntitlementId
                    }
                }
            }
        })
});


const $3f83109d42188808$export$a32dee959fd7bd6e = ()=>{
    const { collectionEntitlementId: collectionEntitlementId } = (0, $eoBBJ.useEditionAwareness)();
    const entryPointParams = (0, $42omo.useMemo)(()=>({
            collectionEntitlementId: `ari:cloud:commerce::entitlement/${collectionEntitlementId}`
        }), [
        collectionEntitlementId
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $8dd6a9e21dfd7f7c$export$e14c42e99b209c4d), {
        entryPoint: (0, $99c6698834a34c04$export$6333901e831d7af0),
        entryPointParams: entryPointParams,
        placement: 'bottom-end',
        dialogConfig: (0, $64ca64fbd66bcdf8$export$3b6761b6086f6dfd)
    });
};














const $482f4cee74e2015c$export$3b6761b6086f6dfd = {
    touchpointIntent: 'startTrial',
    dialogId: 'end-user-request-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $go59p.Edition).STANDARD_EDITION
};









var $1nB07 = parcelRequire("1nB07");


const $a8e79962d694252b$export$6333901e831d7af0 = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>(parcelRequire("4xfjs")), {
        moduleId: "6fc056c1",
        priority: "interaction",
        moduleId: 'edition-awareness-end-user-request-modal'
    }),
    getPreloadProps: ()=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                endUserRequestModalQuery: {
                    parameters: $1nB07.default,
                    variables: {},
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        })
});
var $a8e79962d694252b$export$2e2bcd8739ae039 = $a8e79962d694252b$export$6333901e831d7af0;


function $51b877edaf1bd798$export$c9535e299db3229b() {
    const modalProps = (0, $42omo.useMemo)(()=>({
            width: 'x-large'
        }), []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVYKU.ModalEntryPoint), {
        entryPoint: (0, $a8e79962d694252b$export$6333901e831d7af0),
        modalProps: modalProps,
        dialogConfig: (0, $482f4cee74e2015c$export$3b6761b6086f6dfd)
    });
}





















const $51f149fcd3118140$export$3b6761b6086f6dfd = {
    touchpointIntent: 'onboarding',
    dialogId: 'feature-onboarding-modal',
    dialogType: 'modal'
};








/**
 * @generated SignedSource<<0c28e295db48e2ed4c48d24dc8af5bab>>
 * @relayHash fd4cb6f3571e14ffe0aaedf31344d774
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 04b83b613cdd7f5c82d98e9c5ef18e4d689581650254e9b0a7e39ba1cc846859
const $f22c31ad3dc3cf16$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "04b83b613cdd7f5c82d98e9c5ef18e4d689581650254e9b0a7e39ba1cc846859",
        "metadata": {},
        "name": "featureOnboardingModalQuery",
        "operationKind": "query",
        "text": null
    }
};
var $f22c31ad3dc3cf16$export$2e2bcd8739ae039 = $f22c31ad3dc3cf16$var$node;



const $986a47c6a261264f$export$6333901e831d7af0 = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>(parcelRequire("kn5hm")), {
        moduleId: "88239b19",
        priority: "interaction",
        moduleId: 'edition-awareness-feature-onboarding-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                featureOnboardingModalQuery: {
                    parameters: $f22c31ad3dc3cf16$export$2e2bcd8739ae039,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});


function $a03438e29af67a13$export$14fd36acdc725af0() {
    const { cloudId: cloudId, hasDialogAutoOpened: hasDialogAutoOpened, product: product, edition: edition } = (0, $eoBBJ.useEditionAwareness)();
    const modalProps = (0, $42omo.useMemo)(()=>({
            width: 968,
            height: 568
        }), []);
    const shouldAutoOpen = (0, $42omo.useMemo)(()=>!hasDialogAutoOpened('feature-onboarding-modal'), [
        hasDialogAutoOpened
    ]);
    const markDialogAsSeen = (0, $a979d2c30a666dd9$export$64bdfecd0a02bd78)();
    const hasMarked = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (hasMarked.current || !shouldAutoOpen) return;
        markDialogAsSeen('feature-onboarding-modal', product, edition);
        hasMarked.current = true;
    }, [
        shouldAutoOpen,
        markDialogAsSeen,
        product,
        edition
    ]);
    const [isAutoOpened, setIsAutoOpened] = (0, $42omo.useState)(shouldAutoOpen);
    const entryPointProps = (0, $42omo.useMemo)(()=>({
            isAutoOpened: isAutoOpened,
            onClose () {
                setIsAutoOpened(false);
            }
        }), [
        isAutoOpened
    ]);
    const entryPointParams = (0, $42omo.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $ecqMk.getHamsKey)(product)
        }), [
        cloudId,
        product
    ]);
    const analyticsAttributes = (0, $42omo.useMemo)(()=>({
            isAutoOpened: isAutoOpened
        }), [
        isAutoOpened
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
        data: analyticsAttributes,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fVYKU.ModalEntryPoint), {
            entryPoint: (0, $986a47c6a261264f$export$6333901e831d7af0),
            modalProps: modalProps,
            dialogConfig: (0, $51f149fcd3118140$export$3b6761b6086f6dfd),
            entryPointProps: entryPointProps,
            shouldAutoOpen: shouldAutoOpen,
            entryPointParams: entryPointParams
        })
    });
}























const $357afc7b36f8d9e7$export$3b6761b6086f6dfd = {
    touchpointIntent: 'startTrial',
    dialogId: 'free-choose-your-edition-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $go59p.Edition).SELECTION
};









var $ahaQo = parcelRequire("ahaQo");


const $c3e2b23df62c45b3$export$6333901e831d7af0 = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>(parcelRequire("gCo8T")), {
        moduleId: "951dde01",
        priority: "interaction",
        moduleId: 'edition-awareness-free-choose-your-edition-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                freeChooseYourEditionModalQuery: {
                    parameters: $ahaQo.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});


function $d3cc98ed35bb4889$export$e7aac02eddd1c992() {
    const { product: product, cloudId: cloudId, showFlag: showFlag } = (0, $eoBBJ.useEditionAwareness)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const entryPointParams = (0, $42omo.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $ecqMk.getHamsKey)(product)
        }), [
        cloudId,
        product
    ]);
    const modalProps = (0, $42omo.useMemo)(()=>({
            shouldScrollInViewport: true,
            width: 'x-large'
        }), []);
    const handleOnError = (0, $42omo.useCallback)(()=>{
        showFlag?.({
            id: '@atlassian/edition-awareness.dialog.free-choose-your-edition.entrypoint.flag',
            title: formatMessage({
                id: "@atlassian/edition-awareness.dialog.free-choose-your-edition.entrypoint.flag.title",
                defaultMessage: "We weren't able to get your plan details."
            }),
            description: '',
            appearance: 'error',
            actions: [
                {
                    content: formatMessage({
                        id: "@atlassian/edition-awareness.dialog.free-choose-your-edition.entrypoint.flag.action",
                        defaultMessage: "Refresh"
                    }),
                    onClick: ()=>{
                        window.location.reload();
                    }
                }
            ]
        });
    }, [
        showFlag,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVYKU.ModalEntryPoint), {
        entryPoint: (0, $c3e2b23df62c45b3$export$6333901e831d7af0),
        entryPointParams: entryPointParams,
        modalProps: modalProps,
        dialogConfig: (0, $357afc7b36f8d9e7$export$3b6761b6086f6dfd),
        onError: handleOnError
    });
}















// We're explicitly excluding 'confluence' from this mapping as it's handled separately
const $efc308a1615cf7f1$var$PRODUCT_TO_JIRA_PROJECT_TYPE_KEY = {
    ['jira']: 'SOFTWARE',
    ['jira-product-discovery']: 'PRODUCT_DISCOVERY',
    ['jira-service-management']: 'SERVICE_DESK'
};
const $efc308a1615cf7f1$export$600268f282087736 = (product)=>{
    return $efc308a1615cf7f1$var$PRODUCT_TO_JIRA_PROJECT_TYPE_KEY[product];
};











const $fbd6329d0265539e$export$3b6761b6086f6dfd = {
    touchpointIntent: 'startTrial',
    dialogId: 'free-to-standard-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $go59p.Edition).STANDARD_EDITION
};









var $39sTV = parcelRequire("39sTV");


const $2d8e18d13761fb69$export$6333901e831d7af0 = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>(parcelRequire("35Kv0")), {
        moduleId: "afc4323d",
        priority: "interaction",
        moduleId: 'edition-awareness-free-to-standard-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, projectType: projectType, jiraApplicationKey: jiraApplicationKey, isJira: isJira, isConfluence: isConfluence, shouldIncludeGUPS: shouldIncludeGUPS })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                freeToStandardModalQuery: {
                    parameters: $39sTV.default,
                    variables: {
                        cloudId: cloudId,
                        jiraApplicationKey: jiraApplicationKey,
                        projectType: projectType,
                        isJira: isJira,
                        isConfluence: isConfluence,
                        shouldIncludeGUPS: shouldIncludeGUPS
                    }
                }
            }
        })
});


function $73c73f47a4d8c1d7$var$shouldIncludeGUPS(product, cyeaExperimentCohort) {
    if (product !== 'confluence') return false;
    return cyeaExperimentCohort === 'control' || cyeaExperimentCohort === 'variation';
}
function $73c73f47a4d8c1d7$export$61689b501c3b79e6() {
    const { product: product, cloudId: cloudId } = (0, $eoBBJ.useEditionAwareness)();
    const jiraApplicationKey = (0, $c5924b8ca71db57a$export$2fd6994252e4887f)(product);
    const projectType = (0, $efc308a1615cf7f1$export$600268f282087736)(product);
    const { getExperimentValue: getExperimentValue } = (0, $dv2kx.useGetExperimentValue)();
    const cyeaExperimentCohort = getExperimentValue({
        statsigParams: {
            experimentName: 'confluence_free_choose_your_edition_experiment',
            parameterName: 'cohort',
            defaultValue: 'not-enrolled',
            options: {
                fireExperimentExposure: false
            }
        }
    });
    const entryPointParams = (0, $42omo.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $ecqMk.getHamsKey)(product),
            // Fallback to any valid value since this means that we're not using jira
            jiraApplicationKey: jiraApplicationKey ?? 'JIRA_SOFTWARE',
            // Fallback to any valid value since this means that we're not using jira
            projectType: projectType ?? 'SOFTWARE',
            isJira: product === 'jira' || product === 'jira-product-discovery' || product === 'jira-service-management',
            isConfluence: product === 'confluence',
            shouldIncludeGUPS: $73c73f47a4d8c1d7$var$shouldIncludeGUPS(product, cyeaExperimentCohort)
        }), [
        cyeaExperimentCohort,
        cloudId,
        product,
        projectType,
        jiraApplicationKey
    ]);
    const modalProps = (0, $42omo.useMemo)(()=>({
            width: 'x-large'
        }), []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVYKU.ModalEntryPoint), {
        entryPoint: (0, $2d8e18d13761fb69$export$6333901e831d7af0),
        entryPointParams: entryPointParams,
        modalProps: modalProps,
        dialogConfig: (0, $fbd6329d0265539e$export$3b6761b6086f6dfd)
    });
}





parcelRequire("42omo");








const $de75c2eedcc29cbe$export$1a0ae553b5d69abc = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'payment-details-popup',
    dialogType: 'pop-up',
    targetProductEdition: (0, $go59p.Edition).PREMIUM_EDITION
};
const $de75c2eedcc29cbe$export$e42f11d536a45036 = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'payment-details-popup',
    dialogType: 'pop-up',
    targetProductEdition: (0, $go59p.Edition).STANDARD_EDITION
};









const $5d3675f1ff03388c$export$6333901e831d7af0 = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>(parcelRequire("hWLJI")), {
        moduleId: "43cb1037",
        priority: "interaction",
        moduleId: 'edition-awareness-payment-details-popup'
    }),
    getPreloadProps: ()=>({
            entryPoints: {},
            extraProps: {},
            queries: {}
        })
});


function $c0fade8d8df05371$export$7d88b723086482e8() {
    const { edition: edition } = (0, $eoBBJ.useEditionAwareness)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $8dd6a9e21dfd7f7c$export$e14c42e99b209c4d), {
        entryPoint: (0, $5d3675f1ff03388c$export$6333901e831d7af0),
        placement: 'bottom-start',
        dialogConfig: edition === 'standard' ? (0, $de75c2eedcc29cbe$export$e42f11d536a45036) : (0, $de75c2eedcc29cbe$export$1a0ae553b5d69abc)
    });
}























const $b70683da942964a6$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'plan-selection-page-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $go59p.Edition).SELECTION
};









var $iL4pO = parcelRequire("iL4pO");


const $1043fd2d85d87ba5$export$6333901e831d7af0 = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>(parcelRequire("93N5W")), {
        moduleId: "d069ac51",
        priority: "interaction",
        moduleId: 'edition-awareness-plan-selection-page-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                planSelectionPageModalQuery: {
                    parameters: $iL4pO.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});


const $3c5bcfd3bb06cded$var$TWC_MODAL_CONFIG_DEFAULT = {
    width: '1116px',
    height: '790px'
};
const $3c5bcfd3bb06cded$var$REVERSE_TRIAL_MODAL_CONFIG = {
    width: '990px',
    height: '771px'
};
const $3c5bcfd3bb06cded$var$getModalConfig = (type)=>{
    if (type === 'reverse-trial') return $3c5bcfd3bb06cded$var$REVERSE_TRIAL_MODAL_CONFIG;
    return $3c5bcfd3bb06cded$var$TWC_MODAL_CONFIG_DEFAULT;
};
function $3c5bcfd3bb06cded$export$d906ffa5ff65562d({ type: type }) {
    const { cloudId: cloudId, product: product } = (0, $eoBBJ.useEditionAwareness)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { width: width, height: height } = (0, $42omo.useMemo)(()=>$3c5bcfd3bb06cded$var$getModalConfig(type), [
        type
    ]);
    const entryPointParams = (0, $42omo.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $ecqMk.getHamsKey)(product)
        }), [
        cloudId,
        product
    ]);
    const entryPointProps = (0, $42omo.useMemo)(()=>({
            type: type
        }), [
        type
    ]);
    const modalProps = (0, $42omo.useMemo)(()=>({
            width: width,
            height: height,
            shouldScrollInViewport: false,
            shouldCloseOnEscape: true,
            label: formatMessage({
                id: "@atlassian/edition-awareness.dialog.plan-selection-page.title",
                defaultMessage: "Plan selection"
            })
        }), [
        width,
        height,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVYKU.ModalEntryPoint), {
        entryPointProps: entryPointProps,
        entryPoint: (0, $1043fd2d85d87ba5$export$6333901e831d7af0),
        entryPointParams: entryPointParams,
        modalProps: modalProps,
        dialogConfig: (0, $b70683da942964a6$export$3b6761b6086f6dfd)
    });
}














const $65d62b25498252f8$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'premium-add-payment-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $go59p.Edition).PREMIUM_EDITION
};









const $ccf4d7812553d55b$export$6333901e831d7af0 = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>(parcelRequire("bgz33")), {
        moduleId: "f32031a2",
        priority: "interaction",
        moduleId: 'edition-awareness-premium-add-payment-modal'
    }),
    getPreloadProps: ()=>({
            entryPoints: {},
            extraProps: {},
            queries: {}
        })
});


function $7e6c771ba5eab4ee$export$45cd24e1ba5c2588() {
    const modalProps = (0, $42omo.useMemo)(()=>({
            width: 968,
            height: 576
        }), []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVYKU.ModalEntryPoint), {
        entryPoint: (0, $ccf4d7812553d55b$export$6333901e831d7af0),
        modalProps: modalProps,
        dialogConfig: (0, $65d62b25498252f8$export$3b6761b6086f6dfd)
    });
}




























var $lGgRw = parcelRequire("lGgRw");








var $48FEk = parcelRequire("48FEk");













const $7c69bf52ec61c3fd$var$emptyEntryPointParams = {};
const $7c69bf52ec61c3fd$var$emptyEntryPointProps = {};
function $7c69bf52ec61c3fd$export$6189e5bf9171fa04(props) {
    const { dialogConfig: dialogConfig, ...rest } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
        data: dialogConfig,
        children: /*#__PURE__*/ (0, $l998X.jsx)($7c69bf52ec61c3fd$var$AutoOpenPopupTriggerInner, {
            ...rest
        })
    });
}
/**
 * THIS IS A TEMPORARY IMPLEMENTATION, WILL BE REMOVED IN THE FUTURE
 * NOT RECOMMENDED FOR USE ANYWHERE ELSE
 * Supports the auto-open functionality for the Confluence Premium Popup
 */ function $7c69bf52ec61c3fd$var$AutoOpenPopupTriggerInner({ entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorFallback: errorFallback, onClose: onClose, ...popupProps }) {
    const environmentProvider = (0, $gWF6I.useRelayEnvironmentProvider)();
    const onError = (0, $70Blk.useEntrypointErrorAnalytics)();
    const onDismiss = (0, $4hFod.useOnCloseDialog)();
    const id = (0, $42omo.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const [content, setContent] = (0, $42omo.useState)(null);
    const handleOpen = (0, $42omo.useCallback)(()=>{
        setIsOpen(true);
    }, []);
    const handleClose = (0, $42omo.useCallback)((event, currentLevel)=>{
        setIsOpen(false);
        onClose?.(event, currentLevel);
        onDismiss();
    }, [
        onClose,
        onDismiss
    ]);
    const load = (0, $42omo.useCallback)(()=>(0, $irOoi.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $7c69bf52ec61c3fd$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $42omo.useCallback)(({ reference: entryPointReference })=>{
        // avoid re-loading entry-point when closing popup
        if (isOpen) return;
        handleOpen();
        setContent(/*#__PURE__*/ (0, $l998X.jsx)((0, $48FEk.InternalEntryPointContainer), {
            id: id,
            entryPointReference: entryPointReference,
            fallback: /*#__PURE__*/ (0, $l998X.jsx)($7c69bf52ec61c3fd$var$PopupFallback, {}),
            errorFallback: errorFallback,
            runtimeProps: entryPointProps || $7c69bf52ec61c3fd$var$emptyEntryPointProps,
            onError: onError
        }));
    }, [
        setContent,
        id,
        isOpen,
        entryPointProps,
        errorFallback,
        handleOpen,
        onError
    ]);
    const handleToggleAndLoad = (0, $42omo.useCallback)(()=>{
        if (isOpen) {
            handleClose(null);
            return;
        }
        handleOpen();
        onLoad({
            reference: load()
        });
    }, [
        isOpen,
        handleOpen,
        onLoad,
        load,
        handleClose
    ]);
    const popupTrigger = (0, $42omo.useCallback)((triggerProps)=>{
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $aKQ5r.EditionAwarenessButton), {
            ...triggerProps,
            ref: triggerProps.ref,
            onClick: handleToggleAndLoad
        });
    }, [
        handleToggleAndLoad
    ]);
    const popupContent = (0, $42omo.useCallback)(()=>{
        return content;
    }, [
        content
    ]);
    const hasRun = (0, $42omo.useRef)(false);
    // Auto-open on load
    (0, $42omo.useEffect)(()=>{
        if (!hasRun.current) {
            handleToggleAndLoad?.();
            hasRun.current = true;
        }
    }, [
        handleToggleAndLoad
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.Popup), {
        ...popupProps,
        isOpen: isOpen,
        onClose: handleClose,
        trigger: popupTrigger,
        content: popupContent,
        shouldFitContainer: false
    });
}
const $7c69bf52ec61c3fd$var$PopupFallback = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        padding: "space.200",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {})
    });



var $9bIWo = parcelRequire("9bIWo");








var $jyZ9o = parcelRequire("jyZ9o");


const $e4963a278a51a07d$export$6333901e831d7af0 = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>(parcelRequire("8LOgh")), {
        moduleId: "d68a8af6",
        priority: "interaction",
        moduleId: 'edition-awareness-premium-popup'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                confluencePremiumPopupQuery: {
                    parameters: $jyZ9o.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});


const $0c24f422e55347d1$export$831a974b36144ba6 = ()=>{
    const { cloudId: cloudId, product: product, PremiumWrapper: PremiumWrapper, trialDaysLeft: trialDaysLeft, userRoles: userRoles, shouldAutoOpen: shouldAutoOpen, onAutoOpen: onAutoOpen, isInTrial: isInTrial, isInReverseTrial: isInReverseTrial } = (0, $eoBBJ.useEditionAwareness)();
    const [isPremiumModalOpen, setIsPremiumModalOpen] = (0, $42omo.useState)(false);
    const handleClosePremiumModal = (0, $42omo.useCallback)(()=>setIsPremiumModalOpen(false), []);
    const handleOpenPremiumModal = (0, $42omo.useCallback)(()=>setIsPremiumModalOpen(true), []);
    const entryPointParams = (0, $42omo.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $ecqMk.getHamsKey)(product)
        }), [
        product,
        cloudId
    ]);
    const entryPointProps = (0, $42omo.useMemo)(()=>({
            handleOpenPremiumModal: handleOpenPremiumModal,
            onClose: handleClosePremiumModal
        }), [
        handleOpenPremiumModal,
        handleClosePremiumModal
    ]);
    const onClose = (0, $42omo.useCallback)(()=>{
        // This will reset the auto open state from product
        onAutoOpen?.();
    }, [
        onAutoOpen
    ]);
    if (!PremiumWrapper) // Shouldn't happen, but if it does then we can at least still show the customer a dialog
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: shouldAutoOpen ? /*#__PURE__*/ (0, $l998X.jsx)((0, $7c69bf52ec61c3fd$export$6189e5bf9171fa04), {
            entryPoint: (0, $e4963a278a51a07d$export$6333901e831d7af0),
            entryPointParams: entryPointParams,
            entryPointProps: entryPointProps,
            placement: 'bottom-start',
            onClose: onClose,
            dialogConfig: (0, $9bIWo.DIALOG_CONFIG)
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $8dd6a9e21dfd7f7c$export$e14c42e99b209c4d), {
            entryPoint: (0, $e4963a278a51a07d$export$6333901e831d7af0),
            entryPointParams: entryPointParams,
            entryPointProps: entryPointProps,
            placement: 'bottom-start',
            onClose: onClose,
            dialogConfig: (0, $9bIWo.DIALOG_CONFIG)
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: /*#__PURE__*/ (0, $l998X.jsx)(PremiumWrapper, {
            isInTrial: Boolean(isInTrial),
            isInReverseTrial: Boolean(isInReverseTrial),
            trialDaysLeft: trialDaysLeft,
            isSiteAdmin: !!userRoles?.includes('SITE_ADMIN'),
            isPremiumModalOpen: isPremiumModalOpen,
            onClosePremiumModal: handleClosePremiumModal,
            children: shouldAutoOpen ? /*#__PURE__*/ (0, $l998X.jsx)((0, $7c69bf52ec61c3fd$export$6189e5bf9171fa04), {
                entryPoint: (0, $e4963a278a51a07d$export$6333901e831d7af0),
                entryPointParams: entryPointParams,
                entryPointProps: entryPointProps,
                placement: 'bottom-start',
                onClose: onClose,
                dialogConfig: (0, $9bIWo.DIALOG_CONFIG)
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $8dd6a9e21dfd7f7c$export$e14c42e99b209c4d), {
                entryPoint: (0, $e4963a278a51a07d$export$6333901e831d7af0),
                entryPointParams: entryPointParams,
                entryPointProps: entryPointProps,
                placement: 'bottom-start',
                onClose: onClose,
                dialogConfig: (0, $9bIWo.DIALOG_CONFIG)
            })
        })
    });
};


















const $0eca6d0f162e3482$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'reverse-trial-popup',
    dialogType: 'pop-up',
    targetProductEdition: (0, $go59p.Edition).PREMIUM_EDITION
};









var $g73ad = parcelRequire("g73ad");


const $583081f994a2b5ba$export$6333901e831d7af0 = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>(parcelRequire("3LH0H")), {
        moduleId: "38aee5f9",
        priority: "interaction",
        moduleId: 'edition-awareness-reverse-trial-popup'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                reverseTrialPopupQuery: {
                    parameters: $g73ad.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});


function $863892a689726213$export$436172fa0e71e289() {
    const { product: product, cloudId: cloudId } = (0, $eoBBJ.useEditionAwareness)();
    const entryPointParams = (0, $42omo.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $ecqMk.getHamsKey)(product)
        }), [
        cloudId,
        product
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $8dd6a9e21dfd7f7c$export$e14c42e99b209c4d), {
        entryPoint: (0, $583081f994a2b5ba$export$6333901e831d7af0),
        entryPointParams: entryPointParams,
        placement: 'bottom-end',
        dialogConfig: (0, $0eca6d0f162e3482$export$3b6761b6086f6dfd)
    });
}


















const $f8823a7097211119$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'special-offer-sixty-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $go59p.Edition).STANDARD_EDITION
};









var $4ZyWk = parcelRequire("4ZyWk");


const $afbd71079c8c670f$export$6333901e831d7af0 = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>(parcelRequire("a5LT7")), {
        moduleId: "652ea50a",
        priority: "interaction",
        moduleId: 'edition-awareness-special-offer-sixty-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, projectType: projectType })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                specialOfferSixtyModalQuery: {
                    parameters: $4ZyWk.default,
                    variables: {
                        cloudId: cloudId,
                        projectType: projectType
                    }
                }
            }
        })
});


function $27c19f4c19544eda$export$28e8832f80c55136() {
    const { cloudId: cloudId, product: product } = (0, $eoBBJ.useEditionAwareness)();
    const projectType = (0, $efc308a1615cf7f1$export$600268f282087736)(product);
    if (!projectType) throw new Error('Tried to render special offer sixty modal for unsupported product. Product: ' + product);
    const entryPointParams = {
        cloudId: cloudId,
        projectType: projectType
    };
    const modalProps = (0, $42omo.useMemo)(()=>({
            width: 968,
            height: 568
        }), []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVYKU.ModalEntryPoint), {
        modalProps: modalProps,
        entryPoint: (0, $afbd71079c8c670f$export$6333901e831d7af0),
        entryPointParams: entryPointParams,
        dialogConfig: (0, $f8823a7097211119$export$3b6761b6086f6dfd)
    });
}























const $aedbdaaffbf0dd55$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'standard-add-payment-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $go59p.Edition).STANDARD_EDITION
};









var $605Gj = parcelRequire("605Gj");


const $fc31e4e54a2587ba$export$6333901e831d7af0 = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>(parcelRequire("ibGYw")), {
        moduleId: "8a2449b3",
        priority: "interaction",
        moduleId: 'edition-awareness-standard-add-payment-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey, projectType: projectType, chargeElement: chargeElement, jiraApplicationKey: jiraApplicationKey, isJira: isJira, isConfluence: isConfluence })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                standardAddPaymentModalQuery: {
                    parameters: $605Gj.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey,
                        chargeElement: chargeElement,
                        projectType: projectType,
                        jiraApplicationKey: jiraApplicationKey,
                        isJira: isJira,
                        isConfluence: isConfluence
                    }
                }
            }
        })
});


function $ce43f898bc954ad5$export$e7d982549be9547c() {
    const { product: product, cloudId: cloudId } = (0, $eoBBJ.useEditionAwareness)();
    const projectType = (0, $efc308a1615cf7f1$export$600268f282087736)(product);
    const jiraApplicationKey = (0, $c5924b8ca71db57a$export$2fd6994252e4887f)(product);
    const entryPointParams = (0, $42omo.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $ecqMk.getHamsKey)(product),
            chargeElement: (0, $8d37867ef9911324$export$58e4e89574623b4)(product),
            // Fallback to any valid value since this means that we're not using jira
            jiraApplicationKey: jiraApplicationKey ?? 'JIRA_SOFTWARE',
            // Fallback to any valid value since this means that we're not using jira
            projectType: projectType ?? 'SOFTWARE',
            isJira: product === 'jira' || product === 'jira-product-discovery' || product === 'jira-service-management',
            isConfluence: product === 'confluence'
        }), [
        cloudId,
        product,
        projectType,
        jiraApplicationKey
    ]);
    const modalProps = (0, $42omo.useMemo)(()=>{
        if (product === 'confluence') return {
            width: 1000,
            height: 600
        };
        return {
            width: 968,
            height: 576
        };
    }, [
        product
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVYKU.ModalEntryPoint), {
        entryPoint: (0, $fc31e4e54a2587ba$export$6333901e831d7af0),
        entryPointParams: entryPointParams,
        modalProps: modalProps,
        dialogConfig: (0, $aedbdaaffbf0dd55$export$3b6761b6086f6dfd)
    });
}














const $6546b55d47a92972$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'storage-hard-limit-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $go59p.Edition).STANDARD_EDITION
};









const $8f3f36e007414923$var$ModalNameEntryPoint = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>(parcelRequire("h2tsx")), {
        moduleId: "c613c169",
        priority: "interaction",
        moduleId: 'edition-awareness-storage-hard-limit-modal'
    }),
    getPreloadProps: ()=>({
            entryPoints: {},
            extraProps: {},
            queries: {}
        })
});
var $8f3f36e007414923$export$2e2bcd8739ae039 = $8f3f36e007414923$var$ModalNameEntryPoint;


function $b0631d2258114d35$export$d58ea28307440812() {
    const modalProps = (0, $42omo.useMemo)(()=>({
            width: 968
        }), []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVYKU.ModalEntryPoint), {
        modalProps: modalProps,
        entryPoint: (0, $8f3f36e007414923$export$2e2bcd8739ae039),
        dialogConfig: (0, $6546b55d47a92972$export$3b6761b6086f6dfd)
    });
}









var $gtD4K = parcelRequire("gtD4K");


var $3gadb = parcelRequire("3gadb");








var $fcmKV = parcelRequire("fcmKV");




const $cbb036152ac6a041$export$c3039f8cc491a849 = ({ href: href })=>{
    const context = (0, $eoBBJ.useEditionAwareness)();
    const { getExperimentValue: getExperimentValue } = (0, $dv2kx.useGetExperimentValue)();
    const handleAddPaymentClick = (0, $42omo.useCallback)(()=>{
        // Fire exposure for ea_to_osb_experiment control tenants
        if ((0, $fcmKV.isEligibleForEAtoOSBExperiment)(context)) getExperimentValue({
            statsigParams: {
                experimentName: 'ea_to_osb_experiment',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            },
            trackEventParameters: {
                trackEventGrowthInitiative: 'tako'
            }
        });
    }, [
        getExperimentValue,
        context
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            id: "@atlassian/edition-awareness.link.add-payment-tooltip",
            defaultMessage: "Add payment details to keep your subscription"
        }),
        position: "bottom",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aKQ5r.EditionAwarenessLink), {
            href: href,
            target: "_blank",
            touchpointIntent: "addPaymentDetails",
            linkId: "predunning",
            onClick: handleAddPaymentClick
        })
    });
};





















var $dedJV = parcelRequire("dedJV");

function $549572a612636f8b$export$30ac0f723bd6cc08(userEmail, pageUrl) {
    const encodedPageUrl = encodeURIComponent(pageUrl);
    const encodedUserEmail = encodeURIComponent(userEmail);
    // This URL will take them through the login flow (if necessary) then redirect them to the given (encoded) `pageUrl`.
    return `https://${(0, $dedJV.getATLContextDomain)('id')}/login?continue=${encodedPageUrl}&login_hint=${encodedUserEmail}&prompt=none`;
}





const $23b3d5ef00aa521f$export$5e8c8041aa206ba5 = {
    prod: 'https://www.atlassian.com',
    staging: 'https://wac.stg.internal.atlassian.com',
    dev: 'https://wac.stg.internal.atlassian.com',
    local: 'https://wac.stg.internal.atlassian.com'
};






const $799f841994d05a63$export$7e52df418278fb7 = ()=>{
    const context = (0, $eoBBJ.useEditionAwareness)();
    const { cloudId: cloudId, environment: environment, userEmail: userEmail } = context;
    const { getExperimentValue: getExperimentValue } = (0, $dv2kx.useGetExperimentValue)();
    const handleJstoClick = (0, $42omo.useCallback)(()=>{
        // Fire exposure for ea_to_osb_experiment control tenants
        if ((0, $fcmKV.isEligibleForEAtoOSBExperiment)(context)) getExperimentValue({
            statsigParams: {
                experimentName: 'ea_to_osb_experiment',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            },
            trackEventParameters: {
                trackEventGrowthInitiative: 'tako'
            }
        });
    }, [
        getExperimentValue,
        context
    ]);
    // This information should always be available, given the prior checks to get here
    if (!environment || !userEmail) return /*#__PURE__*/ (0, $l998X.jsx)((0, $cf982b95fa3f8fda$export$e2b7efdbe9e8a76b), {});
    const rawJstoUrl = `${(0, $23b3d5ef00aa521f$export$5e8c8041aa206ba5)[environment]}/software/jira?ref=edition_awareness_standard_trial_ccp&cloudSiteId=${cloudId}`;
    const jstoUrl = (0, $549572a612636f8b$export$30ac0f723bd6cc08)(userEmail, rawJstoUrl);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            id: "@atlassian/edition-awareness.link.jira-standard-trial-overview-tooltip",
            defaultMessage: "More about your trial and how to pay"
        }),
        position: "bottom",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aKQ5r.EditionAwarenessLink), {
            href: jstoUrl,
            target: "_blank",
            touchpointIntent: "addPaymentDetails",
            linkId: "jsto",
            onClick: handleJstoClick
        })
    });
};




















const $183d502e46f29dbe$export$aa8ff608e1ef425 = ({ href: href })=>{
    const { getExperimentValue: getExperimentValue } = (0, $dv2kx.useGetExperimentValue)();
    const handlePaymentFlowClick = (0, $42omo.useCallback)(()=>{
        // Fire exposure for ea_to_osb_experiment variant tenants
        getExperimentValue({
            statsigParams: {
                experimentName: 'ea_to_osb_experiment',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            },
            trackEventParameters: {
                trackEventGrowthInitiative: 'tako'
            }
        });
    }, [
        getExperimentValue
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            id: "@atlassian/edition-awareness.link.payment-flow-tooltip",
            defaultMessage: "Add payment details to keep your subscription"
        }),
        position: "bottom",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aKQ5r.EditionAwarenessLink), {
            href: href,
            target: "_blank",
            touchpointIntent: "addPaymentDetails",
            linkId: "payment-flow",
            onClick: handlePaymentFlowClick
        })
    });
};





parcelRequire("42omo");
















const $679fc34a5c032ea0$export$fd348dfc3b9cfcf5 = ()=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $eoBBJ.useEditionAwareness)();
    const adminHubUrl = (0, $dedJV.getATLContextUrl)('admin');
    const href = `${adminHubUrl}/o/${orgId}/atlassian-apps?openServCoUpgradeDrawer=true&defaultSiteId=${cloudId}&redirectedFrom=topNavEAPill`;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            id: "@atlassian/edition-awareness.link.service-collection-tooltip",
            defaultMessage: "Try Service Collection"
        }),
        position: "bottom",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aKQ5r.EditionAwarenessLink), {
            href: href,
            target: "_blank",
            touchpointIntent: "startTrial",
            linkId: "service-collection-uplift"
        })
    });
};


function $cf982b95fa3f8fda$export$e2b7efdbe9e8a76b() {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $ac7kz.useAnalytics)();
    const hasSent = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'operational',
            actionSubject: 'actionsAndContent',
            actionSubjectId: 'editionAwareness',
            action: 'missed'
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent
    ]);
    return null;
}
function $cf982b95fa3f8fda$var$FreeEdition() {
    const context = (0, $eoBBJ.useEditionAwareness)();
    const { product: product, isInCollection: isInCollection, userRoles: userRoles, automationFreeLimitStatus: automationFreeLimitStatus } = context;
    const { getExperimentValue: getExperimentValue } = (0, $dv2kx.useGetExperimentValue)();
    if ((0, $3uYxt.isProductOneOf)(product, [
        'jira',
        'confluence'
    ]) && isInCollection && userRoles?.includes('BILLING_ADMIN')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $3c5bcfd3bb06cded$export$d906ffa5ff65562d), {
        type: "twc"
    });
    // block any EA to be shown if the customer is in teamwork collection
    if (isInCollection && (0, $3uYxt.isProductOneOf)(product, [
        'jira',
        'confluence'
    ])) return null;
    // This new modal is expanding the audience,
    // but not all eligibility checks on the modals below verify all the criteria because they depended on audience-and-timing to filter them out.
    // Not all check that user have permissions to upgrade
    // We will put it at the top to minimize the risk of showing the incorrect modal
    // Example: Choose your Edition, meet partially meets the criteria of this modal and it would be shown if we put it below
    if ((0, $59Upg.isEligibleForConfluenceEndUserRequestExperiment)(context)) {
        // Fire exposure for the main experiment
        const cohort = getExperimentValue({
            statsigParams: {
                experimentName: 'connie_end_user_request_exp',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            },
            trackEventParameters: {
                trackEventGrowthInitiative: 'transmuters'
            }
        });
        if (cohort === 'variation') return /*#__PURE__*/ (0, $l998X.jsx)((0, $51b877edaf1bd798$export$c9535e299db3229b), {});
        // End users shouldn't see anything in control, I don-t let it fallthrough as the other, because other modals partially meet the criteria and may be shown incorrectly
        return null;
    }
    if ((0, $dh538.fg)('twcg-1076_jira_automation_limits_kill_switch')) {
        if (automationFreeLimitStatus) {
            // These two statuses change the button content, and we need to fire exposure
            const fireExperimentExposure = automationFreeLimitStatus === 'BREACHED' || automationFreeLimitStatus === 'PROJECTED_TO_BREACH';
            const cohort = getExperimentValue({
                statsigParams: {
                    experimentName: 'twcg-1076_jira_automation_limits_experiment',
                    parameterName: 'cohort',
                    defaultValue: 'not-enrolled',
                    options: {
                        fireExperimentExposure: fireExperimentExposure
                    }
                },
                trackEventParameters: {
                    trackEventGrowthInitiative: 'luna'
                }
            });
            if (cohort === 'variation') return /*#__PURE__*/ (0, $l998X.jsx)((0, $0a0495b2b072edca$export$b124b7369c64df7c), {});
        }
    }
    if ((0, $7iPhi.isEligibleForStorageHardLimit)(context)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $b0631d2258114d35$export$d58ea28307440812), {});
    if ((0, $dh538.fg)('special_offer_60_days_jira_standard_kill_switch')) {
        if ((0, $2wRpZ.isEligibleForSpecialOfferSixty)(context)) {
            const cohort = getExperimentValue({
                statsigParams: {
                    experimentName: 'special_offer_60_days_jira_standard',
                    parameterName: 'cohort',
                    defaultValue: 'not-enrolled',
                    options: {
                        fireExperimentExposure: false
                    }
                }
            });
            if (cohort === 'variation') return /*#__PURE__*/ (0, $l998X.jsx)((0, $27c19f4c19544eda$export$28e8832f80c55136), {});
        }
    }
    if ((0, $c6WWz.isEligibleForChooseYourEdition)(context)) {
        const cohort = getExperimentValue({
            statsigParams: {
                experimentName: 'confluence_free_choose_your_edition_experiment',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled',
                options: {
                    fireExperimentExposure: false
                }
            }
        });
        if (cohort === 'variation') return /*#__PURE__*/ (0, $l998X.jsx)((0, $d3cc98ed35bb4889$export$e7aac02eddd1c992), {});
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $73c73f47a4d8c1d7$export$61689b501c3b79e6), {});
}
function $cf982b95fa3f8fda$var$StandardEdition() {
    const context = (0, $eoBBJ.useEditionAwareness)();
    const { getExperimentValue: getExperimentValue } = (0, $dv2kx.useGetExperimentValue)();
    const { product: product, isInTrial: isInTrial, isInPredunning: isInPredunning, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails, isInCollection: isInCollection, userRoles: userRoles, addPaymentDetailsExperienceUrl: addPaymentDetailsExperienceUrl, userEmail: userEmail } = context;
    if ((0, $3uYxt.isProductOneOf)(product, [
        'jira',
        'confluence'
    ]) && isInCollection && userRoles?.includes('BILLING_ADMIN')) {
        if (isInTrial) {
            if (invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails) // Teamwork Collection with no PDE in trial
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $3c5bcfd3bb06cded$export$d906ffa5ff65562d), {
                type: "twc"
            });
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $3f83109d42188808$export$a32dee959fd7bd6e), {});
        }
        if (isInPredunning) return /*#__PURE__*/ (0, $l998X.jsx)((0, $31122e1275a76a4a$export$7c1c66d41188536), {});
    }
    // block any EA to be shown if the customer is in teamwork collection
    if (isInCollection && (0, $3uYxt.isProductOneOf)(product, [
        'jira',
        'confluence'
    ])) return null;
    // Service Collection Uplift for JSM Standard
    if ((0, $4WriN.isEligibleForServCoUplift)(context)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $679fc34a5c032ea0$export$fd348dfc3b9cfcf5), {});
    if ((0, $7cyOE.isEligibleForManualFeatureOnboarding)(context) && getExperimentValue({
        statsigParams: {
            experimentName: 'manual_trial_w_pde_onboarding',
            parameterName: 'cohort',
            defaultValue: 'not-enrolled'
        }
    }) === 'variation') return /*#__PURE__*/ (0, $l998X.jsx)((0, $a03438e29af67a13$export$14fd36acdc725af0), {});
    if ((isInTrial || isInPredunning) && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails) {
        if ((0, $dh538.fg)('ea_to_osb_kill_switch')) {
            if ((0, $3uYxt.isProductOneOf)(product, [
                'jira',
                'confluence'
            ]) && addPaymentDetailsExperienceUrl) {
                const osbEACohort = getExperimentValue({
                    statsigParams: {
                        experimentName: 'ea_to_osb_experiment',
                        parameterName: 'cohort',
                        defaultValue: 'not-enrolled',
                        options: {
                            fireExperimentExposure: false
                        }
                    }
                });
                if (osbEACohort === 'variation') return /*#__PURE__*/ (0, $l998X.jsx)((0, $183d502e46f29dbe$export$aa8ff608e1ef425), {
                    href: addPaymentDetailsExperienceUrl
                });
            }
        }
        if (isInTrial && (product === 'jira-service-management' || product === 'jira-product-discovery')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $ce43f898bc954ad5$export$e7d982549be9547c), {});
        // Jira Standard - Site admins get routed to JSTO, others to payment popup
        if (product === 'jira' && isInTrial && userRoles?.includes('SITE_ADMIN') && userEmail) return !(0, $dh538.fg)('ea_to_jsto_kill_switch') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $799f841994d05a63$export$7e52df418278fb7), {}) : /*#__PURE__*/ (0, $l998X.jsx)((0, $c0fade8d8df05371$export$7d88b723086482e8), {});
        // If the site admin doesn't have an email then we fallback to the non site admin experience
        if (product === 'jira' && isInTrial && (!userRoles?.includes('SITE_ADMIN') || !userEmail)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $c0fade8d8df05371$export$7d88b723086482e8), {});
        if (product === 'confluence') return /*#__PURE__*/ (0, $l998X.jsx)((0, $ce43f898bc954ad5$export$e7d982549be9547c), {});
        if (addPaymentDetailsExperienceUrl && isInPredunning && (0, $3uYxt.isProductOneOf)(product, [
            'jira',
            'jira-service-management',
            'jira-product-discovery'
        ])) return /*#__PURE__*/ (0, $l998X.jsx)((0, $cbb036152ac6a041$export$c3039f8cc491a849), {
            href: addPaymentDetailsExperienceUrl
        });
    }
    if ((0, $7cyOE.isEligibleForManualFeatureOnboarding)(context)) // Customers that are eligible (have payment details) would not see any other standard button
    // We're returning early with the ineligible analytics here to not fire the no action event which
    // is used for monitoring
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $37ac4a182bd262c7$export$132e847a0a2f0eca), {});
    return /*#__PURE__*/ (0, $l998X.jsx)($cf982b95fa3f8fda$export$e2b7efdbe9e8a76b, {});
}
function $cf982b95fa3f8fda$var$PremiumEdition() {
    const context = (0, $eoBBJ.useEditionAwareness)();
    const { getExperimentValue: getExperimentValue } = (0, $dv2kx.useGetExperimentValue)();
    const { product: product, isInTrial: isInTrial, isInPredunning: isInPredunning, isInReverseTrial: isInReverseTrial, isInCollection: isInCollection, addPaymentDetailsExperienceUrl: addPaymentDetailsExperienceUrl, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails, userRoles: userRoles } = context;
    // make sure twc is always shown first before jira reverse trial
    // otherwise, jira reverse trial will be shown with collection
    // addition check on invoiceableStatus and canAddPaymentDetails
    // to block any EA to be shown if the customer is in a collection
    // * confluence premium is showing EA regardless which needs to be blocked from collection
    if ((0, $3uYxt.isProductOneOf)(product, [
        'jira',
        'confluence'
    ]) && isInCollection && userRoles?.includes('BILLING_ADMIN')) {
        if (isInTrial) {
            if (invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails) // Teamwork Collection with no PDE in trial
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $3c5bcfd3bb06cded$export$d906ffa5ff65562d), {
                type: "twc"
            });
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $3f83109d42188808$export$a32dee959fd7bd6e), {});
        }
        if (isInPredunning) return /*#__PURE__*/ (0, $l998X.jsx)((0, $31122e1275a76a4a$export$7c1c66d41188536), {});
    }
    // block any EA to be shown if the customer is in a TWC collection
    if (isInCollection && (0, $3uYxt.isProductOneOf)(product, [
        'jira',
        'confluence'
    ])) return null;
    // Service Collection Uplift for JSM Premium
    if ((0, $4WriN.isEligibleForServCoUplift)(context)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $679fc34a5c032ea0$export$fd348dfc3b9cfcf5), {});
    if ((0, $7cyOE.isEligibleForManualFeatureOnboarding)(context) && getExperimentValue({
        statsigParams: {
            experimentName: 'manual_trial_w_pde_onboarding',
            parameterName: 'cohort',
            defaultValue: 'not-enrolled'
        }
    }) === 'variation') return /*#__PURE__*/ (0, $l998X.jsx)((0, $a03438e29af67a13$export$14fd36acdc725af0), {});
    if (product === 'jira' && (isInTrial || isInPredunning) && isInReverseTrial && userRoles?.includes('BILLING_ADMIN') && (0, $dh538.fg)('jira_reverse_trial_ea_updates_during_trial_gate')) {
        const rtCohort = getExperimentValue({
            statsigParams: {
                experimentName: 'jira_reverse_trial_ea_updates_during_trial',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            },
            trackEventParameters: {
                trackEventGrowthInitiative: 'transmuters'
            }
        });
        if (rtCohort === 'variation') return /*#__PURE__*/ (0, $l998X.jsx)((0, $3c5bcfd3bb06cded$export$d906ffa5ff65562d), {
            type: "reverse-trial"
        });
    }
    if (product === 'jira' && isInTrial && isInReverseTrial && addPaymentDetailsExperienceUrl) return /*#__PURE__*/ (0, $l998X.jsx)((0, $863892a689726213$export$436172fa0e71e289), {});
    if (product === 'jira' && isInTrial && !isInReverseTrial && addPaymentDetailsExperienceUrl) return /*#__PURE__*/ (0, $l998X.jsx)((0, $c0fade8d8df05371$export$7d88b723086482e8), {});
    if (isInPredunning && (0, $3uYxt.isProductOneOf)(product, [
        'jira',
        'jira-service-management',
        'jira-product-discovery'
    ]) && addPaymentDetailsExperienceUrl) return /*#__PURE__*/ (0, $l998X.jsx)((0, $cbb036152ac6a041$export$c3039f8cc491a849), {
        href: addPaymentDetailsExperienceUrl
    });
    if ((0, $fTb0L.isEligibleForConfluenceBuyReverseTrialExperiment)(context) && (0, $dh538.fg)('growth_confluence_buy_reverse_trials_fg')) {
        const abCohort = getExperimentValue({
            statsigParams: {
                experimentName: 'growth_confluence_buy_reverse_trials_ab',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            },
            trackEventParameters: {
                trackEventGrowthInitiative: 'luna',
                trackEventAttributes: {
                    touchpointId: 'actions-and-content'
                }
            }
        });
        if (abCohort === 'variation') return /*#__PURE__*/ (0, $l998X.jsx)((0, $3c5bcfd3bb06cded$export$d906ffa5ff65562d), {
            type: "reverse-trial"
        });
    }
    if (product === 'confluence' && (isInTrial || isInPredunning)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $0c24f422e55347d1$export$831a974b36144ba6), {});
    if (isInTrial && (0, $3uYxt.isProductOneOf)(product, [
        'jira-service-management',
        'jira-product-discovery'
    ])) return /*#__PURE__*/ (0, $l998X.jsx)((0, $7e6c771ba5eab4ee$export$45cd24e1ba5c2588), {});
    if ((0, $7cyOE.isEligibleForManualFeatureOnboarding)(context)) // Customers that are eligible (have payment details) would not see any other standard button
    // We're returning early with the ineligible analytics here to not fire the no action event which
    // is used for monitoring
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $37ac4a182bd262c7$export$132e847a0a2f0eca), {});
    return /*#__PURE__*/ (0, $l998X.jsx)($cf982b95fa3f8fda$export$e2b7efdbe9e8a76b, {});
}
function $cf982b95fa3f8fda$export$3bec899b1babe0fe() {
    const { edition: edition } = (0, $eoBBJ.useEditionAwareness)();
    if (edition === 'free') return /*#__PURE__*/ (0, $l998X.jsx)($cf982b95fa3f8fda$var$FreeEdition, {});
    if (edition === 'standard') return /*#__PURE__*/ (0, $l998X.jsx)($cf982b95fa3f8fda$var$StandardEdition, {});
    if (edition === 'premium') return /*#__PURE__*/ (0, $l998X.jsx)($cf982b95fa3f8fda$var$PremiumEdition, {});
    return /*#__PURE__*/ (0, $l998X.jsx)($cf982b95fa3f8fda$export$e2b7efdbe9e8a76b, {});
}


/**
 * One off event which tracks when a customer is eligible/ineligible for edition awareness
 */ function $37ac4a182bd262c7$var$useTrackAudienceAndTiming(isEligible) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $ac7kz.useAnalytics)();
    const hasSent = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'operational',
            actionSubject: 'audienceAndTiming',
            actionSubjectId: 'editionAwareness',
            action: 'checked',
            attributes: {
                isEligible: isEligible
            }
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        isEligible
    ]);
}
/**
 * Tracks when a user should see the edition awareness experience
 */ function $37ac4a182bd262c7$var$Analytics({ children: children }) {
    $37ac4a182bd262c7$var$useTrackAudienceAndTiming(true);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
        children: children
    });
}
function $37ac4a182bd262c7$export$132e847a0a2f0eca() {
    $37ac4a182bd262c7$var$useTrackAudienceAndTiming(false);
    return null;
}
function $37ac4a182bd262c7$export$d288e6ad7a0cf9f8() {
    const context = (0, $eoBBJ.useEditionAwareness)();
    const { product: product, edition: edition, isInTrial: isInTrial, isInPredunning: isInPredunning, isInCollection: isInCollection, isEnterpriseCustomer: isEnterpriseCustomer, canUpgrade: canUpgrade, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails, canDirectBuyUpgrade: canDirectBuyUpgrade } = context;
    const isInTrialOrPredunning = isInTrial || isInPredunning;
    const shouldSeeManualFeatureOnboarding = (0, $7cyOE.isEligibleForManualFeatureOnboarding)(context);
    const shouldSeeButton = (0, $42omo.useMemo)(()=>{
        if (isEnterpriseCustomer) // EA should not be shown to Enterprise customers as per: https://atlassiansupport.atlassian.net/browse/CES-106245
        return false;
        /* Avoid complex logic for collection
		// Collection starts with new stream of logic to see if we should show the button
		// We should avoid products-specific complex logic for collection
		//
		// Collection uses different logic for edition awareness
		// As required by Team EU. EA is shown for Teamwork Collection when user has PDE.
		// */ if (isInCollection) {
            if ((0, $3uYxt.isProductOneOf)(product, [
                'jira',
                'confluence'
            ])) // Teamwork Collection EA is shown to all customers in collection
            // by identifying product is Jira, Confluence or Loon to identify Teamwork Collection
            // This is temporary solution to identify Teamwork Collection
            return true;
        //intentional leave this no default return to avoid block other collection handler
        }
        if (product === 'jira-product-discovery' && (0, $dh538.fg)('jpd_disable_edition_awareness')) return false;
        if (edition === 'free' && (canUpgrade || canDirectBuyUpgrade)) return true;
        if ((0, $59Upg.isEligibleForConfluenceEndUserRequestExperiment)(context)) return true;
        if (edition === 'standard' && isInTrialOrPredunning && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails) return true;
        if (edition === 'premium' && (0, $3uYxt.isProductOneOf)(product, [
            'jira',
            'jira-service-management',
            'jira-product-discovery'
        ]) && isInTrialOrPredunning && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails) return true;
        if (shouldSeeManualFeatureOnboarding) // As part of the manual trial onboarding experiment we are showing the button to customers on manual trial with payment details
        return true;
        if (product === 'confluence' && edition === 'premium' && isInTrialOrPredunning) // Confluence will always show the button for premium while a customer is in a trial or in predunning
        // If the customer can add payment, that is checked as part of rendering the dialog (as the dialog
        // will still show to the customer if they can not add payment details)
        return true;
        if ((0, $4WriN.isEligibleForServCoUplift)(context)) return true;
        return false;
    }, [
        isEnterpriseCustomer,
        isInCollection,
        product,
        edition,
        canUpgrade,
        canDirectBuyUpgrade,
        isInTrialOrPredunning,
        invoiceableStatus,
        canAddPaymentDetails,
        shouldSeeManualFeatureOnboarding,
        context
    ]);
    if (!shouldSeeButton) {
        if (invoiceableStatus === 'INVOICEABLE' && isInTrial) // Like below, we're firing the analytics event, but also including a span to test the VC90 impact
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    "data-testid": "ea-expanded-audience"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)($37ac4a182bd262c7$export$132e847a0a2f0eca, {})
            ]
        });
        if (edition === 'free' || isInTrialOrPredunning) // We're only firing the ineligible analytics when we could've shown the button, not all instances
        // this is to ensure we don't send the event on every page load
        return /*#__PURE__*/ (0, $l998X.jsx)($37ac4a182bd262c7$export$132e847a0a2f0eca, {});
        return null;
    }
    return /*#__PURE__*/ (0, $l998X.jsx)($37ac4a182bd262c7$var$Analytics, {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cf982b95fa3f8fda$export$3bec899b1babe0fe), {})
    });
}



var $04kvJ = parcelRequire("04kvJ");


var $hT0Mj = parcelRequire("hT0Mj");

/**
 * Edition awareness is used to communicate to customers about the current edition they have and if they should
 * - Add payment details
 * - Upgrade their edition
 *
 * This component deals with creating the context which is then used throughout the package to:
 * - Track analytics
 * - Know which product/edition/cloud id is being used
 * - Know when to show/hide the button
 */ function $576330e59c9c12a5$var$EditionAwarenessImpl(props) {
    const { cloudId: cloudId, product: product, edition: edition, orgId: orgId, accountId: accountId, userDisplayName: userDisplayName, userRoles: userRolesFromProduct, environment: environment, siteTraits: siteTraits = [], canRender: canRender, isInReverseTrial: isInReverseTrialFromProduct, onOpenOnboardingMenu: onOpenOnboardingMenu, premiumFeatureHighlightToggle: premiumFeatureHighlightToggle, shouldAutoOpen: shouldAutoOpen, onAutoOpen: onAutoOpen, PremiumWrapper: PremiumWrapper, getAction: getAction, showFlag: showFlag, hideFlag: hideFlag } = props;
    const queryConfig = (0, $41131f5950265612$export$bac5bb66ae1b635d)(product, edition, cloudId, accountId, userRolesFromProduct);
    const data = (0, $irOoi.useLazyLoadQuery)((0, $6e87170c9009b0c9$export$2e2bcd8739ae039), queryConfig);
    const entitlementInfo = data?.tenantContexts?.[0]?.entitlementInfo;
    const entitlement = entitlementInfo?.entitlement;
    const entitlementId = entitlementInfo?.entitlementId;
    const invoiceableStatus = typeof entitlement?.subscription?.accountDetails?.invoiceGroup?.invoiceable === 'boolean' ? entitlement.subscription.accountDetails.invoiceGroup.invoiceable ? 'INVOICEABLE' : 'NOT_INVOICEABLE' : 'UNKNOWN';
    const invoiceGroupPaymentConfig = entitlement?.subscription?.accountDetails?.invoiceGroup?.experienceCapabilities?.configurePaymentV2;
    const canAddInvoiceGroupPayment = invoiceGroupPaymentConfig ? Boolean(invoiceGroupPaymentConfig.isAvailableToUser && invoiceGroupPaymentConfig.experienceUrl) : null;
    const transactionAccountPaymentConfig = entitlement?.transactionAccount?.experienceCapabilities?.addPaymentMethodV2;
    const canAddTxaPayment = transactionAccountPaymentConfig ? Boolean(transactionAccountPaymentConfig.isAvailableToUser && transactionAccountPaymentConfig.experienceUrl) : null;
    // Use invoice group configurePaymentV2 to determine can add payment and experience url by default
    // If invoice group does not exist (for example free edition skip trial scenario), fall back to txa addPaymentMethodV2 if possible
    const canAddPaymentDetails = (0, $dh538.fg)('ea_check_txa_add_payment_details_fg') ? canAddInvoiceGroupPayment ?? canAddTxaPayment : canAddInvoiceGroupPayment ?? false;
    const addPaymentDetailsExperienceUrl = (()=>{
        if ((0, $dh538.fg)('ea_check_txa_add_payment_details_fg')) {
            if (invoiceGroupPaymentConfig) return invoiceGroupPaymentConfig.experienceUrl;
            else if (edition === 'free') return transactionAccountPaymentConfig?.experienceUrl;
            else return null;
        }
        return invoiceGroupPaymentConfig?.experienceUrl;
    })();
    const hasPaymentDetailsEntered = Boolean(entitlement?.transactionAccount?.isBillToPresent);
    const trialTimeLeft = entitlement?.subscription?.trial?.timeLeft ?? undefined;
    const trialDaysLeft = (0, $1o4fX.getTrialDaysLeft)(trialTimeLeft);
    const trialStartTimestamp = entitlement?.subscription?.trial?.startTimestamp;
    const trialStartDate = (0, $42omo.useMemo)(()=>trialStartTimestamp ? new Date(trialStartTimestamp) : undefined, [
        trialStartTimestamp
    ]);
    const trialEndTimestamp = entitlement?.subscription?.trial?.endTimestamp;
    const trialEndDate = (0, $42omo.useMemo)(()=>trialEndTimestamp ? new Date(trialEndTimestamp) : undefined, [
        trialEndTimestamp
    ]);
    const trialLengthDays = entitlement?.offering?.trial?.lengthDays ?? undefined;
    const isInTrial = Boolean(trialDaysLeft && trialDaysLeft > 0);
    const isEntitlementPredunningStatus = entitlement?.preDunning?.status;
    const isCollectionEntitlementPredunningStatus = entitlement?.relatesFromEntitlementsWithCollectionType?.[0]?.entitlement?.preDunning?.status;
    const isInPredunning = (isEntitlementPredunningStatus === 'IN_PRE_DUNNING' || isCollectionEntitlementPredunningStatus === 'IN_PRE_DUNNING') && invoiceableStatus === 'NOT_INVOICEABLE';
    const isInReverseTrial = (isInTrial || isInPredunning) && (isInReverseTrialFromProduct !== undefined ? isInReverseTrialFromProduct : false);
    const { isInCollection: isInCollection, collectionEntitlementId: collectionEntitlementId } = (0, $42omo.useMemo)(()=>{
        const collectionEntitlement = entitlement?.relatesFromEntitlements?.find((item)=>item?.relationshipType === 'COLLECTION');
        return {
            isInCollection: !!collectionEntitlement?.entitlementId,
            collectionEntitlementId: collectionEntitlement?.entitlementId
        };
    }, [
        entitlement?.relatesFromEntitlements
    ]);
    const isChangeOfferingAvailable = entitlement?.experienceCapabilities?.changeOfferingV2?.isAvailableToUser;
    const changeOfferingToStandardExperienceUrl = entitlement?.experienceCapabilities?.changeOfferingV2?.experienceUrl;
    const isDirectBuyChangeOfferingAvailable = entitlement?.experienceCapabilities?.changeOfferingV2WithSkipTrial?.isAvailableToUser;
    const directBuyChangeOfferingToStandardExperienceUrl = entitlement?.experienceCapabilities?.changeOfferingV2WithSkipTrial?.experienceUrl;
    const canUpgrade = Boolean(isChangeOfferingAvailable && changeOfferingToStandardExperienceUrl);
    const canDirectBuyUpgrade = Boolean(isDirectBuyChangeOfferingAvailable && directBuyChangeOfferingToStandardExperienceUrl);
    const transactionAccountId = entitlement?.transactionAccount?.key;
    const isEnterpriseCustomer = (0, $42omo.useMemo)(()=>{
        const enterpriseEntitlement = entitlement?.relatesFromEntitlements?.find((item)=>item?.relationshipType === 'ENTERPRISE');
        return !!enterpriseEntitlement?.entitlementId;
    }, [
        entitlement?.relatesFromEntitlements
    ]);
    const productCollection = (0, $4b00699181955ef3$export$6cf5f13af3dcd5bf)(product);
    const collectionType = isInCollection && productCollection?.isEnabled && productCollection?.collectionType || null;
    const userRoles = (0, $42omo.useMemo)(()=>{
        const roles = [
            ...userRolesFromProduct || []
        ];
        if (data?.tenantContexts?.[0]?.entitlementInfo?.entitlement?.transactionAccount?.isCurrentUserBillingAdmin) roles.push('BILLING_ADMIN');
        return roles;
    }, [
        data?.tenantContexts,
        userRolesFromProduct
    ]);
    const userEmail = data?.user?.email;
    // We need to use the `latestUsageForChargeElement` to get the licensed user count for both free and trialing customers
    const licensedUsersRaw = entitlement?.latestUsageForChargeElement;
    // Assumes that there are always at least one assigned user to cover scenarios
    const licensedUsers = Math.max(licensedUsersRaw || 0, 1);
    const storageUsageInGB = (0, $42omo.useMemo)(()=>{
        if (data.jira?.attachmentStorageUsed && (0, $3uYxt.isProductOneOf)(product, [
            'jira',
            'jira-service-management',
            'jira-product-discovery'
        ])) return (0, $9CFT2.bytesToGigabytes)(data.jira.attachmentStorageUsed);
        return undefined;
    }, [
        data.jira?.attachmentStorageUsed,
        product
    ]);
    const storageLimitInGB = (0, $42omo.useMemo)(()=>{
        if (data.jira?.attachmentStorageAllowed) return (0, $9CFT2.bytesToGigabytes)(data.jira.attachmentStorageAllowed);
        return undefined;
    }, [
        data.jira?.attachmentStorageAllowed
    ]);
    const storageIsUnlimited = (0, $42omo.useMemo)(()=>{
        if (data.jira?.attachmentStorageIsUnlimited) return data.jira.attachmentStorageIsUnlimited;
        return undefined;
    }, [
        data.jira?.attachmentStorageIsUnlimited
    ]);
    const siteTraitsForContext = (0, $42omo.useMemo)(()=>(0, $a16ccc20b9b7a957$export$2a16c85f3c5d2302)(siteTraits), [
        siteTraits
    ]);
    const offeringKey = entitlement?.offering?.key;
    const automationFreeLimitStatus = (0, $42omo.useMemo)(()=>(0, $dh538.fg)('twcg-1076_jira_automation_limits_kill_switch') ? (0, $fgLLK.getAutomationFreeLimitStatus)({
            product: product,
            edition: edition,
            isInTrial: isInTrial,
            ...siteTraitsForContext
        }) : null, [
        product,
        edition,
        isInTrial,
        siteTraitsForContext
    ]);
    const lastKnownTrial = (0, $42omo.useMemo)(()=>{
        // We purposely don't discard the results of the trial if the customer is not on a trial, the reason for this
        // is to enable experiences where the customer has just started a trial, but that change is not yet reflected
        // on the page that has loaded for them.
        const trialEndTimeStamp = entitlement?.entitlementProfile?.lastKnownTrial?.trialEndTimeStamp;
        if (!trialEndTimeStamp || trialEndTimeStamp <= Date.now()) // Discard the result as it's in the past and we should assume outdated
        return undefined;
        return {
            trialEndTimeStamp: entitlement?.entitlementProfile?.lastKnownTrial?.trialEndTimeStamp,
            trialType: entitlement?.entitlementProfile?.lastKnownTrial?.trialType,
            trialTrigger: entitlement?.entitlementProfile?.lastKnownTrial?.trialTrigger,
            createdAt: entitlement?.entitlementProfile?.lastKnownTrial?.createdAt,
            offeringId: entitlement?.entitlementProfile?.lastKnownTrial?.offeringId
        };
    }, [
        entitlement?.entitlementProfile?.lastKnownTrial
    ]);
    const isEnrolledInUpgradeFreePoolTargetExperiment = (0, $42omo.useMemo)(()=>{
        if (product !== 'confluence' || edition !== 'standard' || // technically a tenant is enrolled if they are on 'free', but once they upgrade to standard we want to continue showing them the experience as there is a 'post-upgrade' UX
        isInTrial === false || invoiceableStatus !== 'INVOICEABLE' || !userRoles?.includes('SITE_ADMIN') || lastKnownTrial?.trialType !== 'MANUAL_TRIAL') return false;
        return (0, $14e213b8e8fc1cca$export$f31114036914eca1)();
    }, [
        product,
        edition,
        isInTrial,
        invoiceableStatus,
        lastKnownTrial,
        userRoles
    ]);
    const { startCheckingForAttemptToUpgrade: startCheckingForAttemptToUpgrade } = (0, $43b34477bd88ddd4$export$6ce8b9d5e852c5a9)({
        product: product,
        edition: edition,
        showFlag: showFlag,
        // Fallback should never happen as we shouldn't call startCheckingForAttemptToUpgrade
        // when there is no entitlement
        entitlementId: entitlement?.id ?? 'entitlement-id',
        lastKnownTrial: lastKnownTrial,
        isInCollection: isInCollection
    });
    const hasDialogAutoOpened = (0, $42omo.useCallback)((dialogId)=>{
        if (dialogId === 'feature-onboarding-modal') {
            const state = data?.userPreferences?.onboardingState?.find((s)=>s.key === (0, $a979d2c30a666dd9$export$423571b0238e9b3e)(dialogId, product, edition));
            if (state?.value === 'true') return true;
            return localStorage.getItem((0, $a979d2c30a666dd9$export$423571b0238e9b3e)(dialogId, product, edition)) === 'true';
        }
        return true;
    }, [
        data,
        product,
        edition
    ]);
    const context = (0, $42omo.useMemo)(()=>{
        return {
            cloudId: cloudId,
            orgId: orgId,
            product: product,
            edition: edition,
            entitlementId: entitlementId,
            invoiceableStatus: invoiceableStatus,
            canAddPaymentDetails: canAddPaymentDetails,
            hasPaymentDetailsEntered: hasPaymentDetailsEntered,
            addPaymentDetailsExperienceUrl: addPaymentDetailsExperienceUrl,
            offeringKey: offeringKey,
            trialDaysLeft: trialDaysLeft,
            trialLengthDays: trialLengthDays,
            trialStartDate: trialStartDate,
            trialEndDate: trialEndDate,
            isInTrial: isInTrial,
            isInPredunning: isInPredunning,
            isInReverseTrial: isInReverseTrial,
            canUpgrade: canUpgrade,
            canDirectBuyUpgrade: canDirectBuyUpgrade,
            changeOfferingToStandardExperienceUrl: changeOfferingToStandardExperienceUrl,
            directBuyChangeOfferingToStandardExperienceUrl: directBuyChangeOfferingToStandardExperienceUrl,
            transactionAccountId: transactionAccountId,
            isInCollection: isInCollection,
            isEnterpriseCustomer: isEnterpriseCustomer,
            collectionEntitlementId: collectionEntitlementId,
            collectionType: collectionType,
            userId: accountId,
            userDisplayName: userDisplayName,
            userRoles: userRoles,
            userEmail: userEmail,
            environment: environment,
            licensedUsers: licensedUsers,
            storageUsageInGB: storageUsageInGB,
            storageLimitInGB: storageLimitInGB,
            storageIsUnlimited: storageIsUnlimited,
            ...siteTraitsForContext,
            automationFreeLimitStatus: automationFreeLimitStatus,
            onOpenOnboardingMenu: onOpenOnboardingMenu,
            premiumFeatureHighlightToggle: premiumFeatureHighlightToggle,
            shouldAutoOpen: shouldAutoOpen,
            onAutoOpen: onAutoOpen,
            PremiumWrapper: PremiumWrapper,
            startCheckingForAttemptToUpgrade: startCheckingForAttemptToUpgrade,
            lastKnownTrial: lastKnownTrial,
            getAction: getAction,
            showFlag: showFlag,
            hideFlag: hideFlag,
            hasDialogAutoOpened: hasDialogAutoOpened,
            isEnrolledInUpgradeFreePoolTargetExperiment: isEnrolledInUpgradeFreePoolTargetExperiment
        };
    }, [
        cloudId,
        orgId,
        product,
        edition,
        entitlementId,
        invoiceableStatus,
        canAddPaymentDetails,
        hasPaymentDetailsEntered,
        addPaymentDetailsExperienceUrl,
        offeringKey,
        trialDaysLeft,
        trialLengthDays,
        trialStartDate,
        trialEndDate,
        isInTrial,
        isInPredunning,
        isInReverseTrial,
        canUpgrade,
        canDirectBuyUpgrade,
        changeOfferingToStandardExperienceUrl,
        directBuyChangeOfferingToStandardExperienceUrl,
        transactionAccountId,
        isInCollection,
        isEnterpriseCustomer,
        collectionEntitlementId,
        collectionType,
        accountId,
        userDisplayName,
        userRoles,
        userEmail,
        environment,
        licensedUsers,
        storageUsageInGB,
        storageLimitInGB,
        storageIsUnlimited,
        siteTraitsForContext,
        automationFreeLimitStatus,
        onOpenOnboardingMenu,
        premiumFeatureHighlightToggle,
        shouldAutoOpen,
        onAutoOpen,
        PremiumWrapper,
        startCheckingForAttemptToUpgrade,
        lastKnownTrial,
        getAction,
        showFlag,
        hideFlag,
        hasDialogAutoOpened,
        isEnrolledInUpgradeFreePoolTargetExperiment
    ]);
    const experimentContextValue = (0, $42omo.useMemo)(()=>new (0, $dv2kx.ExperimentContextClass)(), []);
    if (!canRender) return /*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
        name: "edition-awareness-waiting-on-product"
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dv2kx.ExperimentContext).Provider, {
        value: experimentContextValue,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eoBBJ.EditionAwarenessContext).Provider, {
            value: context,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $04kvJ.ErrorBoundary), {
                product: product,
                edition: edition,
                id: "audience-and-timing",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hT0Mj.Spotlights), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $37ac4a182bd262c7$export$d288e6ad7a0cf9f8), {})
                })
            })
        })
    });
}
function $576330e59c9c12a5$export$a55b02efe3d62583(props) {
    const { product: product, edition: edition } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
        name: "edition-awareness-platform",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $04kvJ.ErrorBoundary), {
            product: product,
            edition: edition,
            id: "edition-awareness",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $l998X.jsx)($576330e59c9c12a5$var$EditionAwarenessImpl, {
                    ...props
                })
            })
        })
    });
}


function $ca2cfb97a8e29468$export$c46712e77943b100(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gWF6I.RelayEnvironmentProvider), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $576330e59c9c12a5$export$a55b02efe3d62583), {
            ...props
        })
    });
}



var $1ytiN = parcelRequire("1ytiN");


var $9wGTI = parcelRequire("9wGTI");


var $hl0fg = parcelRequire("hl0fg");


var $7aRa9 = parcelRequire("7aRa9");


var $bQm3c = parcelRequire("bQm3c");


var $e4o8D = parcelRequire("e4o8D");


var $d9tcB = parcelRequire("d9tcB");


var $hY10E = parcelRequire("hY10E");


var $57I23 = parcelRequire("57I23");


var $jmjWc = parcelRequire("jmjWc");


const $d348f00c56224e2e$export$9d05b4c1ccafbb15 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "Ebpq6",
    name: "PremiumTrialOnboardingSpotlight",
    loader: async ()=>(await (parcelRequire("2708F"))).PremiumTrialOnboardingSpotlight
});








var $jupik = parcelRequire("jupik");


const $b8ba1324d97f13ae$export$936374c058c289fa = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "xIodC",
    name: "PremiumTrialOnboardingModal",
    loader: async ()=>(await Promise.resolve((parcelRequire("jupik")))).PremiumTrialOnboardingModal
});



var $bqyIi = parcelRequire("bqyIi");


var $hqD0X = parcelRequire("hqD0X");


var $eXOow = parcelRequire("eXOow");

var $IdK2A = parcelRequire("IdK2A");




var $5QjrO = parcelRequire("5QjrO");




var $8yYKd = parcelRequire("8yYKd");


var $grWYF = parcelRequire("grWYF");


var $2XqLN = parcelRequire("2XqLN");


var $f7B1p = parcelRequire("f7B1p");

const $3a95c39060b2f8ec$var$fetchPersonalizationSiteUserTraits = async (cloudId)=>{
    const response = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`);
    return response.json();
};
const $3a95c39060b2f8ec$var$callSiteTraits = async (cloudId)=>{
    if (!cloudId) return [];
    const siteUserTraitsData = await $3a95c39060b2f8ec$var$fetchPersonalizationSiteUserTraits(cloudId);
    if (!siteUserTraitsData || !siteUserTraitsData.attributes) return [];
    return siteUserTraitsData.attributes;
};
const $3a95c39060b2f8ec$export$847d02aadbf9f5f8 = (0, $2XqLN.default)($3a95c39060b2f8ec$var$callSiteTraits);






var $ep3mz = parcelRequire("ep3mz");


var $cLo2u = parcelRequire("cLo2u");


var $bZSO8 = parcelRequire("bZSO8");







function $335f03b73910ade3$var$useGetAutomationAction() {
    return (0, $42omo.useCallback)(async ()=>{
        return {
            id: 'automation',
            type: 'link',
            href: `/wiki/admin/automation#/tab/rule-library`
        };
    }, []);
}
function $335f03b73910ade3$var$usePagePermissionsAction(showPagePermissionsSpotlight) {
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    return (0, $42omo.useCallback)(async ()=>{
        if (!contentId || !spaceKey || !contentType) return {
            id: 'page-permissions',
            type: 'link',
            href: `/wiki/create-content/page?journeyId=onboarding-page-permissions`
        };
        return {
            id: 'page-permissions',
            type: 'fn',
            fn: showPagePermissionsSpotlight
        };
    }, [
        contentId,
        contentType,
        spaceKey,
        showPagePermissionsSpotlight
    ]);
}
function $335f03b73910ade3$var$useGetGuestAccessAction() {
    return (0, $42omo.useCallback)(async ()=>{
        return {
            id: 'guest-access',
            type: 'link',
            href: '/wiki/admin/permissions/global?tab=external'
        };
    }, []);
}
function $335f03b73910ade3$var$useGetWhiteboardsAction() {
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    return (0, $42omo.useCallback)(async ()=>{
        const href = (0, $bZSO8.buildCreationLink)({
            contentType: 'whiteboard',
            source: 'editionAwarenessActions',
            spaceKey: spaceKey ?? undefined,
            openTemplatePicker: true
        });
        return {
            id: 'whiteboards',
            type: 'link',
            href: href
        };
    }, [
        spaceKey
    ]);
}
function $335f03b73910ade3$var$useGetMissionControlAction() {
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    return (0, $42omo.useCallback)(async ()=>{
        if (edition !== (0, $d9tcB.ConfluenceEdition).PREMIUM) // Mission control is a premium only feature
        return null;
        return {
            id: 'mission-control',
            type: 'link',
            href: '/wiki/admin/center'
        };
    }, [
        edition
    ]);
}
function $335f03b73910ade3$export$bc923229a7fa61e7({ showPagePermissionsSpotlight: showPagePermissionsSpotlight }) {
    const getAutomationAction = $335f03b73910ade3$var$useGetAutomationAction();
    const getGuestAccessAction = $335f03b73910ade3$var$useGetGuestAccessAction();
    const getWhiteboardsAction = $335f03b73910ade3$var$useGetWhiteboardsAction();
    const getPagePermissionsAction = $335f03b73910ade3$var$usePagePermissionsAction(showPagePermissionsSpotlight);
    const getMissionControlAction = $335f03b73910ade3$var$useGetMissionControlAction();
    return (0, $42omo.useCallback)(async (actionId)=>{
        switch(actionId){
            case 'automation':
                return getAutomationAction();
            case 'guest-access':
                return getGuestAccessAction();
            case 'page-permissions':
                return getPagePermissionsAction();
            case 'whiteboards':
                return getWhiteboardsAction();
            case 'mission-control':
                return getMissionControlAction();
            default:
                return null;
        }
    }, [
        getAutomationAction,
        getGuestAccessAction,
        getMissionControlAction,
        getPagePermissionsAction,
        getWhiteboardsAction
    ]);
}


const $368a95c4eb3585b7$var$editionMap = {
    [(0, $d9tcB.ConfluenceEdition).FREE]: 'free',
    [(0, $d9tcB.ConfluenceEdition).STANDARD]: 'standard',
    [(0, $d9tcB.ConfluenceEdition).PREMIUM]: 'premium'
};
function $368a95c4eb3585b7$export$eb753ea923b564db({ children: children, isInTrial: isInTrial, isInReverseTrial: isInReverseTrial, trialDaysLeft: trialDaysLeft, isPremiumModalOpen: isPremiumModalOpen, onClosePremiumModal: onClosePremiumModal, isSiteAdmin: isSiteAdmin }) {
    const { setIsOpen: setIsOpen } = (0, $8yYKd.useOpenActionMenuActions)();
    // PopoverProvider requires client-side DOM measurements for proper positioning, e.g. getBoundingClientRect()
    // During SSR, positioning calculations fail and cause errors
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const [{ isSpotlightCheckEnabled: isSpotlightCheckEnabled }, { enableSpotlightCheck: enableSpotlightCheck }] = (0, $IdK2A.useShouldCheckEligibilityForSpotlight)();
    (0, $42omo.useEffect)(()=>{
        async function ptoPhaseTwoSpotlightCheck() {
            if (isSpotlightCheckEnabled === false && (0, $eXOow.getIsPremiumOnboardingHappened)() && isInTrial) await enableSpotlightCheck();
        }
        ptoPhaseTwoSpotlightCheck();
    }, [
        isSpotlightCheckEnabled,
        enableSpotlightCheck,
        isInTrial
    ]);
    /**
   * Renders the new @atlaskit/spotlight implementation (PopoverProvider/PopoverTarget).
   * Only renders the spotlight when in trial and not in reverse trial.
   * See ticket ENGHEALTH-46607 for migration details.
   */ const renderNewSpotlight = ()=>{
        if (isInTrial && !isInReverseTrial) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d348f00c56224e2e$export$9d05b4c1ccafbb15), {
            daysLeft: trialDaysLeft,
            isSiteAdmin: isSiteAdmin,
            renderServerPlaceholder: renderServerPlaceholder
        }));
        return children;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isPremiumModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b8ba1324d97f13ae$export$936374c058c289fa), {
        onClose: onClosePremiumModal,
        triggerFrom: (0, $jupik.TriggerFrom).PILL,
        daysLeft: trialDaysLeft
    }), (0, $9wGTI.fg)('cc-engagement-migrate-premium-trial-spotlight') ? renderNewSpotlight() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqyIi.BorderNudge), {
        target: (0, $hqD0X.HOVER_TARGET).PREMIUM_TRIAL,
        customStyles: {
            width: '100%',
            borderRadius: "var(--ds-radius-large, 8px)"
        }
    }, isInTrial && !isInReverseTrial ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: (0, $eXOow.PTO_PHASE_TWO_SPOTLIGHT_TARGET)
    }, children) : children), isInTrial && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d348f00c56224e2e$export$9d05b4c1ccafbb15), {
        daysLeft: trialDaysLeft,
        isSiteAdmin: isSiteAdmin
    })), (0, $9wGTI.fg)('d0_confluence_auto_provisioning_onboarding_upgrade') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5QjrO.ConfluenceTrialSpotlight), {
        onClose: ()=>setIsOpen(true)
    }));
}
const $368a95c4eb3585b7$var$EditionAwarenessFlagSupport = ({ flags: flags, ...props })=>{
    const showFlag = (0, $42omo.useCallback)((flag)=>flags.showFlag(flag), [
        flags
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ca2cfb97a8e29468$export$c46712e77943b100), {
        ...props,
        showFlag: showFlag,
        hideFlag: flags.hideFlag
    });
};
const $368a95c4eb3585b7$var$EditionAwarenessWithFlags = (0, $7aRa9.withFlags)($368a95c4eb3585b7$var$EditionAwarenessFlagSupport);
const $368a95c4eb3585b7$export$a55b02efe3d62583 = ()=>{
    const { edition: confluenceEdition, cloudId: cloudId, accessStatus: accessStatus, isLoggedIn: isLoggedIn, userId: userId, displayName: displayName } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isPagePermissionsSpotlightActive, setIsPagePermissionsSpotlightActive] = (0, $42omo.useState)(false);
    const showPagePermissionsSpotlight = (0, $42omo.useCallback)(()=>{
        setIsPagePermissionsSpotlightActive(true);
    }, []);
    const hidePagePermissionsSpotlight = (0, $42omo.useCallback)(()=>{
        setIsPagePermissionsSpotlightActive(false);
    }, []);
    const getAction = (0, $335f03b73910ade3$export$bc923229a7fa61e7)({
        showPagePermissionsSpotlight: showPagePermissionsSpotlight
    });
    const [siteTraits, setSiteTraits] = (0, $42omo.useState)(()=>{
        if (confluenceEdition === (0, $d9tcB.ConfluenceEdition).FREE) return undefined;
        return [];
    });
    const isFedrampEnv = (0, $lzcvT.isFedRamp)();
    const [autoOpenState, { setIsOpen: setIsOpen }] = (0, $8yYKd.useOpenActionMenuState)();
    const { width: windowWidth } = (0, $hl0fg.useWindowSize)();
    const resetAutoOpenState = (0, $42omo.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    const isLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    (0, $42omo.useEffect)(()=>{
        if (siteTraits === undefined) (0, $3a95c39060b2f8ec$export$847d02aadbf9f5f8)(cloudId).then((traits)=>{
            setSiteTraits(traits);
        }).catch((error)=>{
            setSiteTraits([]);
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'editionAwarenessGrowthCohortTrait',
                    source: 'confluence-frontend',
                    attributes: {
                        error: error.message,
                        stack: error.stack
                    }
                }
            }).fire();
        });
    }, [
        cloudId,
        confluenceEdition,
        createAnalyticsEvent,
        siteTraits
    ]);
    const edition = confluenceEdition ? $368a95c4eb3585b7$var$editionMap[confluenceEdition] : null;
    const { isReverseTrialer: isReverseTrialer, loading: isReverseTrialLoading } = (0, $hY10E.useReverseTrialCohort)({
        skip: !isLicensed || !isLoggedIn || isFedrampEnv || confluenceEdition !== (0, $d9tcB.ConfluenceEdition).PREMIUM
    });
    // TODO: Once this component is SSRed, change this logic to use a media query
    if (windowWidth < 680) return null;
    if (!isLicensed || !isLoggedIn || isFedrampEnv || !edition) // Users that are not logged in/licensed shouldn't attempt to render the component
    // If we're missing the edition then we don't know what to render
    return null;
    // We need to wait for the siteType to be set, and isReverseTrialer to be known before we can render the button
    const canRender = siteTraits !== undefined && !isReverseTrialLoading;
    const componentContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($368a95c4eb3585b7$var$EditionAwarenessWithFlags, {
        product: "confluence",
        cloudId: cloudId,
        edition: edition,
        accountId: userId,
        userDisplayName: displayName,
        userRoles: isSiteAdmin ? [
            'SITE_ADMIN'
        ] : [],
        siteTraits: siteTraits,
        isInReverseTrial: isReverseTrialer,
        premiumFeatureHighlightToggle: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $57I23.PremiumFeatureHighlightToggle), {
            id: "prem-feature-highlight-toggle-pill",
            source: "premTrialActionComponent"
        }),
        shouldAutoOpen: autoOpenState.isOpen,
        // While this is called onAutoOpen, we are calling it when the dialog closes to reset the state if we reset on open, the dialog would never open
        onAutoOpen: resetAutoOpenState,
        PremiumWrapper: $368a95c4eb3585b7$export$eb753ea923b564db,
        canRender: canRender,
        getAction: getAction
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "edition-awareness"
    }, (0, $9wGTI.fg)('confluence_frontend_spolitlight_ads_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, componentContent), isPagePermissionsSpotlightActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $grWYF.OnboardingPagePermissionsSpotlight), {
        onClose: hidePagePermissionsSpotlight
    }) : null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: "edition-awareness"
    }, componentContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, isPagePermissionsSpotlightActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $grWYF.OnboardingPagePermissionsSpotlight), {
        onClose: hidePagePermissionsSpotlight
    }) : null)));
};
module.exports["PremiumWrapper"] = $368a95c4eb3585b7$export$eb753ea923b564db;
module.exports["EditionAwareness"] = $368a95c4eb3585b7$export$a55b02efe3d62583;

});

parcelRegister("9CFT2", function(module, exports) {
/**
 * Most storage measurements are in gigabytes
 */ function $617d1c2def355953$export$6f25243957146989(bytes) {
    return bytes / 1000000000;
}
module.exports["bytesToGigabytes"] = $617d1c2def355953$export$6f25243957146989;

});

parcelRegister("eoBBJ", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $e386a7914d299870$export$ac3ca8c46f19a73f = /*#__PURE__*/ (0, $42omo.createContext)(null);
function $e386a7914d299870$export$5a5baedfe8151ce() {
    const context = (0, $42omo.useContext)($e386a7914d299870$export$ac3ca8c46f19a73f);
    if (!context) throw new Error('Missing context, please ensure this is used within EditionAwarenessContext');
    return context;
}
module.exports["EditionAwarenessContext"] = $e386a7914d299870$export$ac3ca8c46f19a73f;
module.exports["useEditionAwareness"] = $e386a7914d299870$export$5a5baedfe8151ce;

});

parcelRegister("dv2kx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $c6GJD = parcelRequire("c6GJD");


var $8pzEG = parcelRequire("8pzEG");

class $c27b0540064e1768$export$cab0526cd5428d4e {
    experimentExposed(experimentName, experimentVariant, extraAttributes) {
        // If the experiment is already in the dictionary (i.e. been exposed before),
        // we don't want to overwrite the timestamp of first exposure.
        if (Object.keys(this.experimentDictionary).includes(experimentName)) return;
        this.experimentDictionary[experimentName] = {
            cohort: experimentVariant,
            timestamp: Date.now(),
            ...extraAttributes
        };
    }
    experiments() {
        return this.experimentDictionary;
    }
    constructor(context){
        this.experimentDictionary = {};
        this.experimentDictionary = context ?? {};
    }
}
const $c27b0540064e1768$export$fcdf652c4fd8e4c7 = /*#__PURE__*/ (0, $42omo.createContext)(null);
function $c27b0540064e1768$export$471c3c65727643de() {
    const context = (0, $42omo.useContext)($c27b0540064e1768$export$fcdf652c4fd8e4c7);
    if (!context) throw new Error('Missing context, please ensure this is used within ExperimentContext');
    return context;
}
const $c27b0540064e1768$export$259da07bf82c42c7 = (parameterValue)=>parameterValue ? 'variation' : 'control';
const $c27b0540064e1768$export$f2497ad79c72045c = (cohort)=>{
    if (cohort === 'treatment') return 'variation';
    else if (cohort === 'control') return 'control';
    else return 'not-enrolled';
};
const $c27b0540064e1768$export$59dd27b2c85d98d8 = ()=>{
    const experimentContext = $c27b0540064e1768$export$471c3c65727643de();
    const fireExperimentExposureEvent = (0, $8pzEG.useFeatureExposedAnalytics)();
    const getExperimentValue = (0, $42omo.useCallback)(({ statsigParams: { experimentName: experimentName, parameterName: parameterName, defaultValue: defaultValue, options: options }, trackEventParameters: trackEventParameters, experimentContextAttributes: experimentContextAttributes = {} })=>{
        const cohort = options ? (0, $c6GJD.default).getExperimentValue(experimentName, parameterName, defaultValue, options) : (0, $c6GJD.default).getExperimentValue(experimentName, parameterName, defaultValue);
        // By default, fireExperimentExposure is true but we need to explicitly
        // check for that to ensure we fire our context update correctly.
        if (options?.fireExperimentExposure !== false) {
            experimentContext.experimentExposed(experimentName, cohort, experimentContextAttributes);
            if (trackEventParameters) fireExperimentExposureEvent(experimentName, cohort, trackEventParameters?.trackEventGrowthInitiative, trackEventParameters?.trackEventAttributes);
        }
        return cohort;
    }, [
        experimentContext,
        fireExperimentExposureEvent
    ]);
    /**
   * @deprecated Use getExperimentValue instead with the correct experiment cohort values.
   * We are moving towards consistent cohort values of 'control', 'variation' and 'not-enrolled'.
   */ const getExperimentValueWithTransform = (0, $42omo.useCallback)(({ statsigParams: { experimentName: experimentName, parameterName: parameterName, defaultValue: defaultValue, options: options }, transformCohortFunc: transformCohortFunc, trackEventParameters: trackEventParameters, experimentContextAttributes: experimentContextAttributes = {} })=>{
        const cohort = options ? (0, $c6GJD.default).getExperimentValue(experimentName, parameterName, defaultValue, options) : (0, $c6GJD.default).getExperimentValue(experimentName, parameterName, defaultValue);
        // By default, fireExperimentExposure is true but we need to explicitly
        // check for that to ensure we fire our context update correctly.
        if (options?.fireExperimentExposure !== false) {
            experimentContext.experimentExposed(experimentName, transformCohortFunc(cohort), experimentContextAttributes);
            if (trackEventParameters && typeof cohort === 'string') fireExperimentExposureEvent(experimentName, cohort, trackEventParameters?.trackEventGrowthInitiative, trackEventParameters?.trackEventAttributes);
        }
        return cohort;
    }, [
        experimentContext,
        fireExperimentExposureEvent
    ]);
    return {
        getExperimentValue: getExperimentValue,
        getExperimentValueWithTransform: getExperimentValueWithTransform
    };
};
module.exports["ExperimentContextClass"] = $c27b0540064e1768$export$cab0526cd5428d4e;
module.exports["ExperimentContext"] = $c27b0540064e1768$export$fcdf652c4fd8e4c7;
module.exports["useExperimentContext"] = $c27b0540064e1768$export$471c3c65727643de;
module.exports["treatmentCohortTransformFn"] = $c27b0540064e1768$export$f2497ad79c72045c;
module.exports["useGetExperimentValue"] = $c27b0540064e1768$export$59dd27b2c85d98d8;

});

parcelRegister("8pzEG", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ac7kz = parcelRequire("ac7kz");

function $12c853e475c615c0$export$b12ce465f015026c({ flagKey: flagKey, cohort: cohort, growthInitiative: growthInitiative, attributes: attributes, children: children }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $ac7kz.useAnalytics)();
    const hasSent = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'exposed',
            actionSubject: 'feature',
            attributes: {
                ...attributes,
                flagKey: flagKey,
                cohort: cohort,
                growthInitiative: growthInitiative
            }
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        flagKey,
        cohort,
        growthInitiative,
        attributes
    ]);
    if (!children) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
}
const $12c853e475c615c0$export$5218ddb3d9c658c0 = ()=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $ac7kz.useAnalytics)();
    const sentFlagKeys = (0, $42omo.useRef)([]);
    const fireExperimentExposureEvent = (0, $42omo.useCallback)((flagKey, cohort, growthInitiative, attributes)=>{
        if (sentFlagKeys.current.includes(flagKey)) return;
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'exposed',
            actionSubject: 'feature',
            attributes: {
                ...attributes,
                flagKey: flagKey,
                cohort: cohort,
                growthInitiative: growthInitiative
            }
        });
        sentFlagKeys.current.push(flagKey);
    }, [
        sendAnalyticsEvent
    ]);
    return fireExperimentExposureEvent;
};
module.exports["FeatureExposedAnalytics"] = $12c853e475c615c0$export$b12ce465f015026c;
module.exports["useFeatureExposedAnalytics"] = $12c853e475c615c0$export$5218ddb3d9c658c0;

});

parcelRegister("ac7kz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3pfAb = parcelRequire("3pfAb");


var $6v6KC = parcelRequire("6v6KC");

var $inPa6 = parcelRequire("inPa6");


var $eoBBJ = parcelRequire("eoBBJ");


var $dv2kx = parcelRequire("dv2kx");

const $2a8aa1aaafc441a7$export$85183a312807388d = (0, $3pfAb.FabricChannel).growth;
const $2a8aa1aaafc441a7$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    return context.reduce((acc, x)=>{
        if (x.attributes) return {
            ...acc,
            ...x.attributes
        };
        return {
            ...acc,
            ...x ?? {}
        };
    }, {});
};
const $2a8aa1aaafc441a7$export$38cd8db2db178f58 = {
    packageName: '@atlassian/edition-awareness',
    source: 'editionAwareness',
    featureId: 'edition-awareness',
    growthPillar: 'BUY'
};
function $2a8aa1aaafc441a7$export$e955abb82869dc84() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const editionAwarenessContext = (0, $eoBBJ.useEditionAwareness)();
    const experimentContext = (0, $dv2kx.useExperimentContext)();
    const sendAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        const editionAwarenessContextAttributes = {
            // Required properties
            cloudId: editionAwarenessContext.cloudId,
            product: editionAwarenessContext.product,
            currentProductEdition: editionAwarenessContext.edition,
            // Payment properties
            isInvoiceable: editionAwarenessContext.invoiceableStatus === 'INVOICEABLE' ? true : editionAwarenessContext.invoiceableStatus === 'NOT_INVOICEABLE' ? false : null,
            hasPaymentDetailsEntered: editionAwarenessContext.hasPaymentDetailsEntered,
            canAddPaymentDetails: editionAwarenessContext.canAddPaymentDetails,
            addPaymentDetailsExperienceUrl: editionAwarenessContext.addPaymentDetailsExperienceUrl,
            // Trial properties
            trialDaysLeft: editionAwarenessContext.trialDaysLeft,
            trialLengthDays: editionAwarenessContext.trialLengthDays,
            trialEndDate: editionAwarenessContext.trialEndDate,
            isInTrial: editionAwarenessContext.isInTrial,
            isInPredunning: editionAwarenessContext.isInPredunning,
            isInReverseTrial: editionAwarenessContext.isInReverseTrial,
            trialOfferingName: editionAwarenessContext.trialOfferingName,
            lastKnownTrial: editionAwarenessContext?.lastKnownTrial,
            offeringKey: editionAwarenessContext?.offeringKey,
            // Upgrade properties
            canUpgrade: editionAwarenessContext.canUpgrade,
            changeOfferingToStandardExperienceUrl: editionAwarenessContext.changeOfferingToStandardExperienceUrl,
            directBuyChangeOfferingToStandardExperienceUrl: editionAwarenessContext.directBuyChangeOfferingToStandardExperienceUrl,
            // Entitlement properties
            entitlementId: editionAwarenessContext.entitlementId,
            isInCollection: editionAwarenessContext.isInCollection,
            collectionType: editionAwarenessContext.collectionType,
            // User permissions properties
            userRoles: editionAwarenessContext.userRoles,
            userEmail: editionAwarenessContext.userEmail,
            // Site properties
            billingSourceSystem: editionAwarenessContext.hasDismissedButton === false ? null : 'CCP',
            licensedUsers: editionAwarenessContext.licensedUsers,
            storageUsageInGB: editionAwarenessContext.storageUsageInGB,
            isEnterpriseCustomer: editionAwarenessContext.isEnterpriseCustomer,
            // Site traits
            automationUsage: editionAwarenessContext.automationUsage,
            lastAutomationFreeLimitBreachDate: editionAwarenessContext.lastAutomationFreeLimitBreachDate,
            automationFreeLimitStatus: editionAwarenessContext.automationFreeLimitStatus,
            // Capabilities
            shouldAutoOpen: editionAwarenessContext.shouldAutoOpen
        };
        if (payload instanceof (0, $6v6KC.default)) {
            const contextAttributes = $2a8aa1aaafc441a7$export$d97c97ed77ff09e8(payload.context);
            payload.update({
                ...payload.payload,
                attributes: {
                    ...contextAttributes,
                    ...$2a8aa1aaafc441a7$export$38cd8db2db178f58,
                    ...payload.payload.attributes,
                    ...editionAwarenessContextAttributes,
                    experiments: experimentContext.experiments()
                }
            }).fire($2a8aa1aaafc441a7$export$85183a312807388d);
        } else {
            const event = createAnalyticsEvent({
                ...payload,
                attributes: {
                    ...$2a8aa1aaafc441a7$export$38cd8db2db178f58,
                    ...payload.attributes,
                    ...editionAwarenessContextAttributes,
                    experiments: experimentContext.experiments()
                }
            });
            const contextAttributes = $2a8aa1aaafc441a7$export$d97c97ed77ff09e8(event.context);
            event.update({
                attributes: {
                    ...contextAttributes,
                    ...event.payload.attributes
                }
            }).fire($2a8aa1aaafc441a7$export$85183a312807388d);
        }
    }, [
        createAnalyticsEvent,
        editionAwarenessContext,
        experimentContext
    ]);
    return {
        sendAnalyticsEvent: sendAnalyticsEvent
    };
}
function $2a8aa1aaafc441a7$export$b901544a79a3bbad({ name: name, attributes: attributes }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = $2a8aa1aaafc441a7$export$e955abb82869dc84();
    const hasSent = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'screen',
            name: name,
            attributes: attributes
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        name,
        attributes
    ]);
    return null;
}
module.exports["ANALYTICS_CHANNEL"] = $2a8aa1aaafc441a7$export$85183a312807388d;
module.exports["getAttributesFromContexts"] = $2a8aa1aaafc441a7$export$d97c97ed77ff09e8;
module.exports["defaultAttributes"] = $2a8aa1aaafc441a7$export$38cd8db2db178f58;
module.exports["useAnalytics"] = $2a8aa1aaafc441a7$export$e955abb82869dc84;

});

parcelRegister("fgLLK", function(module, exports) {

var $cBdZC = parcelRequire("cBdZC");


var $bzSU8 = parcelRequire("bzSU8");

const $5735e2cb95d85b25$export$7296becdbc8d7810 = 100;
const $5735e2cb95d85b25$export$5a0f9f37fb711f37 = 1700;
const $5735e2cb95d85b25$export$b3d11e30afa46646 = 0.8 * $5735e2cb95d85b25$export$7296becdbc8d7810;
const $5735e2cb95d85b25$export$5f347675b43b787f = ({ edition: edition, product: product, isInTrial: isInTrial, automationUsage: automationUsage, lastAutomationFreeLimitBreachDate: lastAutomationFreeLimitBreachDate = null })=>{
    if ((edition === 'free' || edition === 'standard' && isInTrial) && product === 'jira') {
        if ($5735e2cb95d85b25$export$5ff23a30e22aeec2(automationUsage, lastAutomationFreeLimitBreachDate)) return 'BREACHED';
        if ($5735e2cb95d85b25$var$isAutomationProjectedToBreach(automationUsage, edition)) return 'PROJECTED_TO_BREACH';
        if ($5735e2cb95d85b25$var$hasBreachedAutomationUsagePreviousMonth(lastAutomationFreeLimitBreachDate)) return 'BREACHED_PREVIOUS_MONTH';
    }
    return null;
};
const $5735e2cb95d85b25$export$5c4f4d557a0ee678 = (automationUsage)=>{
    const today = new Date();
    const dayOfMonth = today.getDate();
    return automationUsage / dayOfMonth * (0, $cBdZC.default)(today);
};
const $5735e2cb95d85b25$var$isAutomationProjectedToBreach = (automationUsage, edition)=>{
    // Already breached the limit, no need to project
    if (automationUsage >= $5735e2cb95d85b25$export$7296becdbc8d7810) return false;
    const projectedUsage = $5735e2cb95d85b25$export$5c4f4d557a0ee678(automationUsage);
    if (edition === 'free') return projectedUsage >= $5735e2cb95d85b25$export$7296becdbc8d7810 && automationUsage >= $5735e2cb95d85b25$export$b3d11e30afa46646;
    return projectedUsage >= $5735e2cb95d85b25$export$7296becdbc8d7810;
};
const $5735e2cb95d85b25$export$5ff23a30e22aeec2 = (automationUsage, lastAutomationFreeLimitBreachDate)=>{
    return lastAutomationFreeLimitBreachDate && automationUsage >= $5735e2cb95d85b25$export$7296becdbc8d7810 && (0, $bzSU8.default)(new Date(), lastAutomationFreeLimitBreachDate);
};
const $5735e2cb95d85b25$var$hasBreachedAutomationUsagePreviousMonth = (lastAutomationFreeLimitBreachDate)=>{
    if (!lastAutomationFreeLimitBreachDate) return false;
    const now = new Date();
    // Date constructor handles overflow on the last month correctly
    const lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    return (0, $bzSU8.default)(lastAutomationFreeLimitBreachDate, lastMonth);
};
module.exports["AUTOMATION_USAGE_FREE_LIMIT"] = $5735e2cb95d85b25$export$7296becdbc8d7810;
module.exports["AUTOMATION_USAGE_STANDARD_LIMIT"] = $5735e2cb95d85b25$export$5a0f9f37fb711f37;
module.exports["getAutomationFreeLimitStatus"] = $5735e2cb95d85b25$export$5f347675b43b787f;

});

parcelRegister("cBdZC", function(module, exports) {
$parcel$export(module.exports, "default", () => $92c3cb6bf29dbac3$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $92c3cb6bf29dbac3$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}

});

parcelRegister("bzSU8", function(module, exports) {
$parcel$export(module.exports, "default", () => $86dd8d7adaa722e5$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $86dd8d7adaa722e5$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $b5utg.default)(2, arguments);
    var dateLeft = (0, $egXhZ.default)(dirtyDateLeft);
    var dateRight = (0, $egXhZ.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

});

parcelRegister("c6WWz", function(module, exports) {
function $538652de2c4f8aec$export$94a1af7d4eee9d3f(context) {
    const { product: product, edition: edition, isInCollection: isInCollection, isInTrial: isInTrial } = context;
    return !isInCollection && product === 'confluence' && edition === 'free' && !isInTrial;
}
module.exports["isEligibleForChooseYourEdition"] = $538652de2c4f8aec$export$94a1af7d4eee9d3f;

});

parcelRegister("2wRpZ", function(module, exports) {

var $dh538 = parcelRequire("dh538");

function $8ab3c0d458eca72e$export$fb0151ca07bf2312(context) {
    const { isInCollection: isInCollection, product: product, entitlementId: entitlementId, transactionAccountId: transactionAccountId, canDirectBuyUpgrade: canDirectBuyUpgrade } = context;
    return product === 'jira' && !isInCollection && Boolean(entitlementId) && Boolean(transactionAccountId) && Boolean(canDirectBuyUpgrade) && (0, $dh538.fg)('special_offer_60_days_jira_standard_kill_switch');
}
module.exports["isEligibleForSpecialOfferSixty"] = $8ab3c0d458eca72e$export$fb0151ca07bf2312;

});

parcelRegister("go59p", function(module, exports) {
var $99a16ca2a3e56985$export$9874ba4d5a9c06c8 = /*#__PURE__*/ function(GrowthPillar) {
    GrowthPillar["FIND"] = "FIND";
    GrowthPillar["BUY"] = "BUY";
    GrowthPillar["USE"] = "USE";
    GrowthPillar["PLATFORM"] = "PLATFORM";
    return GrowthPillar;
}({});
var $99a16ca2a3e56985$export$6f4a0f769e61929 = /*#__PURE__*/ function(Edition) {
    Edition["FREE_EDITION"] = "free";
    Edition["STANDARD_EDITION"] = "standard";
    Edition["PREMIUM_EDITION"] = "premium";
    Edition["SELECTION"] = "selection";
    return Edition;
}({});
module.exports["Edition"] = $99a16ca2a3e56985$export$6f4a0f769e61929;

});

parcelRegister("aH9Q1", function(module, exports) {

var $2xciB = parcelRequire("2xciB");


var $58Nu8 = parcelRequire("58Nu8");


var $56LFI = parcelRequire("56LFI");

const $da1a55ed1292d791$var$cache = (0, $2xciB.createCache)(new Map());
function $da1a55ed1292d791$export$e83743682263315a(loader, opts) {
    return $da1a55ed1292d791$var$cache.get(opts.moduleId, ()=>(0, $58Nu8.PreloadableJSResource)(()=>(0, $56LFI.postTask)(loader, {
                priority: 'user-visible'
            }), opts));
}
module.exports["JSResourceForInteraction"] = $da1a55ed1292d791$export$e83743682263315a;

});

parcelRegister("2xciB", function(module, exports) {
function $148a59911478cb25$export$cf6fa0bbcc94b912(store) {
    return {
        get (key, supplier) {
            const value = store.get(key);
            if (value != null) return value;
            const v = supplier();
            store.set(key, v);
            return v;
        }
    };
}
module.exports["createCache"] = $148a59911478cb25$export$cf6fa0bbcc94b912;

});

parcelRegister("58Nu8", function(module, exports) {

var $2X3nY = parcelRequire("2X3nY");

function $ba332286d251cd41$export$4fe5fba5bb1d3c09(loader, opts) {
    const resource = (0, $2X3nY.JSResource)(loader, opts);
    return Object.assign(resource, {
        preload () {
            const jsModule = resource.getModuleIfRequired();
            if (jsModule != null) return;
            resource.load().catch(()=>{});
        }
    });
}
module.exports["PreloadableJSResource"] = $ba332286d251cd41$export$4fe5fba5bb1d3c09;

});

parcelRegister("2X3nY", function(module, exports) {

var $6hmze = parcelRequire("6hmze");


var $cAXnn = parcelRequire("cAXnn");


var $7Z6yP = parcelRequire("7Z6yP");

function $39dd57c545107221$export$148e45a6d4b4d65(loader, opts) {
    const { moduleId: moduleId, moduleName: moduleName, modulePath: modulePath, priority: priority } = opts;
    const listeners = new Set();
    let promise;
    let state = {
        type: 'init'
    };
    function createOnLoad(event) {
        return (module)=>{
            (0, $cAXnn.eventEmitter).emit('jsresource.load.complete', event);
            state = {
                type: 'module',
                module: module
            };
            for (const listener of listeners)listener.onLoad(module);
        };
    }
    function createOnError(event) {
        return (error)=>{
            (0, $cAXnn.eventEmitter).emit('jsresource.load.error', {
                ...event,
                error: error
            });
            state = {
                type: 'error',
                error: error
            };
            for (const listener of listeners)listener.onError?.(error);
        };
    }
    return {
        getModuleId () {
            return moduleId;
        },
        getModuleName () {
            return moduleName;
        },
        getModulePath () {
            return modulePath;
        },
        getPriority () {
            return priority;
        },
        getModuleIfRequired () {
            if (state.type === 'error') throw state.error;
            return state.type === 'module' ? state.module : null;
        },
        load () {
            if (!promise) {
                const event = {
                    moduleId: moduleId,
                    transactionId: (0, $6hmze.generateId)()
                };
                const onError = createOnError(event);
                const onLoad = createOnLoad(event);
                (0, $cAXnn.eventEmitter).emit('jsresource.load.start', event);
                try {
                    promise = loader().then((result)=>{
                        const module = (0, $7Z6yP.isJSModuleWithDefaultExport)(result) ? result.default : result;
                        onLoad(module);
                        return module;
                    }).catch((error)=>{
                        onError(error);
                        throw error;
                    });
                } catch (error) {
                    if (error instanceof Error) onError(error);
                    promise = Promise.reject(error);
                }
            }
            return promise;
        },
        onComplete (onLoad, onError) {
            if (state.type === 'module') {
                onLoad(state.module);
                return ()=>{};
            }
            if (state.type === 'error') {
                onError?.(state.error);
                return ()=>{};
            }
            const listener = {
                onError: onError,
                onLoad: onLoad
            };
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        }
    };
}
module.exports["JSResource"] = $39dd57c545107221$export$148e45a6d4b4d65;

});

parcelRegister("6hmze", function(module, exports) {
let $546b0d6600b43919$var$id = 100000;
function $546b0d6600b43919$export$567fc7097e064344() {
    $546b0d6600b43919$var$id += 1;
    return $546b0d6600b43919$var$id.toString();
}
module.exports["generateId"] = $546b0d6600b43919$export$567fc7097e064344;

});

parcelRegister("cAXnn", function(module, exports) {
function $df7beae67697fe3a$var$createEventEmitter() {
    const eventSubscribers = new Map();
    return {
        emit (eventName, event) {
            const subscribers = eventSubscribers.get(eventName);
            for (const subscriber of subscribers ?? [])subscriber(event);
        },
        on (eventName, subscriber) {
            if (!eventSubscribers.has(eventName)) eventSubscribers.set(eventName, new Set([
                subscriber
            ]));
            else eventSubscribers.get(eventName).add(subscriber);
            return ()=>{
                const set = eventSubscribers.get(eventName);
                set.delete(subscriber);
                if (set.size === 0) eventSubscribers.delete(eventName);
            };
        }
    };
}
const $df7beae67697fe3a$export$10dc3edfc20c8ff = $df7beae67697fe3a$var$createEventEmitter();
module.exports["eventEmitter"] = $df7beae67697fe3a$export$10dc3edfc20c8ff;

});

parcelRegister("7Z6yP", function(module, exports) {
function $1cfe6d8b66e6a41d$export$3b514faac3ba993c(module) {
    try {
        // This should be replaced with Object.hasOwn once it is more widely supported
        return Object.prototype.hasOwnProperty.call(module, 'default');
    } catch (_) {
        // This fallback will occur when module is undefined, or null after converting to Object.hasOwn
        return false;
    }
}
module.exports["isJSModuleWithDefaultExport"] = $1cfe6d8b66e6a41d$export$3b514faac3ba993c;

});

parcelRegister("56LFI", function(module, exports) {
async function $d3c226111d006051$var$toPromise(callback) {
    return callback();
}
function $d3c226111d006051$var$getScheduler(obj) {
    if ('scheduler' in obj && obj.scheduler !== 'undefined') return obj.scheduler;
}

function $d3c226111d006051$export$13c9d02ca54955a3(callback, options) {
    // Dynamically import the scheduler-polyfill module, so browsers that do support the Prioritized Task Scheduling API
    // do not pay the performance cost (e.g. bundle size, runtime, etc).
    const scheduler = $d3c226111d006051$var$getScheduler(globalThis);
    if (!scheduler) {
        // Only load the polyfill if we are using the background priority
        if (options.priority === 'background') // This polyfill will be removed once the Prioritized Task Scheduling API is more widely supported in browsers.
        // eslint-disable-next-line import/dynamic-import-chunkname
        // @ts-ignore error TS7016: Could not find a declaration file for module 'scheduler-polyfill' seen in Jira Typechecking (Cypress) step
        return (parcelRequire("j5M61")).then(()=>$d3c226111d006051$var$getScheduler(globalThis).postTask(callback, options));
        return $d3c226111d006051$var$toPromise(callback);
    }
    return scheduler.postTask(callback, options);
}
module.exports["postTask"] = $d3c226111d006051$export$13c9d02ca54955a3;

});

parcelRegister("j5M61", function(module, exports) {

let $de63cad6e511e9d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $de63cad6e511e9d7$var$load("5a167").then(()=>parcelRequire('jUuBC'));

});

parcelRegister("cab2i", function(module, exports) {
/* eslint-disable @typescript-eslint/ban-types */ function $991254190d627578$export$fa00dd5c1a75592f(// The param types can only be inferred if the shape of the entrypoint (i.e. root and getPreloadProps) is specified
// within the function definition itself. Using EntryPoint, EntryPointComponent, or a custom EntryPointRepresentation
// in place of this will cause Root to be inferred as an 'unknown' type.
params) {
    return params;
}
module.exports["createEntryPoint"] = $991254190d627578$export$fa00dd5c1a75592f;

});

parcelRegister("5dr3h", function(module, exports) {

let $3cc3269709d8d17e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3cc3269709d8d17e$var$load("6wr18"),
    $3cc3269709d8d17e$var$load("dNed9"),
    $3cc3269709d8d17e$var$load("fjOTL"),
    $3cc3269709d8d17e$var$load("ffEVr"),
    $3cc3269709d8d17e$var$load("1AVLS")
]).then(()=>parcelRequire('8sR4g'));

});

parcelRegister("l83yi", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $4rwCt = parcelRequire("4rwCt");


var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $9hlns = parcelRequire("9hlns");


var $7wYo8 = parcelRequire("7wYo8");


var $48FEk = parcelRequire("48FEk");


var $gWF6I = parcelRequire("gWF6I");


var $lyOEk = parcelRequire("lyOEk");

const $c2beef8bc8f49818$var$emptyEntryPointParams = {};
const $c2beef8bc8f49818$var$emptyEntryPointProps = {};
const $c2beef8bc8f49818$var$FallbackComponent = ({ fallback: fallback, onUnmount: onUnmount })=>{
    (0, $42omo.useEffect)(()=>{
        return ()=>onUnmount();
    }, [
        onUnmount
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: fallback || /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {})
    });
};
function $c2beef8bc8f49818$export$95d4acdbab2fc6ef({ trigger: trigger, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, fallback: fallback, errorFallback: errorFallback, onError: onError, forcedReportErrorUFO: forcedReportErrorUFO, onClose: onClose, preloadOnFocus: providedPreloadOnFocus, ...popupProps }) {
    const environmentProvider = (0, $gWF6I.useRelayEnvironmentProvider)();
    const preloadOnFocus = providedPreloadOnFocus ?? (0, $dh538.fg)('dst-a11y_preload-on-focus-default-true') ? true : false;
    const id = (0, $42omo.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const [content, setContent] = (0, $42omo.useState)(null);
    const updateRef = (0, $42omo.useRef)(null);
    const handleOpen = (0, $42omo.useCallback)(()=>{
        setIsOpen(true);
    }, []);
    const handleClose = (0, $42omo.useCallback)((event, currentLevel)=>{
        setIsOpen(false);
        onClose?.(event, currentLevel);
    }, [
        onClose
    ]);
    const triggerCloseRef = (0, $lyOEk.useClickToCloseRef)({
        isOpen: isOpen,
        handleClose: handleClose
    });
    const load = (0, $42omo.useCallback)(()=>(0, $irOoi.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $c2beef8bc8f49818$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $42omo.useCallback)(({ reference: entryPointReference })=>{
        // avoid re-loading entry-point when closing popup
        if (isOpen) return;
        handleOpen();
        setContent(/*#__PURE__*/ (0, $l998X.jsx)((0, $48FEk.InternalEntryPointContainer), {
            id: id,
            entryPointReference: entryPointReference,
            fallback: // when the fallback is unmounted we want to trigger an update to the popup position
            /*#__PURE__*/ (0, $l998X.jsx)($c2beef8bc8f49818$var$FallbackComponent, {
                fallback: fallback,
                onUnmount: ()=>updateRef.current?.()
            }),
            errorFallback: errorFallback,
            runtimeProps: {
                ...entryPointProps ?? $c2beef8bc8f49818$var$emptyEntryPointProps,
                onContentResized: ()=>{
                    updateRef.current?.();
                },
                onClose: handleClose
            },
            onError: onError,
            forcedError: forcedReportErrorUFO
        }));
    }, [
        setContent,
        id,
        isOpen,
        entryPointProps,
        fallback,
        forcedReportErrorUFO,
        errorFallback,
        handleOpen,
        onError,
        handleClose
    ]);
    const triggerRef = (0, $7wYo8.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad,
        preloadOnFocus: preloadOnFocus
    });
    const popupTrigger = (0, $42omo.useCallback)((triggerProps)=>{
        const mergedRef = (0, $4rwCt.mergeRefs)([
            triggerRef,
            triggerProps.ref,
            triggerCloseRef
        ]);
        return trigger({
            ...triggerProps,
            ref: mergedRef
        });
    }, [
        trigger,
        triggerRef,
        triggerCloseRef
    ]);
    const popupContent = (0, $42omo.useCallback)(({ update: update })=>{
        updateRef.current = update;
        return content;
    }, [
        content
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.Popup), {
        ...popupProps,
        isOpen: isOpen,
        onClose: handleClose,
        trigger: popupTrigger,
        content: popupContent
    });
}
module.exports["PopupTrigger"] = $c2beef8bc8f49818$export$95d4acdbab2fc6ef;

});

parcelRegister("7wYo8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $hBkFA = parcelRequire("hBkFA");

function $68a341f15f9dda7b$export$1ff47f24e06a5d2d({ load: load, onLoad: onLoad, onBeforeLoad: onBeforeLoad, loadOnFocus: loadOnFocus = false, preloadOnFocus: preloadOnFocus = false }) {
    const nodeRef = (0, $42omo.useRef)(null);
    const eventListeners = (0, $42omo.useRef)([]);
    const { preloadReference: preloadReference, cancelPreload: cancelPreload, eagerLoad: eagerLoad } = (0, $hBkFA.useEntryPointPreload)(load);
    const clickListener = (0, $42omo.useMemo)(()=>{
        return ()=>{
            if (onBeforeLoad) onBeforeLoad();
            onLoad(eagerLoad());
        };
    }, [
        onBeforeLoad,
        onLoad,
        eagerLoad
    ]);
    const mouseDownListener = (0, $42omo.useMemo)(()=>{
        return ()=>{
            eagerLoad();
        };
    }, [
        eagerLoad
    ]);
    const cleanUpEventListeners = (0, $42omo.useCallback)(()=>{
        eventListeners.current.forEach((unbind)=>{
            unbind();
        });
        eventListeners.current = [];
    }, []);
    const addEventListener = (0, $42omo.useCallback)((element, type, callback)=>{
        const unbind = (0, $fFa3V.bind)(element, {
            type: type,
            listener: callback
        });
        eventListeners.current.push(unbind);
    }, []);
    const refCallback = (0, $42omo.useCallback)((element)=>{
        if (element !== nodeRef.current) {
            if (nodeRef.current) {
                cancelPreload();
                cleanUpEventListeners();
            }
            if (element) {
                addEventListener(element, 'click', clickListener);
                addEventListener(element, 'mousedown', mouseDownListener);
                addEventListener(element, 'mouseenter', preloadReference);
                addEventListener(element, 'mouseleave', cancelPreload);
                if (loadOnFocus) addEventListener(element, 'focusin', clickListener);
                else if (preloadOnFocus) {
                    addEventListener(element, 'focusin', preloadReference);
                    addEventListener(element, 'focusout', cancelPreload);
                }
            }
            // Update the ref with the new element
            nodeRef.current = element;
        }
    }, [
        clickListener,
        mouseDownListener,
        preloadReference,
        cancelPreload,
        loadOnFocus,
        addEventListener,
        cleanUpEventListeners,
        preloadOnFocus
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            cleanUpEventListeners();
        };
    }, [
        cleanUpEventListeners
    ]);
    return refCallback;
}
module.exports["usePressablePreloadRef"] = $68a341f15f9dda7b$export$1ff47f24e06a5d2d;

});

parcelRegister("hBkFA", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $b7a3f72174bcd512$var$PRELOAD_MAX_AGE = 300000; // 5 mins
const $b7a3f72174bcd512$var$TIME_TO_INTENT = 200;
function $b7a3f72174bcd512$export$57effc2a5e3611f(load) {
    return (0, $42omo.useMemo)(()=>{
        const request = {};
        const clearPreloadTimeouts = ()=>{
            if (typeof request.preloadIntentTimeout === 'number') {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
            if (typeof request.preloadMaxAgeTimeout === 'number') {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreload = ()=>{
            clearPreloadTimeouts();
            request.preload?.dispose();
        };
        const loadReference = ()=>{
            if (request.load) return request.load;
            const reference = request.preload?.reference ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const eagerLoad = ()=>{
            clearPreloadTimeouts();
            return loadReference();
        };
        const preloadReference = ()=>{
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    delete request.preloadMaxAgeTimeout;
                    request.preload?.dispose();
                }, $b7a3f72174bcd512$var$PRELOAD_MAX_AGE);
            }, $b7a3f72174bcd512$var$TIME_TO_INTENT);
        };
        return {
            preloadReference: preloadReference,
            cancelPreload: cancelPreload,
            eagerLoad: eagerLoad
        };
    }, [
        load
    ]);
}
module.exports["useEntryPointPreload"] = $b7a3f72174bcd512$export$57effc2a5e3611f;

});

parcelRegister("48FEk", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $irOoi = parcelRequire("irOoi");


var $eduVw = parcelRequire("eduVw");


var $hNKXO = parcelRequire("hNKXO");


var $4M6GB = parcelRequire("4M6GB");

function $f9885621a7911f5b$var$InternalEntryPointContainerInner({ entryPointReference: entryPointReference, errorFallback: errorFallback, /** Log and track errors */ onError: onErrorLocal, forcedError: forcedError, fallback: /** Loading fallback */ fallback, id: id, placeholderName: placeholderName, runtimeProps: runtimeProps }) {
    const { PlaceholderComponent: PlaceholderComponent } = (0, $4M6GB.useEntryPointConfig)();
    // useUFOReportError needs to be called under correct UFOSegment to work
    const reportErrorUFO = (0, $eduVw.useUFOReportError)();
    const onError = (0, $42omo.useCallback)((error, errorInfo)=>{
        onErrorLocal?.({
            error: error,
            errorInfo: errorInfo
        });
        (0, $hNKXO.reportError)({
            error: error,
            errorInfo: errorInfo,
            interactionId: id
        });
        reportErrorUFO({
            name: id,
            errorMessage: error?.message ?? 'Unknown error',
            errorStack: error?.stack ?? 'Unknown stack',
            forcedError: forcedError
        });
    }, [
        onErrorLocal,
        id,
        reportErrorUFO,
        forcedError
    ]);
    const FallbackComponent = (0, $42omo.useCallback)(({ error: error })=>{
        const onClose = runtimeProps?.onClose ?? (()=>{});
        return errorFallback ? errorFallback({
            error: error,
            onClose: onClose
        }) : null;
    }, [
        errorFallback,
        runtimeProps
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        FallbackComponent: FallbackComponent,
        onError: onError,
        children: /*#__PURE__*/ (0, $l998X.jsx)(PlaceholderComponent, {
            name: placeholderName ?? 'internal-internal-entry-point-container',
            fallback: fallback,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $irOoi.EntryPointContainer), {
                entryPointReference: entryPointReference,
                props: runtimeProps
            })
        })
    });
}
function $f9885621a7911f5b$export$5d4dc37edd8a3adb(props) {
    const { id: id } = props;
    const { UFOSegmentComponent: UFOSegmentComponent } = (0, $4M6GB.useEntryPointConfig)();
    return /*#__PURE__*/ (0, $l998X.jsx)(UFOSegmentComponent, {
        name: id,
        children: /*#__PURE__*/ (0, $l998X.jsx)($f9885621a7911f5b$var$InternalEntryPointContainerInner, {
            ...props
        })
    });
}
module.exports["InternalEntryPointContainer"] = $f9885621a7911f5b$export$5d4dc37edd8a3adb;

});

parcelRegister("hNKXO", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $e5b5ac7e446444f2$var$buffer = [];
let $e5b5ac7e446444f2$var$push = (payload)=>{
    $e5b5ac7e446444f2$var$buffer.push(payload);
};
function $e5b5ac7e446444f2$export$b33b857ad1d9900e(payload) {
    $e5b5ac7e446444f2$var$push(payload);
}
function $e5b5ac7e446444f2$export$abd5747ea77ecab9(handler) {
    if ((0, $dh538.fg)('moving_jira_entry-points_api_under_platform')) {
        $e5b5ac7e446444f2$var$push = handler;
        $e5b5ac7e446444f2$var$buffer.forEach((payload)=>handler(payload));
        $e5b5ac7e446444f2$var$buffer.length = 0;
    }
}
module.exports["reportError"] = $e5b5ac7e446444f2$export$b33b857ad1d9900e;

});

parcelRegister("4M6GB", function(module, exports) {

var $bniL1 = parcelRequire("bniL1");


var $hnvzE = parcelRequire("hnvzE");

const $a93efc0d5ccefe43$var$DefaultUFOSegmentComponent = (0, $hnvzE.default);
const $a93efc0d5ccefe43$var$entryPointConfig = {
    PlaceholderComponent: (0, $bniL1.default),
    UFOSegmentComponent: $a93efc0d5ccefe43$var$DefaultUFOSegmentComponent,
    ModalErrorFallback: ()=>null
};
function $a93efc0d5ccefe43$export$93a6801f9db838c4(overrides) {
    Object.assign($a93efc0d5ccefe43$var$entryPointConfig, overrides);
    return $a93efc0d5ccefe43$var$entryPointConfig;
}
function $a93efc0d5ccefe43$export$dfa96f26176fa91f() {
    return $a93efc0d5ccefe43$var$entryPointConfig;
}
module.exports["useEntryPointConfig"] = $a93efc0d5ccefe43$export$dfa96f26176fa91f;

});

parcelRegister("lyOEk", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $e35e56a4401e36ea$export$46ec6629f411921d({ isOpen: isOpen, handleClose: handleClose }) {
    const ref = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const clickListener = ()=>{
            if (isOpen) handleClose(null);
        };
        el.addEventListener('click', clickListener);
        return ()=>{
            el.removeEventListener('click', clickListener);
        };
    }, [
        isOpen,
        handleClose
    ]);
    return ref;
}
module.exports["useClickToCloseRef"] = $e35e56a4401e36ea$export$46ec6629f411921d;

});

parcelRegister("3akMv", function(module, exports) {

let $24e26d024c98b0da$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $24e26d024c98b0da$var$load("6wr18"),
    $24e26d024c98b0da$var$load("ffEVr"),
    $24e26d024c98b0da$var$load("aMOuo")
]).then(()=>parcelRequire('ksoel'));

});

parcelRegister("gGWKv", function(module, exports) {
/**
 * @generated SignedSource<<097e739c8f587122d55cf8edeb3e4584>>
 * @relayHash 78d13f0d1fdc6880857606f82d2074ff
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 242a677a397113cedf06a1f4ffb86a7bef4bcd0e5d406fa845d786f9871940f0

var $3e6Uc = parcelRequire("3e6Uc");

const $0873a76812f0bc08$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "collectionEntitlementId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "collectionEntitlementId"
        }
    ], v2 = {
        "concreteType": "CcpEntitlementExperienceCapabilities",
        "kind": "LinkedField",
        "name": "experienceCapabilities",
        "plural": false,
        "selections": [
            {
                "concreteType": "CcpManageEntitlementExperienceCapability",
                "kind": "LinkedField",
                "name": "manageEntitlement",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "experienceUrl"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isAvailableToUser"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "collectionChangePlanPopupQuery",
            "selections": [
                {
                    "concreteType": "CcpQueryApi",
                    "kind": "LinkedField",
                    "name": "ccp",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "CcpEntitlement",
                            "kind": "LinkedField",
                            "name": "entitlementV2",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "collectionChangePlanPopupQuery",
            "selections": [
                {
                    "concreteType": "CcpQueryApi",
                    "kind": "LinkedField",
                    "name": "ccp",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "CcpEntitlement",
                            "kind": "LinkedField",
                            "name": "entitlementV2",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "242a677a397113cedf06a1f4ffb86a7bef4bcd0e5d406fa845d786f9871940f0",
            "metadata": {},
            "name": "collectionChangePlanPopupQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0873a76812f0bc08$var$node.hash = "9b656bb88394dc31aa1596f9938d5c9a";
(0, $3e6Uc.PreloadableQueryRegistry).set($0873a76812f0bc08$var$node.params.id, $0873a76812f0bc08$var$node);
var $0873a76812f0bc08$export$2e2bcd8739ae039 = $0873a76812f0bc08$var$node;
module.exports["default"] = $0873a76812f0bc08$export$2e2bcd8739ae039;

});

parcelRegister("5SCVY", function(module, exports) {

let $4480326240477b6c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4480326240477b6c$var$load("6wr18"),
    $4480326240477b6c$var$load("ffEVr"),
    $4480326240477b6c$var$load("99wAt")
]).then(()=>parcelRequire('bEeQy'));

});

parcelRegister("1nB07", function(module, exports) {
/**
 * @generated SignedSource<<6df9d103a5ac1f082da222a27d75f0ed>>
 * @relayHash 74bceb2880e4acba1f6c57632a1e84c8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5e45583d3d0b67511dc2134859fd0de8080362edff9066b36aeb825b06b4fb43

var $3e6Uc = parcelRequire("3e6Uc");

const $fe957a3e2d80f5e5$var$node = function() {
    var v0 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "key",
                            "value": "end-user-request-to-upgrade-latest-timestamp"
                        }
                    ],
                    "concreteType": "UserOnboardingState",
                    "kind": "LinkedField",
                    "name": "onboardingState",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ],
                    "storageKey": "onboardingState(key:\"end-user-request-to-upgrade-latest-timestamp\")"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "endUserRequestModalQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "endUserRequestModalQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "id": "5e45583d3d0b67511dc2134859fd0de8080362edff9066b36aeb825b06b4fb43",
            "metadata": {},
            "name": "endUserRequestModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$fe957a3e2d80f5e5$var$node.hash = "85c8714a4bf9b70c2bf50e70a13c257f";
(0, $3e6Uc.PreloadableQueryRegistry).set($fe957a3e2d80f5e5$var$node.params.id, $fe957a3e2d80f5e5$var$node);
var $fe957a3e2d80f5e5$export$2e2bcd8739ae039 = $fe957a3e2d80f5e5$var$node;
module.exports["default"] = $fe957a3e2d80f5e5$export$2e2bcd8739ae039;

});

parcelRegister("4xfjs", function(module, exports) {

let $34d61f4a18f2f9e4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $34d61f4a18f2f9e4$var$load("6wr18"),
    $34d61f4a18f2f9e4$var$load("8YAkP"),
    $34d61f4a18f2f9e4$var$load("kiGNy"),
    $34d61f4a18f2f9e4$var$load("Wowvf"),
    $34d61f4a18f2f9e4$var$load("ffEVr"),
    $34d61f4a18f2f9e4$var$load("4I0kP")
]).then(()=>parcelRequire('kD9li'));

});

parcelRegister("kn5hm", function(module, exports) {

let $ed4a0cf0e3af73ff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ed4a0cf0e3af73ff$var$load("2vAWg"),
    $ed4a0cf0e3af73ff$var$load("7cABH"),
    $ed4a0cf0e3af73ff$var$load("cJcjb"),
    $ed4a0cf0e3af73ff$var$load("dNed9"),
    $ed4a0cf0e3af73ff$var$load("fjOTL"),
    $ed4a0cf0e3af73ff$var$load("hv4mn"),
    $ed4a0cf0e3af73ff$var$load("hhss7"),
    $ed4a0cf0e3af73ff$var$load("dek7I"),
    $ed4a0cf0e3af73ff$var$load("dYtBN"),
    $ed4a0cf0e3af73ff$var$load("kNV5Y"),
    $ed4a0cf0e3af73ff$var$load("6wr18"),
    $ed4a0cf0e3af73ff$var$load("kjZZD"),
    $ed4a0cf0e3af73ff$var$load("bkc7o"),
    $ed4a0cf0e3af73ff$var$load("2wlUS"),
    $ed4a0cf0e3af73ff$var$load("lRtGG"),
    $ed4a0cf0e3af73ff$var$load("ffEVr"),
    $ed4a0cf0e3af73ff$var$load("7EorR"),
    $ed4a0cf0e3af73ff$var$load("dTsOE"),
    $ed4a0cf0e3af73ff$var$load("hogcU"),
    $ed4a0cf0e3af73ff$var$load("dAdaw"),
    $ed4a0cf0e3af73ff$var$load("dGvEg")
]).then(()=>parcelRequire('bieQm'));

});

parcelRegister("ahaQo", function(module, exports) {
/**
 * @generated SignedSource<<eed3a7318712d46b36519552e61c16fa>>
 * @relayHash bd4580f0053e11ae636049ae3c53b81c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3b089ddec155bf88dc83de4288cc5473c2c1929d6f169e0b96946e0d58c7f256

var $3e6Uc = parcelRequire("3e6Uc");

const $b68e48383073c56a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = [
        {
            "kind": "ScalarField",
            "name": "experienceUrl"
        }
    ], v4 = {
        "concreteType": "CcpEntitlementExperienceCapabilities",
        "kind": "LinkedField",
        "name": "experienceCapabilities",
        "plural": false,
        "selections": [
            {
                "alias": "changeOfferingPremium",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "offeringName",
                        "value": "Premium"
                    }
                ],
                "concreteType": "CcpChangeOfferingExperienceCapability",
                "kind": "LinkedField",
                "name": "changeOfferingV2",
                "plural": false,
                "selections": v3 /*: any*/ ,
                "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
            },
            {
                "alias": "compareOfferingsStandardHighlighted",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "input",
                        "value": {
                            "highlightedOffering": {
                                "offeringName": "Standard"
                            }
                        }
                    }
                ],
                "concreteType": "CcpCompareOfferingsExperienceCapability",
                "kind": "LinkedField",
                "name": "compareOfferings",
                "plural": false,
                "selections": v3 /*: any*/ ,
                "storageKey": "compareOfferings(input:{\"highlightedOffering\":{\"offeringName\":\"Standard\"}})"
            },
            {
                "alias": "compareOfferingsPremiumHighlighted",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "input",
                        "value": {
                            "highlightedOffering": {
                                "offeringName": "Premium"
                            }
                        }
                    }
                ],
                "concreteType": "CcpCompareOfferingsExperienceCapability",
                "kind": "LinkedField",
                "name": "compareOfferings",
                "plural": false,
                "selections": v3 /*: any*/ ,
                "storageKey": "compareOfferings(input:{\"highlightedOffering\":{\"offeringName\":\"Premium\"}})"
            }
        ]
    }, v5 = {
        "concreteType": "ConfluenceStorage",
        "kind": "LinkedField",
        "name": "confluence_storage",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isUnlimited"
            },
            {
                "kind": "ScalarField",
                "name": "bytesUsed"
            },
            {
                "kind": "ScalarField",
                "name": "bytesLimit"
            }
        ]
    }, v6 = {
        "args": [
            {
                "kind": "Variable",
                "name": "tenantId",
                "variableName": "cloudId"
            }
        ],
        "concreteType": "GrowthUnifiedProfileResult",
        "kind": "LinkedField",
        "name": "growthUnifiedProfile_getUnifiedProfile",
        "plural": false,
        "selections": [
            {
                "concreteType": "GrowthUnifiedProfileSiteDetails",
                "kind": "LinkedField",
                "name": "sites",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "GrowthUnifiedProfileProductDetails",
                        "kind": "LinkedField",
                        "name": "products",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "productName"
                            },
                            {
                                "concreteType": "GrowthUnifiedProfileProductNBE",
                                "kind": "LinkedField",
                                "name": "nbeRecommendation",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "edition"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "recommendationDate"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "freeChooseYourEditionModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "CcpEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "CommerceEntitlementInfoCcp"
                                }
                            ]
                        }
                    ]
                },
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "freeChooseYourEditionModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "CcpEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "CommerceEntitlementInfoCcp"
                                }
                            ]
                        }
                    ]
                },
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ]
        },
        "params": {
            "id": "3b089ddec155bf88dc83de4288cc5473c2c1929d6f169e0b96946e0d58c7f256",
            "metadata": {},
            "name": "freeChooseYourEditionModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b68e48383073c56a$var$node.hash = "0e8059c3834ad6cb88d2ac63ac9691cb";
(0, $3e6Uc.PreloadableQueryRegistry).set($b68e48383073c56a$var$node.params.id, $b68e48383073c56a$var$node);
var $b68e48383073c56a$export$2e2bcd8739ae039 = $b68e48383073c56a$var$node;
module.exports["default"] = $b68e48383073c56a$export$2e2bcd8739ae039;

});

parcelRegister("gCo8T", function(module, exports) {

let $c192ec28a57eed70$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c192ec28a57eed70$var$load("4rKYa"),
    $c192ec28a57eed70$var$load("hhss7"),
    $c192ec28a57eed70$var$load("lq3Sl")
]).then(()=>parcelRequire('iKXPM'));

});

parcelRegister("39sTV", function(module, exports) {
/**
 * @generated SignedSource<<6780e886c89d78b413cdd3c90a49aca1>>
 * @relayHash f414c8c351fff5fe86a702b3d5940cf8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b914287c9466ffe442e8832ba3cbc0ec27ded02133bd16d689996ab511d83209

var $3e6Uc = parcelRequire("3e6Uc");

const $3ce1c7d63282fb58$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConfluence"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isJira"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraApplicationKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectType"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldIncludeGUPS"
    }, v6 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v8 = {
        "condition": "isConfluence",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    v6 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "cql",
                        "value": "type=user"
                    },
                    {
                        "kind": "Literal",
                        "name": "excludeServiceAppUsers",
                        "value": true
                    },
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 100
                    }
                ],
                "concreteType": "ConfluenceSearchConnection",
                "kind": "LinkedField",
                "name": "confluence_searchUser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ConfluenceSearchResponse",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "ConfluencePerson",
                                "kind": "LinkedField",
                                "name": "confluencePerson",
                                "plural": false,
                                "selections": [
                                    v7 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "displayName"
                                    },
                                    {
                                        "concreteType": "Icon",
                                        "kind": "LinkedField",
                                        "name": "profilePicture",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "path"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "ConfluenceStorage",
                "kind": "LinkedField",
                "name": "confluence_storage",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isUnlimited"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "bytesUsed"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "bytesLimit"
                    }
                ]
            }
        ]
    }, v9 = {
        "condition": "shouldIncludeGUPS",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "tenantId",
                        "variableName": "cloudId"
                    }
                ],
                "concreteType": "GrowthUnifiedProfileResult",
                "kind": "LinkedField",
                "name": "growthUnifiedProfile_getUnifiedProfile",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "GrowthUnifiedProfileSiteDetails",
                        "kind": "LinkedField",
                        "name": "sites",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "GrowthUnifiedProfileProductDetails",
                                "kind": "LinkedField",
                                "name": "products",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "productName"
                                    },
                                    {
                                        "concreteType": "GrowthUnifiedProfileProductNBE",
                                        "kind": "LinkedField",
                                        "name": "nbeRecommendation",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "edition"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "recommendationDate"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v10 = [
        {
            "kind": "Variable",
            "name": "applicationKey",
            "variableName": "jiraApplicationKey"
        },
        v6 /*: any*/ 
    ], v11 = {
        "args": v10 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageAllowed"
    }, v12 = {
        "args": v10 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageUsed"
    }, v13 = {
        "args": v10 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageIsUnlimited"
    }, v14 = [
        v6 /*: any*/ ,
        {
            "fields": [
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "types.0",
                            "variableName": "projectType"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "types"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v15 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v17 = {
        "kind": "ScalarField",
        "name": "name"
    }, v18 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "freeToStandardModalQuery",
            "selections": [
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                {
                    "condition": "isJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                {
                                    "args": v14 /*: any*/ ,
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": v15 /*: any*/ ,
                                                            "concreteType": "JiraAssignableUsersConnection",
                                                            "kind": "LinkedField",
                                                            "name": "assignableUsers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAssignableUsersEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                v16 /*: any*/ ,
                                                                                v17 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "assignableUsers(first:10)"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "freeToStandardModalQuery",
            "selections": [
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                {
                    "condition": "isJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                {
                                    "args": v14 /*: any*/ ,
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": v15 /*: any*/ ,
                                                            "concreteType": "JiraAssignableUsersConnection",
                                                            "kind": "LinkedField",
                                                            "name": "assignableUsers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAssignableUsersEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "__typename"
                                                                                },
                                                                                v7 /*: any*/ ,
                                                                                v16 /*: any*/ ,
                                                                                v17 /*: any*/ ,
                                                                                v18 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "assignableUsers(first:10)"
                                                        },
                                                        v18 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b914287c9466ffe442e8832ba3cbc0ec27ded02133bd16d689996ab511d83209",
            "metadata": {},
            "name": "freeToStandardModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3ce1c7d63282fb58$var$node.hash = "c472eaeb7d557347cdcd839b736b6cda";
(0, $3e6Uc.PreloadableQueryRegistry).set($3ce1c7d63282fb58$var$node.params.id, $3ce1c7d63282fb58$var$node);
var $3ce1c7d63282fb58$export$2e2bcd8739ae039 = $3ce1c7d63282fb58$var$node;
module.exports["default"] = $3ce1c7d63282fb58$export$2e2bcd8739ae039;

});

parcelRegister("35Kv0", function(module, exports) {

let $2405e879926e1cc5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2405e879926e1cc5$var$load("6wr18"),
    $2405e879926e1cc5$var$load("dNed9"),
    $2405e879926e1cc5$var$load("aE4di"),
    $2405e879926e1cc5$var$load("fjOTL"),
    $2405e879926e1cc5$var$load("cHQ50"),
    $2405e879926e1cc5$var$load("ffEVr"),
    $2405e879926e1cc5$var$load("7EorR"),
    $2405e879926e1cc5$var$load("dTsOE"),
    $2405e879926e1cc5$var$load("iI6Q4")
]).then(()=>parcelRequire('5qPN6'));

});

parcelRegister("hWLJI", function(module, exports) {

let $d10ce1e22f843a61$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d10ce1e22f843a61$var$load("aKXvR").then(()=>parcelRequire('lJ4sZ'));

});

parcelRegister("iL4pO", function(module, exports) {
/**
 * @generated SignedSource<<4a2c299c3370e776909144f2aeddf21a>>
 * @relayHash f8efbc82dcbdf8e7ea9e842b687fdc1e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 139c0d7db1e5c65a657e8eba68202a4fd9b24e66331526d96b03609175ad4f45

var $3e6Uc = parcelRequire("3e6Uc");

const $9e08aeb6d8001eda$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v4 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "planSelectionPageModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "planSelectionPageModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "139c0d7db1e5c65a657e8eba68202a4fd9b24e66331526d96b03609175ad4f45",
            "metadata": {},
            "name": "planSelectionPageModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9e08aeb6d8001eda$var$node.hash = "5856634e7757286e019aec8f127ddc46";
(0, $3e6Uc.PreloadableQueryRegistry).set($9e08aeb6d8001eda$var$node.params.id, $9e08aeb6d8001eda$var$node);
var $9e08aeb6d8001eda$export$2e2bcd8739ae039 = $9e08aeb6d8001eda$var$node;
module.exports["default"] = $9e08aeb6d8001eda$export$2e2bcd8739ae039;

});

parcelRegister("93N5W", function(module, exports) {

let $698a7a10ce5d2179$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $698a7a10ce5d2179$var$load("cDKlY").then(()=>parcelRequire('8HPXq'));

});

parcelRegister("bgz33", function(module, exports) {

let $833c6032faa99ca5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $833c6032faa99ca5$var$load("6wr18"),
    $833c6032faa99ca5$var$load("dNed9"),
    $833c6032faa99ca5$var$load("ffEVr"),
    $833c6032faa99ca5$var$load("4JtX7")
]).then(()=>parcelRequire('mNVHw'));

});

parcelRegister("9bIWo", function(module, exports) {

var $go59p = parcelRequire("go59p");

const $e563f34420ca911e$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'premium-popup',
    dialogType: 'pop-up',
    targetProductEdition: (0, $go59p.Edition).PREMIUM_EDITION
};
module.exports["DIALOG_CONFIG"] = $e563f34420ca911e$export$3b6761b6086f6dfd;

});

parcelRegister("jyZ9o", function(module, exports) {
/**
 * @generated SignedSource<<5821fe529cfc22897c2985ff0ad736c4>>
 * @relayHash f5958739e09e5411147f112f6550ea59
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 477817a92613a7818d8c6b7b9c49bbc1517b2ca7a3bc41a318aaf8920c59e4c7

var $3e6Uc = parcelRequire("3e6Uc");

const $6b28b4501f8a29ae$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v4 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "confluencePremiumPopupQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "confluencePremiumPopupQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "477817a92613a7818d8c6b7b9c49bbc1517b2ca7a3bc41a318aaf8920c59e4c7",
            "metadata": {},
            "name": "confluencePremiumPopupQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6b28b4501f8a29ae$var$node.hash = "42c226cd7fc904c05729c90bcaaed23e";
(0, $3e6Uc.PreloadableQueryRegistry).set($6b28b4501f8a29ae$var$node.params.id, $6b28b4501f8a29ae$var$node);
var $6b28b4501f8a29ae$export$2e2bcd8739ae039 = $6b28b4501f8a29ae$var$node;
module.exports["default"] = $6b28b4501f8a29ae$export$2e2bcd8739ae039;

});

parcelRegister("8LOgh", function(module, exports) {

let $6629b36e5a3f4ae9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6629b36e5a3f4ae9$var$load("6wr18"),
    $6629b36e5a3f4ae9$var$load("5uN9h"),
    $6629b36e5a3f4ae9$var$load("ffEVr"),
    $6629b36e5a3f4ae9$var$load("ki3nq")
]).then(()=>parcelRequire('k4oWo'));

});

parcelRegister("g73ad", function(module, exports) {
/**
 * @generated SignedSource<<9e7ab9d82c11f650f2bdc01edf024c90>>
 * @relayHash fb387ee4c17d62b6ce4867baf6061884
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fe23b73929c26e3fa0b23fad14fc6c713c94abcd8a87983ce3d62e052dbade3b

var $3e6Uc = parcelRequire("3e6Uc");

const $a453255c2053f7c3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "offeringName",
            "value": "Free"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "reverseTrialPopupQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Free\")"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "reverseTrialPopupQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Free\")"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fe23b73929c26e3fa0b23fad14fc6c713c94abcd8a87983ce3d62e052dbade3b",
            "metadata": {},
            "name": "reverseTrialPopupQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a453255c2053f7c3$var$node.hash = "7149df0cbb7841476e95591ab561c360";
(0, $3e6Uc.PreloadableQueryRegistry).set($a453255c2053f7c3$var$node.params.id, $a453255c2053f7c3$var$node);
var $a453255c2053f7c3$export$2e2bcd8739ae039 = $a453255c2053f7c3$var$node;
module.exports["default"] = $a453255c2053f7c3$export$2e2bcd8739ae039;

});

parcelRegister("3LH0H", function(module, exports) {

let $2be71fda1478adc3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2be71fda1478adc3$var$load("6wr18"),
    $2be71fda1478adc3$var$load("5uN9h"),
    $2be71fda1478adc3$var$load("hhss7"),
    $2be71fda1478adc3$var$load("ffEVr"),
    $2be71fda1478adc3$var$load("7YE3I")
]).then(()=>parcelRequire('1LwFo'));

});

parcelRegister("4ZyWk", function(module, exports) {
/**
 * @generated SignedSource<<e13bd47da081d26d9973b8612665a27f>>
 * @relayHash 18a19388990ad5495499cf916821c41f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 54b26d57473f480c736b713e1e344d4254fcb367d0d9cf5696dca539e63b93c1

var $3e6Uc = parcelRequire("3e6Uc");

const $16ba82cb9fe75b21$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectType"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "fields": [
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "types.0",
                            "variableName": "projectType"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "types"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "specialOfferSixtyModalQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v2 /*: any*/ ,
                                                    "concreteType": "JiraAssignableUsersConnection",
                                                    "kind": "LinkedField",
                                                    "name": "assignableUsers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraAssignableUsersEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v3 /*: any*/ ,
                                                                        v4 /*: any*/ ,
                                                                        v5 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "assignableUsers(first:10)"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "specialOfferSixtyModalQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v2 /*: any*/ ,
                                                    "concreteType": "JiraAssignableUsersConnection",
                                                    "kind": "LinkedField",
                                                    "name": "assignableUsers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraAssignableUsersEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "__typename"
                                                                        },
                                                                        v3 /*: any*/ ,
                                                                        v4 /*: any*/ ,
                                                                        v5 /*: any*/ ,
                                                                        v6 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "assignableUsers(first:10)"
                                                },
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "54b26d57473f480c736b713e1e344d4254fcb367d0d9cf5696dca539e63b93c1",
            "metadata": {},
            "name": "specialOfferSixtyModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$16ba82cb9fe75b21$var$node.hash = "8897785224a240053607a72b915d6145";
(0, $3e6Uc.PreloadableQueryRegistry).set($16ba82cb9fe75b21$var$node.params.id, $16ba82cb9fe75b21$var$node);
var $16ba82cb9fe75b21$export$2e2bcd8739ae039 = $16ba82cb9fe75b21$var$node;
module.exports["default"] = $16ba82cb9fe75b21$export$2e2bcd8739ae039;

});

parcelRegister("a5LT7", function(module, exports) {

let $758f8492b1db7420$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $758f8492b1db7420$var$load("6wr18"),
    $758f8492b1db7420$var$load("dNed9"),
    $758f8492b1db7420$var$load("3opZo"),
    $758f8492b1db7420$var$load("kyUks"),
    $758f8492b1db7420$var$load("ffEVr"),
    $758f8492b1db7420$var$load("7EorR"),
    $758f8492b1db7420$var$load("dTsOE"),
    $758f8492b1db7420$var$load("iFA9H")
]).then(()=>parcelRequire('5884z'));

});

parcelRegister("605Gj", function(module, exports) {
/**
 * @generated SignedSource<<5568e86e767c1f7e601e3156c2ec0fd2>>
 * @relayHash 081ae02dbc9e7d3009e7fbdca4492722
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7e0de08a75b889e79cd9fefc7277283b171871d0347b99f590cc073558ab0ab9

var $3e6Uc = parcelRequire("3e6Uc");

const $9a20a5bf41c0e83d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "chargeElement"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hamsProductKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConfluence"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isJira"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraApplicationKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectType"
    }, v7 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v9 = {
        "args": [
            {
                "kind": "Variable",
                "name": "chargeElement",
                "variableName": "chargeElement"
            }
        ],
        "kind": "ScalarField",
        "name": "latestUsageForChargeElement"
    }, v10 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v11 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v12 = {
        "condition": "isConfluence",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    v10 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "cql",
                        "value": "type=user"
                    },
                    {
                        "kind": "Literal",
                        "name": "excludeServiceAppUsers",
                        "value": true
                    },
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 100
                    }
                ],
                "concreteType": "ConfluenceSearchConnection",
                "kind": "LinkedField",
                "name": "confluence_searchUser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ConfluenceSearchResponse",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "ConfluencePerson",
                                "kind": "LinkedField",
                                "name": "confluencePerson",
                                "plural": false,
                                "selections": [
                                    v11 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "displayName"
                                    },
                                    {
                                        "concreteType": "Icon",
                                        "kind": "LinkedField",
                                        "name": "profilePicture",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "path"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "ConfluenceStorage",
                "kind": "LinkedField",
                "name": "confluence_storage",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isUnlimited"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "bytesUsed"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "bytesLimit"
                    }
                ]
            }
        ]
    }, v13 = [
        {
            "kind": "Variable",
            "name": "applicationKey",
            "variableName": "jiraApplicationKey"
        },
        v10 /*: any*/ 
    ], v14 = {
        "args": v13 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageAllowed"
    }, v15 = {
        "args": v13 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageUsed"
    }, v16 = {
        "args": v13 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageIsUnlimited"
    }, v17 = [
        v10 /*: any*/ ,
        {
            "fields": [
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "types.0",
                            "variableName": "projectType"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "types"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v18 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v19 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v20 = {
        "kind": "ScalarField",
        "name": "name"
    }, v21 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v22 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "standardAddPaymentModalQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v12 /*: any*/ ,
                {
                    "condition": "isJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                {
                                    "args": v17 /*: any*/ ,
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": v18 /*: any*/ ,
                                                            "concreteType": "JiraAssignableUsersConnection",
                                                            "kind": "LinkedField",
                                                            "name": "assignableUsers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAssignableUsersEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v11 /*: any*/ ,
                                                                                v19 /*: any*/ ,
                                                                                v20 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "assignableUsers(first:10)"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "standardAddPaymentModalQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v21 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v21 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v22 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v12 /*: any*/ ,
                {
                    "condition": "isJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                {
                                    "args": v17 /*: any*/ ,
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": v18 /*: any*/ ,
                                                            "concreteType": "JiraAssignableUsersConnection",
                                                            "kind": "LinkedField",
                                                            "name": "assignableUsers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAssignableUsersEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v21 /*: any*/ ,
                                                                                v11 /*: any*/ ,
                                                                                v19 /*: any*/ ,
                                                                                v20 /*: any*/ ,
                                                                                v22 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "assignableUsers(first:10)"
                                                        },
                                                        v22 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7e0de08a75b889e79cd9fefc7277283b171871d0347b99f590cc073558ab0ab9",
            "metadata": {},
            "name": "standardAddPaymentModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9a20a5bf41c0e83d$var$node.hash = "1a2deb9f2ae9b251077ad9a1cce4e589";
(0, $3e6Uc.PreloadableQueryRegistry).set($9a20a5bf41c0e83d$var$node.params.id, $9a20a5bf41c0e83d$var$node);
var $9a20a5bf41c0e83d$export$2e2bcd8739ae039 = $9a20a5bf41c0e83d$var$node;
module.exports["default"] = $9a20a5bf41c0e83d$export$2e2bcd8739ae039;

});

parcelRegister("ibGYw", function(module, exports) {

let $d3da970593913765$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d3da970593913765$var$load("6wr18"),
    $d3da970593913765$var$load("dNed9"),
    $d3da970593913765$var$load("aE4di"),
    $d3da970593913765$var$load("cHQ50"),
    $d3da970593913765$var$load("ffEVr"),
    $d3da970593913765$var$load("7EorR"),
    $d3da970593913765$var$load("dTsOE"),
    $d3da970593913765$var$load("eCMUX")
]).then(()=>parcelRequire('3OMxQ'));

});

parcelRegister("h2tsx", function(module, exports) {

let $c679798c8c50b1c3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c679798c8c50b1c3$var$load("6wr18"),
    $c679798c8c50b1c3$var$load("dNed9"),
    $c679798c8c50b1c3$var$load("fjOTL"),
    $c679798c8c50b1c3$var$load("ffEVr"),
    $c679798c8c50b1c3$var$load("lLln8")
]).then(()=>parcelRequire('55CAD'));

});

parcelRegister("e4o8D", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $2679ebd914f0a083$export$96e8e9e8e57310bb = (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const renderServerPlaceholderOnNonHydrate = t0 === undefined ? false : t0;
    const isTransition = window.__SSR_RENDERED__ === false;
    const [renderServerPlaceholder, setRenderServerPlaceholder] = (0, $42omo.useState)(renderServerPlaceholderOnNonHydrate ? !isTransition || Boolean(undefined) : window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setRenderServerPlaceholder(false);
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $42omo.useEffect)(t1, t2);
    return renderServerPlaceholder;
};
module.exports["useRenderServerPlaceholder"] = $2679ebd914f0a083$export$96e8e9e8e57310bb;

});

parcelRegister("hY10E", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $917iu = parcelRequire("917iu");


var $bQm3c = parcelRequire("bQm3c");


var $9wGTI = parcelRequire("9wGTI");


var $1ytiN = parcelRequire("1ytiN");


var $euL71 = parcelRequire("euL71");


var $kAcNG = parcelRequire("kAcNG");


var $a119A = parcelRequire("a119A");

const $8853af7e8236bde8$export$4695bad538a258b4 = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isPremium = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    // SignUpProperties that are sent from BXP
    const { isReverseTrialer: isReverseTrialer, loading: loading, error: error } = $8853af7e8236bde8$export$153e1a2894ed595({
        skip: !isSiteAdmin || !isPremium
    });
    // Master FF to quickly enable / disable all Onboarding Experiences
    const isReverseTrialEligibleUser = isSiteAdmin && isPremium && (0, $9wGTI.fg)('cc_onboarding_experience');
    const isReverseTrialTreatmentCohort = !loading && !error && isReverseTrialer;
    return {
        isReverseTrialEligible: isReverseTrialEligibleUser && isReverseTrialTreatmentCohort
    };
};
function $8853af7e8236bde8$export$153e1a2894ed595({ skip: skip } = {}) {
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { data: reverseTrialData, loading: isReverseTrialLoading, error: reverseTrialError } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useReverseTrialEligibleSignUpPropertiesQuery{signUpProperties{reverseTrial}}`, {
        skip: skip
    });
    const { loading: isSitePersonalizationLoading, error: sitePersonalizationError, attributes: attributes } = (0, $kAcNG.useSitePersonalizationQuery)({
        cloudId: cloudId,
        skip: skip
    });
    const TRIAL_PERIOD_DAYS = 45;
    let isWithinFirstTrialPeriod = true; // Default to true because if the activation date is not available, this means that the site was recently provisioned
    const activationDateAttr = attributes?.find((attr)=>attr.name === 'confluence.ondemand.activationDate');
    if (activationDateAttr && activationDateAttr.value) {
        const activationDate = new Date(activationDateAttr.value);
        const daysSinceActivation = (0, $917iu.default)(new Date(), activationDate);
        isWithinFirstTrialPeriod = daysSinceActivation <= TRIAL_PERIOD_DAYS;
    }
    const reverseTrialCohort = reverseTrialData?.signUpProperties?.reverseTrial;
    return {
        isReverseTrialer: isWithinFirstTrialPeriod && reverseTrialCohort === (0, $a119A.ReverseTrialCohort).ENROLLED,
        reverseTrialCohort: reverseTrialCohort,
        loading: skip ? false : isReverseTrialLoading || isSitePersonalizationLoading,
        error: skip ? null : reverseTrialError || sitePersonalizationError
    };
}
module.exports["useReverseTrialCohort"] = $8853af7e8236bde8$export$153e1a2894ed595;

});

parcelRegister("kAcNG", function(module, exports) {

var $8Lx5S = parcelRequire("8Lx5S");


var $1uFM6 = parcelRequire("1uFM6");


var $aMcHK = parcelRequire("aMcHK");


var $hcDKy = parcelRequire("hcDKy");

let $a3e54b7319a42934$export$98a405b08ebbac37 = false;
const $a3e54b7319a42934$export$3cfde1d6c626a865 = ({ cloudId: cloudId, skip: skip, fetchPolicy: fetchPolicy })=>{
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const skipOptions = skip || !isLicensed || $a3e54b7319a42934$export$98a405b08ebbac37 || // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    Boolean(undefined); // SitePersonalizationQuery isn't preloaded and can be skipped during SSR to avoid unnecessary requests
    const { data: data, loading: loading, error: error } = (0, $hcDKy.useExperimentalSitePersonalizationQuery)({
        variables: {
            cloudId: cloudId
        },
        fetchPolicy: fetchPolicy || 'cache-first',
        skip: skipOptions,
        onError (apolloError) {
            $a3e54b7319a42934$export$98a405b08ebbac37 = apolloError?.graphQLErrors?.some((graphQLError)=>(0, $aMcHK.isStatusCodeError)(graphQLError, '401') || (0, $1uFM6.isUnauthorizedError)(graphQLError));
        }
    });
    const attributes = data?.experimentalSitePersonalization?.attributes || [];
    return {
        loading: loading,
        error: error,
        attributes: attributes
    };
};
module.exports["useSitePersonalizationQuery"] = $a3e54b7319a42934$export$3cfde1d6c626a865;

});

parcelRegister("hcDKy", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $CIjCq = parcelRequire("CIjCq");

const $c7a26f042941282d$export$f9ec68434a742b9f = ({ skip: skip, onError: onError, variables: variables, fetchPolicy: fetchPolicy })=>{
    return (0, $dK51B.useExperimentalQuery)({
        url: ({ cloudId: cloudId })=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`,
        method: 'GET',
        parseResult: (json)=>({
                experimentalSitePersonalization: {
                    attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(json.attributes)
                }
            }),
        skip: skip,
        onError: onError,
        variables: variables,
        fetchPolicy: fetchPolicy
    });
};
module.exports["useExperimentalSitePersonalizationQuery"] = $c7a26f042941282d$export$f9ec68434a742b9f;

});

parcelRegister("a119A", function(module, exports) {
/**
 * @generated SignedSource<<7c96ffe5db93bb7b8bc74d6411281d3b>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/ var $15e6aec9d603aba5$export$8798225e6f84b893 = /*#__PURE__*/ function(ReverseTrialCohort) {
    ReverseTrialCohort["CONTROL"] = "CONTROL";
    ReverseTrialCohort["ENROLLED"] = "ENROLLED";
    ReverseTrialCohort["NOT_ENROLLED"] = "NOT_ENROLLED";
    ReverseTrialCohort["UNASSIGNED"] = "UNASSIGNED";
    ReverseTrialCohort["UNKNOWN"] = "UNKNOWN";
    ReverseTrialCohort["VARIANT"] = "VARIANT";
    return ReverseTrialCohort;
}({});
module.exports["ReverseTrialCohort"] = $15e6aec9d603aba5$export$8798225e6f84b893;

});

parcelRegister("2708F", function(module, exports) {

let $189c57cc34672e5c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $189c57cc34672e5c$var$load("60S8F").then(()=>parcelRequire('8JC1j'));

});

parcelRegister("aXjWU", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6d6c82fa2f331bd2$var$initialActiveTriggerState = {
    activeTriggerState: {
        activeTriggerId: undefined
    }
};
const $6d6c82fa2f331bd2$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $6d6c82fa2f331bd2$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($6d6c82fa2f331bd2$var$initialActiveTriggerState);
const $6d6c82fa2f331bd2$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($6d6c82fa2f331bd2$var$initialTriggerDispatchState);
const $6d6c82fa2f331bd2$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [activeTriggerState, setActiveTriggerState] = (0, $42omo.useState)($6d6c82fa2f331bd2$var$initialActiveTriggerState.activeTriggerState);
    const setTriggerState = (0, $42omo.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setActiveTriggerState((current)=>{
            const hasStateChanged = current.activeTriggerId !== triggerId || current.activeTriggerId === triggerId && isActive === false;
            if (!hasStateChanged) return current;
            if (isActive) return {
                activeTriggerId: triggerId
            };
            return {
                activeTriggerId: undefined
            };
        });
    }, []);
    const triggerContextValue = (0, $42omo.useMemo)(()=>({
            activeTriggerState: activeTriggerState
        }), [
        activeTriggerState
    ]);
    const triggerContexDispatchValue = (0, $42omo.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d6c82fa2f331bd2$var$TriggerContext.Provider, {
        value: triggerContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d6c82fa2f331bd2$var$TriggerDispatchContext.Provider, {
        value: triggerContexDispatchValue
    }, children));
};
const $6d6c82fa2f331bd2$export$454c1d7c35958f5e = ()=>(0, $42omo.useContext)($6d6c82fa2f331bd2$var$TriggerContext);
const $6d6c82fa2f331bd2$export$23cbf084e08bdb93 = ()=>(0, $42omo.useContext)($6d6c82fa2f331bd2$var$TriggerDispatchContext);
const $6d6c82fa2f331bd2$export$3b196fe93a948c18 = (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $6d6c82fa2f331bd2$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: activeTriggerState.activeTriggerId === triggerId
    } : {
        isActive: undefined
    };
};
const $6d6c82fa2f331bd2$export$83b33e5fe4cce64 = ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $6d6c82fa2f331bd2$export$23cbf084e08bdb93();
    const fireTrigger = (0, $42omo.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};
const $6d6c82fa2f331bd2$export$e45375ff75169f = (messageId)=>{
    // listeners
    const { isActive: hasMessageStarted } = $6d6c82fa2f331bd2$export$3b196fe93a948c18(`${messageId}-started`);
    // actions
    const { fireTrigger: requestMessageStartTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: fireDismissClickTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-dismiss`
    });
    const { fireTrigger: fireCtaClickTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-cta-click`
    });
    const requestMessageStart = (0, $42omo.useCallback)(()=>{
        requestMessageStartTrigger({
            isActive: true
        });
    }, [
        requestMessageStartTrigger
    ]);
    const dismissMessage = (0, $42omo.useCallback)(()=>{
        fireDismissClickTrigger({
            isActive: true
        });
    }, [
        fireDismissClickTrigger
    ]);
    const handlePostOfficeClickTracking = (0, $42omo.useCallback)(()=>{
        fireCtaClickTrigger({
            isActive: true
        });
    }, [
        fireCtaClickTrigger
    ]);
    return {
        hasMessageStarted: hasMessageStarted,
        requestMessageStart: requestMessageStart,
        dismissMessage: dismissMessage,
        handlePostOfficeClickTracking: handlePostOfficeClickTracking
    };
};
module.exports["TriggerContextProvider"] = $6d6c82fa2f331bd2$export$e80a5720bb4c8fe3;
module.exports["useTrigger"] = $6d6c82fa2f331bd2$export$3b196fe93a948c18;
module.exports["useFirePostOfficeTrigger"] = $6d6c82fa2f331bd2$export$83b33e5fe4cce64;
module.exports["usePostOfficeExernalMessageProxy"] = $6d6c82fa2f331bd2$export$e45375ff75169f;

});

parcelRegister("lwNi3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $04e9M = parcelRequire("04e9M");


var $jOtRZ = parcelRequire("jOtRZ");


var $lBR3p = parcelRequire("lBR3p");

const $5efec5cf952678ca$export$ddc368dc94a41e62 = (withChoreographer = true)=>{
    const { cloudId: cloudId, activationId: activationId, environment: environment } = (0, $bQm3c.useSessionData)();
    const workspaceId = (0, $04e9M.getWorkspaceId)(cloudId, activationId);
    const disableEngagementForTests = sessionStorage.getItem('confluence.disable-engagement-for-tests') === 'true';
    const envType = (0, $jOtRZ.useAnalyticsEnvironment)(environment);
    return (0, $42omo.useMemo)(()=>(0, $lBR3p.getCoordinationClient)(disableEngagementForTests, cloudId, workspaceId, withChoreographer, envType), [
        disableEngagementForTests,
        cloudId,
        workspaceId,
        withChoreographer,
        envType
    ]);
};
module.exports["useCoordinationClient"] = $5efec5cf952678ca$export$ddc368dc94a41e62;

});

parcelRegister("lBR3p", function(module, exports) {

var $5loD0 = parcelRequire("5loD0");


var $fw9LG = parcelRequire("fw9LG");

const $b379edbfb382bc54$var$noop = async ()=>false;
const $b379edbfb382bc54$export$a3f969ef7d35205d = (disableEngagementForTests, cloudId, workspaceId, enableChoreographer, environment)=>{
    if (disableEngagementForTests) return {
        start: $b379edbfb382bc54$var$noop,
        stop: $b379edbfb382bc54$var$noop
    };
    else {
        const coordinationOptions = {
            enableChoreographer: enableChoreographer,
            envType: environment,
            additionalData: {
                sourceProductId: (0, $fw9LG.ProductIds).CONFLUENCE
            }
        };
        return new (0, $5loD0.default)({
            cloudId: cloudId,
            stargateUrl: '/gateway/api',
            isFedRAMPEnvironment: false,
            workspaceId: workspaceId,
            coordinationOptions: coordinationOptions
        });
    }
};
module.exports["getCoordinationClient"] = $b379edbfb382bc54$export$a3f969ef7d35205d;

});

parcelRegister("5loD0", function(module, exports) {

var $ll2sR = parcelRequire("ll2sR");


var $4nGsu = parcelRequire("4nGsu");

class $4b61f610720049a6$export$2e2bcd8739ae039 {
    async start(messageId, variationId) {
        if (!(0, $4nGsu.isMessagingEnabled)()) return false;
        return (0, $ll2sR.startMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            variationId: variationId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
    async stop(messageId) {
        if (!(0, $4nGsu.isMessagingEnabled)()) return false;
        return (0, $ll2sR.stopMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
    constructor(configOrCloudId, stargateUrl){
        this.cloudId = void 0;
        this.stargateUrl = void 0;
        this.orgId = void 0;
        this.workspaceId = void 0;
        this.coordinationOptions = void 0;
        let config;
        if (typeof configOrCloudId === 'string') config = {
            cloudId: configOrCloudId,
            stargateUrl: stargateUrl,
            isFedRAMPEnvironment: false
        };
        else config = configOrCloudId;
        if (!config.cloudId || !config.stargateUrl) throw new Error('Need a valid CloudId and Stargate url');
        this.cloudId = config.cloudId;
        this.stargateUrl = config.stargateUrl;
        this.orgId = config.orgId;
        this.workspaceId = config.workspaceId;
        this.coordinationOptions = config.coordinationOptions;
    }
}
module.exports["default"] = $4b61f610720049a6$export$2e2bcd8739ae039;

});

parcelRegister("lbbQA", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");

const $2040c63a9f59b807$var$AUTO_PROVISIONING_D0_EXPERIMENT_TRAIT_NAME = 'is_jira_confluence_d0_auto-provisioned';
const $2040c63a9f59b807$var$fetchPersonalizationSiteUserTraits = async (cloudId)=>{
    const response = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`);
    return response.json();
};
const $2040c63a9f59b807$export$7c4b9b835380d869 = async (cloudId)=>{
    if (!cloudId) return null;
    const siteUserTraitsData = await $2040c63a9f59b807$var$fetchPersonalizationSiteUserTraits(cloudId);
    if (!siteUserTraitsData || !siteUserTraitsData.attributes) return null;
    const trait = siteUserTraitsData.attributes.find((att)=>att.name === $2040c63a9f59b807$var$AUTO_PROVISIONING_D0_EXPERIMENT_TRAIT_NAME);
    return trait ? trait.value : null;
};
module.exports["getAutoProvisioningTapTrait"] = $2040c63a9f59b807$export$7c4b9b835380d869;

});

parcelRegister("c1nt3", function(module, exports) {
const $2353b1143751815c$export$a27c21aa3ed8f0f1 = (createAnalyticsEvent, reason, attributes)=>{
    createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            source: 'confluence',
            action: 'error',
            actionSubject: 'experiment',
            attributes: {
                reason: reason,
                experimentKey: 'jsw_confluence_day_0_auto_provision',
                ...attributes
            }
        }
    }).fire();
};
const $2353b1143751815c$export$e5b4271d9c5c1be6 = (createAnalyticsEvent, action, actionSubject, attributes)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            source: 'confluence',
            action: 'succeeded',
            actionSubject: 'dataFetchStep',
            attributes: {
                experimentKey: 'jsw_confluence_day_0_auto_provision',
                step: actionSubject + action,
                ...attributes
            }
        }
    }).fire();
};
module.exports["fireErrorAnalytics"] = $2353b1143751815c$export$a27c21aa3ed8f0f1;
module.exports["fireSuccessAnalytics"] = $2353b1143751815c$export$e5b4271d9c5c1be6;

});

parcelRegister("8yYKd", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $b16abfc5e83ea805$var$initialState = {
    isOpen: false
};
const $b16abfc5e83ea805$var$actions = {
    setIsOpen: (isOpen)=>({ setState: setState })=>{
            setState({
                isOpen: isOpen
            });
        }
};
const $b16abfc5e83ea805$export$6f57813fe9f31bf9 = (0, $1P1Tu.createStore)({
    initialState: $b16abfc5e83ea805$var$initialState,
    actions: $b16abfc5e83ea805$var$actions,
    name: 'ActionMenuOpenStore'
});
const $b16abfc5e83ea805$export$10a1cd82ade4795b = (0, $9zUhf.createHook)($b16abfc5e83ea805$export$6f57813fe9f31bf9);
const $b16abfc5e83ea805$export$fca68ed490dc18f9 = (0, $9zUhf.createActionsHook)($b16abfc5e83ea805$export$6f57813fe9f31bf9);
module.exports["useOpenActionMenuState"] = $b16abfc5e83ea805$export$10a1cd82ade4795b;
module.exports["useOpenActionMenuActions"] = $b16abfc5e83ea805$export$fca68ed490dc18f9;

});

parcelRegister("cLo2u", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $7zgzO = parcelRequire("7zgzO");

function $91bacb73ef37142f$export$12ed3d1363567203(spaceKey) {
    const $ = (0, $frIzR.c)(1);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = typeof document !== "undefined" ? document.querySelector("meta#confluence-space-key")?.content : null;
        $[0] = t0;
    } else t0 = $[0];
    const documentMetaSpaceKey = t0;
    return documentMetaSpaceKey ?? null;
}
module.exports["useSpaceKey"] = $91bacb73ef37142f$export$12ed3d1363567203;

});

parcelRegister("bZSO8", function(module, exports) {

var $c3Qwv = parcelRequire("c3Qwv");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $hQnHK = parcelRequire("hQnHK");


var $6mKj3 = parcelRequire("6mKj3");


var $98wxI = parcelRequire("98wxI");

const $e7afa99020494478$var$queryParamKeys = {
    subType: 'subType',
    parentPageId: 'parentPageId',
    title: 'title',
    draftId: 'draftId',
    linkCreation: 'linkCreation',
    fromPageId: 'fromPageId',
    // used by createpage.action endpoint.
    spaceKey: 'spaceKey',
    source: 'source',
    withFallback: 'withFallback',
    openTemplatesGallery: 'openTemplatesGallery',
    paywallStatus: 'paywallStatus',
    deactivationIdentifier: 'deactivationIdentifier',
    openJiraImportTool: (0, $hQnHK.JIRA_IMPORT_TOOL_QUERY_PARAM),
    cloudId: (0, $hQnHK.CLOUD_ID),
    projectUuid: (0, $hQnHK.PROJECT_UUID),
    autoImportJiraIssues: (0, $hQnHK.AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM),
    jiraImportJql: (0, $hQnHK.JIRA_IMPORT_JQL),
    insertTemplateWithKey: (0, $hQnHK.INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM),
    smartLinkCreateSource: 'smartLinkCreateSource',
    smartLinkEmbedUrl: 'smartLinkEmbedUrl',
    restoreVersionContentId: 'restoreVersionContentId',
    openTemplatePicker: 'openTemplatePicker',
    journeyId: 'journeyId',
    templateKey: 'templateKey'
};
const $e7afa99020494478$var$SUPPORTED_CONTENT_TYPES = [
    'page',
    'blog',
    'whiteboard',
    'database',
    'smartLinkEmbed',
    'folder'
];
const $e7afa99020494478$export$b3086acbf0304043 = (options)=>{
    const queryParams = {};
    if ('subType' in options && options.subType) queryParams[$e7afa99020494478$var$queryParamKeys.subType] = options.subType;
    if ('spaceKey' in options && options.spaceKey) queryParams[$e7afa99020494478$var$queryParamKeys.spaceKey] = options.spaceKey;
    if ('parentPageId' in options && options.parentPageId) queryParams[$e7afa99020494478$var$queryParamKeys.parentPageId] = options.parentPageId;
    if ('openTemplatePicker' in options && options.openTemplatePicker !== undefined) queryParams[$e7afa99020494478$var$queryParamKeys.openTemplatePicker] = options.openTemplatePicker;
    if ('title' in options && options.title) queryParams[$e7afa99020494478$var$queryParamKeys.title] = options.title;
    if ('draftId' in options && options.draftId) queryParams[$e7afa99020494478$var$queryParamKeys.draftId] = options.draftId;
    if ('linkCreation' in options && options.linkCreation) queryParams[$e7afa99020494478$var$queryParamKeys.linkCreation] = options.linkCreation;
    if ('withFallback' in options && options.withFallback) queryParams[$e7afa99020494478$var$queryParamKeys.withFallback] = options.withFallback;
    if ('openTemplatesGallery' in options && options.openTemplatesGallery) queryParams[$e7afa99020494478$var$queryParamKeys.openTemplatesGallery] = options.openTemplatesGallery;
    if ('source' in options && options.source) queryParams[$e7afa99020494478$var$queryParamKeys.source] = options.source;
    if ('paywallStatus' in options && options.paywallStatus) queryParams[$e7afa99020494478$var$queryParamKeys.paywallStatus] = options.paywallStatus;
    if ('deactivationIdentifier' in options && options.deactivationIdentifier) queryParams[$e7afa99020494478$var$queryParamKeys.deactivationIdentifier] = options.deactivationIdentifier;
    if ((0, $hQnHK.JIRA_IMPORT_TOOL_QUERY_PARAM) in options && options.openJiraImportTool) queryParams[$e7afa99020494478$var$queryParamKeys.openJiraImportTool] = options.openJiraImportTool;
    if ((0, $hQnHK.CLOUD_ID) in options && options.cloudId) queryParams[$e7afa99020494478$var$queryParamKeys.cloudId] = options.cloudId;
    if ((0, $hQnHK.PROJECT_UUID) in options && options.projectUuid) queryParams[$e7afa99020494478$var$queryParamKeys.projectUuid] = options.projectUuid;
    if ((0, $hQnHK.AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM) in options && options.autoImportJiraIssues) queryParams[$e7afa99020494478$var$queryParamKeys.autoImportJiraIssues] = options.autoImportJiraIssues;
    if ((0, $hQnHK.JIRA_IMPORT_JQL) in options && options.jiraImportJql) queryParams[$e7afa99020494478$var$queryParamKeys.jiraImportJql] = options.jiraImportJql;
    if ((0, $hQnHK.INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM) in options && options.insertTemplateWithKey) queryParams[$e7afa99020494478$var$queryParamKeys.insertTemplateWithKey] = options.insertTemplateWithKey;
    if ('smartLinkCreateSource' in options && options.smartLinkCreateSource) queryParams[$e7afa99020494478$var$queryParamKeys.smartLinkCreateSource] = options.smartLinkCreateSource;
    if ('smartLinkEmbedUrl' in options && options.smartLinkEmbedUrl) queryParams[$e7afa99020494478$var$queryParamKeys.smartLinkEmbedUrl] = options.smartLinkEmbedUrl;
    if ('restoreVersionContentId' in options && options.restoreVersionContentId) queryParams[$e7afa99020494478$var$queryParamKeys.restoreVersionContentId] = options.restoreVersionContentId;
    if ('journeyId' in options && options.journeyId) queryParams[$e7afa99020494478$var$queryParamKeys.journeyId] = options.journeyId;
    if ('templateKey' in options && options.templateKey) queryParams[$e7afa99020494478$var$queryParamKeys.templateKey] = options.templateKey;
    return (0, $1NBp8.CREATE_CONTENT).toUrl({
        contentType: options.contentType
    }, {
        query: queryParams
    });
};
const $e7afa99020494478$var$useContentType = (0, $dPJCf.createRouteParamHook)('contentType');
const $e7afa99020494478$export$963d972ae7433a64 = ()=>{
    const contentType = $e7afa99020494478$var$useContentType();
    if ($e7afa99020494478$var$SUPPORTED_CONTENT_TYPES.includes(contentType)) {
        if (contentType === "folder" && !(0, $6mKj3.UNSAFE_expValNoExposure)("cfind-4930-get-started-doc-notification", "isEnabled", false)) return;
        return contentType;
    }
};
const $e7afa99020494478$export$67c4cee80a3410cd = (queryParams)=>{
    const subType = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.subType);
    const spaceKey = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.spaceKey);
    const parentPageId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.parentPageId);
    const title = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.title);
    const draftId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.draftId);
    const linkCreation = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.linkCreation);
    const fromPageId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.fromPageId);
    const withFallback = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.withFallback) ? true : undefined;
    const openTemplatesGallery = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openTemplatesGallery) ? true : undefined;
    const source = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.source);
    const deactivationIdentifier = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.deactivationIdentifier);
    const paywallStatus = (0, $98wxI.PaywallStatus)[(0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.paywallStatus) || ''];
    const openJiraImportTool = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openJiraImportTool) ? true : undefined;
    const cloudId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.cloudId);
    const projectUuid = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.projectUuid);
    const autoImportJiraIssues = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.autoImportJiraIssues) ? true : undefined;
    const jiraImportJql = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.jiraImportJql);
    const insertTemplateWithKey = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.insertTemplateWithKey) ?? undefined;
    const smartLinkCreateSource = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.smartLinkCreateSource);
    const smartLinkEmbedUrl = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.smartLinkEmbedUrl);
    const restoreVersionContentId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.restoreVersionContentId);
    const journeyId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.journeyId);
    const openTemplatePickerParam = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openTemplatePicker);
    const openTemplatePicker = openTemplatePickerParam ? openTemplatePickerParam === 'true' : undefined;
    const templateKey = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.templateKey);
    return {
        subType: subType,
        spaceKey: spaceKey,
        parentPageId: parentPageId || fromPageId,
        title: // prefer new parameter over old parameter
        title,
        draftId: draftId,
        linkCreation: linkCreation,
        withFallback: withFallback,
        source: source,
        paywallStatus: paywallStatus,
        deactivationIdentifier: deactivationIdentifier,
        openJiraImportTool: openJiraImportTool,
        cloudId: cloudId,
        projectUuid: projectUuid,
        autoImportJiraIssues: autoImportJiraIssues,
        jiraImportJql: jiraImportJql,
        insertTemplateWithKey: insertTemplateWithKey,
        smartLinkCreateSource: smartLinkCreateSource,
        smartLinkEmbedUrl: smartLinkEmbedUrl,
        restoreVersionContentId: restoreVersionContentId,
        openTemplatesGallery: openTemplatesGallery,
        openTemplatePicker: openTemplatePicker,
        journeyId: journeyId,
        templateKey: templateKey
    };
};
var $e7afa99020494478$export$f9ad0711e89cafb5 = /*#__PURE__*/ function(ExperienceResolution) {
    ExperienceResolution[ExperienceResolution["ABORT"] = 0] = "ABORT";
    ExperienceResolution[ExperienceResolution["SUCCEED"] = 1] = "SUCCEED";
    return ExperienceResolution;
}({});
module.exports["buildCreationLink"] = $e7afa99020494478$export$b3086acbf0304043;
module.exports["useCreateRouteSupportedContentType"] = $e7afa99020494478$export$963d972ae7433a64;
module.exports["parseQueryParams"] = $e7afa99020494478$export$67c4cee80a3410cd;
module.exports["ExperienceResolution"] = $e7afa99020494478$export$f9ad0711e89cafb5;

});

parcelRegister("hQnHK", function(module, exports) {
const $0037b6bfd6daf741$export$8cda2e6ee87e510b = 'openTemplatePicker';
const $0037b6bfd6daf741$export$2deb4fd8c7cecd6b = 'isNewWhiteboard';
const $0037b6bfd6daf741$export$58465f9d39dce215 = 'insertTemplateWithKey';
const $0037b6bfd6daf741$export$6b4bb9c01a5ea809 = 'headless';
const $0037b6bfd6daf741$export$fe7e318da6d65170 = 'canvas-server';
const $0037b6bfd6daf741$export$f356f97db9b96f17 = 'canvas-relay';
const $0037b6bfd6daf741$export$1cebfc86ac630bb9 = 'whiteboard-frame';
const $0037b6bfd6daf741$export$3078341395c8cb8e = 'whiteboard-locale';
const $0037b6bfd6daf741$export$8103f24eb51911e7 = 'whiteboard-linked-object';
const $0037b6bfd6daf741$export$d7fb875e30263264 = 'initial-theme';
const $0037b6bfd6daf741$export$abce116b94c493f9 = 'bifrost-override';
const $0037b6bfd6daf741$export$d3cf0d39019c8c7f = 'deactivationIdentifier';
const $0037b6bfd6daf741$export$390fc29767c845fc = 'whiteboardPaywallUpsellButton';
const $0037b6bfd6daf741$export$7864364f55e7d48e = 'whiteboardPaywallLearnMoreButton';
const $0037b6bfd6daf741$export$4541324acb17bf12 = 'whiteboardCreationPaywall-';
const $0037b6bfd6daf741$export$c896c362d8b74a87 = 'openJiraImportTool';
const $0037b6bfd6daf741$export$54b9795b714f5c18 = 'autoImportJiraIssues';
const $0037b6bfd6daf741$export$321c00d8e9c04c4f = 'jiraImportJql';
const $0037b6bfd6daf741$export$72b22303fb080064 = 'openMiroImportTool';
const $0037b6bfd6daf741$export$1ef18edc28f65989 = 'openMuralImportTool';
const $0037b6bfd6daf741$export$cbbd90bf5df877bd = 'cloudId';
const $0037b6bfd6daf741$export$2f0c01c772bbe851 = 'projectUuid';
const $0037b6bfd6daf741$export$f045456260cdfa6f = new Date('2024-02-29T00:00Z');
const $0037b6bfd6daf741$export$1c237a39a0b4e9d9 = 'parentProduct';
const $0037b6bfd6daf741$export$2fe42b7bd8ad9641 = 'parentDomain';
const $0037b6bfd6daf741$export$e75d2079ca761674 = 'presentationMode';
const $0037b6bfd6daf741$export$6c706ba208a447e = 'themeState';
const $0037b6bfd6daf741$export$8b639ae03e233763 = 'visualRefresh';
const $0037b6bfd6daf741$export$628c002e5c2252ee = 'createdAt';
const $0037b6bfd6daf741$export$cab138e355452790 = 'focusedCommentId';
const $0037b6bfd6daf741$export$fc53afa4d35a37cf = 'focusedMentionId';
const $0037b6bfd6daf741$export$95e280144fb6ae44 = 'replyToComment';
const $0037b6bfd6daf741$export$4f5dbfe1c54c9e86 = 'version';
const $0037b6bfd6daf741$export$4b9f8234d01d21e9 = 'createdFromSlug';
const $0037b6bfd6daf741$export$8718ad6f6cf65056 = 'debugLayouts';
const $0037b6bfd6daf741$export$326bc0b4b25bc0cb = 'racing';
const $0037b6bfd6daf741$export$148d5c0fade1be8d = 'slides';
module.exports["TEMPLATE_PICKER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8cda2e6ee87e510b;
module.exports["NEW_WHITEBOARD_QUERY_PARAM"] = $0037b6bfd6daf741$export$2deb4fd8c7cecd6b;
module.exports["INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM"] = $0037b6bfd6daf741$export$58465f9d39dce215;
module.exports["HEADLESS_QUERY_PARAM"] = $0037b6bfd6daf741$export$6b4bb9c01a5ea809;
module.exports["SERVER_SPOT_PARAM"] = $0037b6bfd6daf741$export$fe7e318da6d65170;
module.exports["RELAY_SPOT_PARAM"] = $0037b6bfd6daf741$export$f356f97db9b96f17;
module.exports["WHITEBOARD_IFRAME_TITLE"] = $0037b6bfd6daf741$export$1cebfc86ac630bb9;
module.exports["WHITEBOARD_LOCALE"] = $0037b6bfd6daf741$export$3078341395c8cb8e;
module.exports["WHITEBOARD_LINKED_OBJECT"] = $0037b6bfd6daf741$export$8103f24eb51911e7;
module.exports["INITIAL_THEME_PARAM"] = $0037b6bfd6daf741$export$d7fb875e30263264;
module.exports["BIFROST_OVERRIDE_PARAM"] = $0037b6bfd6daf741$export$abce116b94c493f9;
module.exports["PAYWALL_DEACTIVATION_IDENTIFIER"] = $0037b6bfd6daf741$export$d3cf0d39019c8c7f;
module.exports["WHITEBOARD_PAYWALL_UPSELL_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$390fc29767c845fc;
module.exports["WHITEBOARD_PAYWALL_INFO_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$7864364f55e7d48e;
module.exports["WHITEBOARD_CREATION_PAYWALL_SOURCE_PREFIX"] = $0037b6bfd6daf741$export$4541324acb17bf12;
module.exports["JIRA_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$c896c362d8b74a87;
module.exports["AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM"] = $0037b6bfd6daf741$export$54b9795b714f5c18;
module.exports["JIRA_IMPORT_JQL"] = $0037b6bfd6daf741$export$321c00d8e9c04c4f;
module.exports["MIRO_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$72b22303fb080064;
module.exports["MURAL_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$1ef18edc28f65989;
module.exports["CLOUD_ID"] = $0037b6bfd6daf741$export$cbbd90bf5df877bd;
module.exports["PROJECT_UUID"] = $0037b6bfd6daf741$export$2f0c01c772bbe851;
module.exports["PARENT_PRODUCT_QUERY_PARAM"] = $0037b6bfd6daf741$export$1c237a39a0b4e9d9;
module.exports["PARENT_DOMAIN_QUERY_PARAM"] = $0037b6bfd6daf741$export$2fe42b7bd8ad9641;
module.exports["PRESENTATION_MODE_QUERY_PARAM"] = $0037b6bfd6daf741$export$e75d2079ca761674;
module.exports["EMBEDDED_THEME_STATE"] = $0037b6bfd6daf741$export$6c706ba208a447e;
module.exports["VISUAL_REFRESH_PARAM"] = $0037b6bfd6daf741$export$8b639ae03e233763;
module.exports["EMBEDDED_WHITEBOARD_CREATED_AT_QUERY_PARAM"] = $0037b6bfd6daf741$export$628c002e5c2252ee;
module.exports["FOCUSED_COMMENT_ID"] = $0037b6bfd6daf741$export$cab138e355452790;
module.exports["FOCUSED_MENTION_ID"] = $0037b6bfd6daf741$export$fc53afa4d35a37cf;
module.exports["REPLY_TO_COMMENT"] = $0037b6bfd6daf741$export$95e280144fb6ae44;
module.exports["WHITEBOARD_VERSION_ID"] = $0037b6bfd6daf741$export$4f5dbfe1c54c9e86;
module.exports["CREATED_FROM_SLUG"] = $0037b6bfd6daf741$export$4b9f8234d01d21e9;
module.exports["DEBUG_LAYOUTS_QUERY_PARAM"] = $0037b6bfd6daf741$export$8718ad6f6cf65056;
module.exports["RACING_QUERY_PARAM"] = $0037b6bfd6daf741$export$326bc0b4b25bc0cb;
module.exports["SLIDES_QUERY_PARAM"] = $0037b6bfd6daf741$export$148d5c0fade1be8d;

});

parcelRegister("98wxI", function(module, exports) {
var $5046ea0ba58442ff$export$d9669dcdbd1161d9 = /*#__PURE__*/ function(PaywallStatus) {
    PaywallStatus["ACTIVE"] = "ACTIVE";
    PaywallStatus["DEACTIVATED"] = "DEACTIVATED";
    PaywallStatus["UNSET"] = "UNSET";
    return PaywallStatus;
}({});
module.exports["PaywallStatus"] = $5046ea0ba58442ff$export$d9669dcdbd1161d9;

});

parcelRegister("iaK3p", function(module, exports) {
/**
 * @generated SignedSource<<64599f16afee950a47221dcfc47cc997>>
 * @relayHash 5f15c23509e6cb7f2874b0f92de8a11b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8c70e28d771c617ecf7c58416cff6761443cf9b61782cdb47a1bb82fdf95ba9f
const $8d30006ecab20121$var$node = function() {
    var v0 = [
        {
            "concreteType": "DiscoveredFeature",
            "kind": "LinkedField",
            "name": "featureDiscovery",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "pluginKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "featureKey"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "5f15c23509e6cb7f2874b0f92de8a11b",
            "id": "8c70e28d771c617ecf7c58416cff6761443cf9b61782cdb47a1bb82fdf95ba9f",
            "metadata": {},
            "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
            "operationKind": "query",
            "text": "query useFeatureDiscoveryFeatureDiscoveryQuery{featureDiscovery{pluginKey,featureKey}}"
        }
    };
}();
$8d30006ecab20121$var$node.hash = "8577be880df828fbee71c90a7701eddf";
var $8d30006ecab20121$export$2e2bcd8739ae039 = $8d30006ecab20121$var$node;
module.exports["default"] = $8d30006ecab20121$export$2e2bcd8739ae039;

});

parcelRegister("fBMbo", function(module, exports) {

var $dNGPK = parcelRequire("dNGPK");


var $7qH1e = parcelRequire("7qH1e");

function $b5cfafc926496f98$export$479d1ccc5f2ab701(target, ...deps) {
    // Read context and grab all the dependencies override Providers in the tree
    const { getDependencies: getDependencies } = // grab value from alt renderer (eg react-test-renderer)
    (0, $dNGPK.Context)._currentRenderer2 && (0, $dNGPK.Context)._currentValue2 || // grab value from default renderer
    (0, $dNGPK.Context)._currentValue || (0, $7qH1e.globalDi);
    return getDependencies(deps, target);
}
module.exports["di"] = $b5cfafc926496f98$export$479d1ccc5f2ab701;

});

parcelRegister("dNGPK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7qH1e = parcelRequire("7qH1e");

const $a0c113d1cdcf525c$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    getDependencies: (0, $7qH1e.globalDi).getDependencies
});
module.exports["Context"] = $a0c113d1cdcf525c$export$841858b892ce1f4c;

});

parcelRegister("7qH1e", function(module, exports) {

var $ipvr6 = parcelRequire("ipvr6");


var $b1tX2 = parcelRequire("b1tX2");

const $568c54c2a75aa99b$var$replacementMap = new Map();
const $568c54c2a75aa99b$export$a775919ebd7dd28a = {
    getDependencies (realDeps, targetChild) {
        if ($568c54c2a75aa99b$var$replacementMap.size) for(let i = 0; i < realDeps.length; i++){
            const replacedInj = (0, $b1tX2.findInjectable)($568c54c2a75aa99b$var$replacementMap, realDeps[i], targetChild);
            if (replacedInj) realDeps[i] = replacedInj.value;
        }
        return realDeps;
    },
    use (injs) {
        if ($568c54c2a75aa99b$var$replacementMap.size) throw new Error(`${(0, $ipvr6.PACKAGE_NAME)} has replacements configured already. ` + `Implicit merging is not supported, so please concatenate injectables. ` + `If this is not expected, please file a bug report`);
        injs.forEach((inj)=>(0, $b1tX2.addInjectableToMap)($568c54c2a75aa99b$var$replacementMap, inj));
    },
    clear () {
        $568c54c2a75aa99b$var$replacementMap.clear();
    },
    _fromProvider (injs, props = {}) {
        injs.forEach((inj)=>{
            if (props.global || (0, $ipvr6.diRegistry).get(inj).global) (0, $b1tX2.addInjectableToMap)($568c54c2a75aa99b$var$replacementMap, inj);
        });
    },
    _remove (injs) {
        injs.forEach((inj)=>(0, $b1tX2.removeInjectableFromMap)($568c54c2a75aa99b$var$replacementMap, inj));
    }
};
function $568c54c2a75aa99b$export$b887ce09d70113f9(thunk, deps) {
    $568c54c2a75aa99b$export$a775919ebd7dd28a.use(deps);
    let result;
    try {
        result = thunk();
        return result;
    } finally{
        // autocleanup dependences if either async or sync
        if (result && typeof result === 'object' && typeof result.then === 'function') // dont use finally as it "multiplies" rejected promises
        result.then($568c54c2a75aa99b$export$a775919ebd7dd28a.clear, $568c54c2a75aa99b$export$a775919ebd7dd28a.clear);
        else $568c54c2a75aa99b$export$a775919ebd7dd28a.clear();
    }
}
module.exports["globalDi"] = $568c54c2a75aa99b$export$a775919ebd7dd28a;

});

parcelRegister("ipvr6", function(module, exports) {
const $d672f259068efdcd$export$4203fb010fad9bf0 = new WeakMap();
const $d672f259068efdcd$export$b8b9d90f9e5bd72b = 'react-magnetic-di';
module.exports["diRegistry"] = $d672f259068efdcd$export$4203fb010fad9bf0;
module.exports["PACKAGE_NAME"] = $d672f259068efdcd$export$b8b9d90f9e5bd72b;

});

parcelRegister("b1tX2", function(module, exports) {

var $ipvr6 = parcelRequire("ipvr6");


var $aqxLC = parcelRequire("aqxLC");

let $80670563c880fcd1$var$hasWarned = false;
function $80670563c880fcd1$export$5b28268982f175ba(message) {
    if (!$80670563c880fcd1$var$hasWarned) {
        // eslint-disable-next-line no-console
        console.warn('Warning:', message);
        $80670563c880fcd1$var$hasWarned = true;
    }
}
function $80670563c880fcd1$export$7a7134bdd2f9ae2e(replacementMap, inj) {
    const injObj = (0, $ipvr6.diRegistry).get(inj);
    if (!injObj) throw new Error(`Seems like you are trying to use "${inj}" as injectable, but magnetic-di needs the return value of "injectable()"`);
    if (injObj.track) (0, $aqxLC.stats).set(injObj);
    if (replacementMap.has(injObj.from)) replacementMap.get(injObj.from).add(injObj);
    else replacementMap.set(injObj.from, new Set([
        injObj
    ]));
    return replacementMap;
}
function $80670563c880fcd1$export$8057a2244a849b7b(replacementMap, inj) {
    const injObj = (0, $ipvr6.diRegistry).get(inj);
    const injectables = replacementMap.get(injObj.from) || new Set();
    if (injectables.size === 1) replacementMap.delete(injObj.from);
    else injectables.delete(injObj);
}
function $80670563c880fcd1$export$be63e0664592e141(Comp, wrapper = '') {
    const name = Comp.displayName || Comp.name;
    return !name || !wrapper ? name : `${wrapper}(${name})`;
}
function $80670563c880fcd1$export$1c9f709888824e05(fn) {
    const source = fn.toString();
    const [, args] = source.match(/const \[[^\]]+\] = .*di.*\(\w+[,\s]+([^)]+)/) || [];
    return args;
}
function $80670563c880fcd1$export$7c436e151c3ee289(replacementMap, dep, targetChild) {
    const injectables = replacementMap.get(dep);
    if (!injectables) return null;
    // loop all injectables for the dep, with targeted ones preferred
    let anyCandidate = null;
    let targetCandidate = null;
    for (const inj of injectables){
        var _inj$targets;
        if (!inj.targets) anyCandidate = inj;
        if ((_inj$targets = inj.targets) != null && _inj$targets.has(targetChild)) targetCandidate = inj;
    }
    const candidate = targetCandidate || anyCandidate;
    (0, $aqxLC.stats).track(candidate);
    return candidate;
}
module.exports["addInjectableToMap"] = $80670563c880fcd1$export$7a7134bdd2f9ae2e;
module.exports["removeInjectableFromMap"] = $80670563c880fcd1$export$8057a2244a849b7b;
module.exports["findInjectable"] = $80670563c880fcd1$export$7c436e151c3ee289;

});

parcelRegister("aqxLC", function(module, exports) {
const $79768685dc5c2f62$var$createState = ()=>({
        unused: new Map(),
        used: new Set(),
        provided: new Set()
    });
const $79768685dc5c2f62$export$7804429c45dff272 = {
    state: $79768685dc5c2f62$var$createState(),
    set (inj) {
        var _inj$value;
        // allow injectable override without flagging as unused
        for (let unusedInj of this.state.unused.keys())if (unusedInj.from === inj.from) this.state.unused.delete(unusedInj);
        this.state.unused.set(inj, new Error(`Unused "di" injectable: ${((_inj$value = inj.value) == null ? void 0 : _inj$value.displayName) || inj.value}.`, {
            cause: inj.cause
        }));
    },
    track (inj) {
        if (!inj) return;
        this.state.unused.delete(inj);
        this.state.used.add(inj);
        this.state.provided.add(inj.from);
        // reset to avoid potential memory leaks via stack traces
        inj.cause = null;
    },
    reset () {
        this.state = $79768685dc5c2f62$var$createState();
    },
    unused () {
        return Array.from(this.state.unused.entries()).map(([inj, error])=>({
                get: ()=>inj.value,
                error: ()=>error
            }));
    }
};
module.exports["stats"] = $79768685dc5c2f62$export$7804429c45dff272;

});

parcelRegister("keVvA", function(module, exports) {
$parcel$export(module.exports, "default", () => $36f6a30267bec70f$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");


var $e9OZ6 = parcelRequire("e9OZ6");


var $5cR9p = parcelRequire("5cR9p");

function $36f6a30267bec70f$export$2e2bcd8739ae039({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $5cR9p.useSafeIntl)();
    const messages = (0, $e9OZ6.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the context and pass them downstream
   * This prevents the missing messages error
   */ const mergedMessages = (0, $42omo.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1e2E5.default), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages,
        children: children
    });
}

});

parcelRegister("e9OZ6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hxPth = parcelRequire("hxPth");

const $e1a1ee666860bb23$export$4d17e2d9c5348842 = (locale, loaderFn)=>{
    const [localeState, setLocaleState] = (0, $42omo.useState)((0, $hxPth.DEFAULT_LOCALE_STATE));
    (0, $42omo.useEffect)(()=>{
        if (!localeState.messages || locale !== localeState.locale) {
            let current = true;
            loaderFn(locale).then((messages)=>{
                if (current) setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            });
            return ()=>{
                current = false;
            };
        }
        return undefined;
    }, [
        loaderFn,
        locale,
        localeState
    ]);
    return localeState.messages;
};
module.exports["useMessages"] = $e1a1ee666860bb23$export$4d17e2d9c5348842;

});

parcelRegister("hxPth", function(module, exports) {
const $b9a0da62d538b640$export$79618bef82c02d4c = {
    locale: 'en',
    messages: {}
};
module.exports["DEFAULT_LOCALE_STATE"] = $b9a0da62d538b640$export$79618bef82c02d4c;

});

parcelRegister("5cR9p", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");

var $fI8ba = parcelRequire("fI8ba");

var $gmMgo = parcelRequire("gmMgo");


var $hxPth = parcelRequire("hxPth");

// Prevents memory leaks
const $1961b540cbe6be26$var$cache = (0, $fI8ba.createIntlCache)();
const $1961b540cbe6be26$export$f752ac21ea3960a5 = ()=>{
    const context = (0, $42omo.useContext)((0, $gmMgo.Context));
    if (!context) return (0, $1e2E5.createIntl)((0, $hxPth.DEFAULT_LOCALE_STATE), $1961b540cbe6be26$var$cache);
    return context;
};
module.exports["useSafeIntl"] = $1961b540cbe6be26$export$f752ac21ea3960a5;

});

parcelRegister("lvsjl", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa82743632a2ad8f$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $fa82743632a2ad8f$export$2e2bcd8739ae039(callback, delay, options) {
    if (options === void 0) options = {};
    var maxWait = options.maxWait;
    var maxWaitHandler = (0, $42omo.useRef)(null);
    var maxWaitArgs = (0, $42omo.useRef)([]);
    var leading = options.leading;
    var trailing = options.trailing === undefined ? true : options.trailing;
    var leadingCall = (0, $42omo.useRef)(false);
    var functionTimeoutHandler = (0, $42omo.useRef)(null);
    var isComponentUnmounted = (0, $42omo.useRef)(false);
    var debouncedFunction = (0, $42omo.useRef)(callback);
    debouncedFunction.current = callback;
    var cancelDebouncedCallback = (0, $42omo.useCallback)(function() {
        clearTimeout(functionTimeoutHandler.current);
        clearTimeout(maxWaitHandler.current);
        maxWaitHandler.current = null;
        maxWaitArgs.current = [];
        functionTimeoutHandler.current = null;
        leadingCall.current = false;
    }, []);
    (0, $42omo.useEffect)(function() {
        // We have to set isComponentUnmounted to be truth, as fast-refresh runs all useEffects
        isComponentUnmounted.current = false;
        return function() {
            // we use flag, as we allow to call callPending outside the hook
            isComponentUnmounted.current = true;
        };
    }, []);
    var debouncedCallback = (0, $42omo.useCallback)(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        maxWaitArgs.current = args;
        clearTimeout(functionTimeoutHandler.current);
        if (leadingCall.current) leadingCall.current = false;
        if (!functionTimeoutHandler.current && leading && !leadingCall.current) {
            debouncedFunction.current.apply(debouncedFunction, args);
            leadingCall.current = true;
        }
        functionTimeoutHandler.current = setTimeout(function() {
            var shouldCallFunction = true;
            if (leading && leadingCall.current) shouldCallFunction = false;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current && trailing && shouldCallFunction) debouncedFunction.current.apply(debouncedFunction, args);
        }, delay);
        if (maxWait && !maxWaitHandler.current && trailing) maxWaitHandler.current = setTimeout(function() {
            var args = maxWaitArgs.current;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current) debouncedFunction.current.apply(null, args);
        }, maxWait);
    }, [
        maxWait,
        delay,
        cancelDebouncedCallback,
        leading,
        trailing
    ]);
    var callPending = (0, $42omo.useCallback)(function() {
        // Call pending callback only if we have anything in our queue
        if (!functionTimeoutHandler.current) return;
        debouncedFunction.current.apply(null, maxWaitArgs.current);
        cancelDebouncedCallback();
    }, [
        cancelDebouncedCallback
    ]);
    // At the moment, we use 3 args array so that we save backward compatibility
    return [
        debouncedCallback,
        cancelDebouncedCallback,
        callPending
    ];
}

});

parcelRegister("jhwJP", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $8e78cdefc122a0a9$export$d1326a8d9df930b6 = (i18nBase, i18nLiveDocs)=>{
    const initializeData = (targetObj)=>{
        targetObj._data = (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? {
            ...i18nBase,
            ...i18nLiveDocs
        } : i18nBase;
        targetObj._initialized = true;
    };
    return new Proxy({}, {
        get: (targetObj, prop)=>{
            // Ensures retrieval of properties on i18n object use i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return targetObj._data[prop];
        },
        ownKeys: (targetObj)=>{
            // ensures `.keys` uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return Reflect.ownKeys(targetObj._data);
        },
        has: (targetObj, prop)=>{
            // Ensures for...in uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return prop in targetObj._data;
        },
        getOwnPropertyDescriptor: (targetObj, prop)=>{
            // Ensures i18n props are enumerable, required for ownKeys/etc to work
            if (!targetObj._initialized) initializeData(targetObj);
            const descriptor = Object.getOwnPropertyDescriptor(targetObj._data, prop);
            return descriptor ? {
                ...descriptor,
                enumerable: true
            } : undefined;
        }
    });
};
module.exports["mergeLiveDocI18n"] = $8e78cdefc122a0a9$export$d1326a8d9df930b6;

});

parcelRegister("f7Bnv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1ytiN = parcelRequire("1ytiN");

function $7faf87d57bd98ac2$export$a3bfa6bb89ccecd5(WrappedComponent) {
    return function WithIsSiteAdminComponent(props) {
        const { isSiteAdmin: isSiteAdmin, error: error, loading: loading } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
        if (error || loading) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            ...props,
            isSiteAdmin: isSiteAdmin
        });
    };
}
module.exports["withIsSiteAdmin"] = $7faf87d57bd98ac2$export$a3bfa6bb89ccecd5;

});

parcelRegister("izVB4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a9109095f0a9b69c0b01202dc3ed5e4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d8682c67cc42b6ad$var$_react = $d8682c67cc42b6ad$var$_interopRequireDefault((parcelRequire("42omo")));

var $d8682c67cc42b6ad$var$_baseNew = $d8682c67cc42b6ad$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $d8682c67cc42b6ad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Editions".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing premium features in upsell experiences. The Editions gem icon has officially replaced the sparkle icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d8682c67cc42b6ad$var$EditionsIcon = (props)=>/*#__PURE__*/ $d8682c67cc42b6ad$var$_react.default.createElement($d8682c67cc42b6ad$var$_baseNew.default, Object.assign({
        name: "EditionsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m12.75 1 .096.006a.75.75 0 0 1 .54.347l2.5 4a.75.75 0 0 1-.066.883l-7.25 8.5a.75.75 0 0 1-1.14 0l-7.25-8.5a.75.75 0 0 1-.066-.883l2.5-4 .056-.079A.75.75 0 0 1 3.25 1zM8 11.813 9.719 6.5H6.28zm-1.873-.914L4.704 6.5H2.375zm3.745 0L13.625 6.5h-2.33zM11.302 5h2.596l-1.563-2.5H10.52zM6.27 5h3.46l-.782-2.5H7.052zM2.103 5h2.595l.781-2.5H3.665z"/>`
    }, props));
$d8682c67cc42b6ad$var$EditionsIcon.displayName = 'EditionsIcon';
var $d8682c67cc42b6ad$var$_default = module.exports.default = $d8682c67cc42b6ad$var$EditionsIcon;

});

parcelRegister("dqdrq", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $izVB4 = parcelRequire("izVB4");


var $j4WDj = parcelRequire("j4WDj");


var $6J7Bn = parcelRequire("6J7Bn");

const $ce55fe36479bc4cf$var$StyledButton = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(11);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? (0, $6J7Bn.ButtonBase) : t2;
        let t3;
        let t4;
        let t5;
        let t6;
        let t7;
        let t8;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_DEFAULT_START));
            t4 = (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_DEFAULT_END));
            t5 = (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_HOVER_START));
            t6 = (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_HOVER_END));
            t7 = (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_ACTIVE_START));
            t8 = (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_ACTIVE_END));
            $[3] = t3;
            $[4] = t4;
            $[5] = t5;
            $[6] = t6;
            $[7] = t7;
            $[8] = t8;
        } else {
            t3 = $[3];
            t4 = $[4];
            t5 = $[5];
            t6 = $[6];
            t7 = $[7];
            t8 = $[8];
        }
        let t9;
        if ($[9] !== __cmpls) {
            t9 = {
                ...__cmpls,
                "--_iozncj": t3,
                "--_id2ec3": t4,
                "--_1wa1xp5": t5,
                "--_1ck0ygl": t6,
                "--_1jf6nc6": t7,
                "--_1kksnqn": t8
            };
            $[9] = __cmpls;
            $[10] = t9;
        } else t9 = $[10];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmplp,
            style: t9,
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_1wgmglyw _1tnq12b0 _nup9qsa8 _ge1r1cay _h99ltlke _r7sm1uxc _1xlotlke _1jypidpf _1fm3idpf _12z9idpf _1dwpidpf _kl6h116y _1w901gfe _1l5a1gfe _zelm1gfe _1fh11gfe _1f1j1gfe",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ as: C = (0, $6J7Bn.ButtonBase), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_iozncj": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_DEFAULT_START)),
            "--_id2ec3": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_DEFAULT_END)),
            "--_1wa1xp5": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_HOVER_START)),
            "--_1ck0ygl": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_HOVER_END)),
            "--_1jf6nc6": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_ACTIVE_START)),
            "--_1kksnqn": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_ACTIVE_END))
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1wgmglyw _1tnq12b0 _nup9qsa8 _ge1r1cay _h99ltlke _r7sm1uxc _1xlotlke _1jypidpf _1fm3idpf _12z9idpf _1dwpidpf _kl6h116y _1w901gfe _1l5a1gfe _zelm1gfe _1fh11gfe _1f1j1gfe",
            __cmplp.className
        ])
    });
});
const $ce55fe36479bc4cf$var$ButtonText = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c8fhey _1e0c1txw _4cvr1h6o _1bah1h6o _k48p1wq8",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8fhey _1e0c1txw _4cvr1h6o _1bah1h6o _k48p1wq8",
            __cmplp.className
        ])
    });
}); /**
     * A styled button with a gradient background, intended to be used as a product edition upgrade CTA button.
     */ 
const $ce55fe36479bc4cf$export$d1aef6466b5ecaa5 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    let buttonProps;
    let children;
    if ($[0] !== t0) {
        ({ children: children, ...buttonProps } = t0);
        $[0] = t0;
        $[1] = buttonProps;
        $[2] = children;
    } else {
        buttonProps = $[1];
        children = $[2];
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($izVB4))), {
            label: ""
        });
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ce55fe36479bc4cf$var$ButtonText, null, children);
        $[4] = children;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== buttonProps || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ce55fe36479bc4cf$var$StyledButton, {
            iconBefore: t1,
            ...buttonProps
        }, t2);
        $[6] = buttonProps;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ children: children, ...buttonProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ce55fe36479bc4cf$var$StyledButton, {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($izVB4))), {
            label: ""
        }),
        ...buttonProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ce55fe36479bc4cf$var$ButtonText, null, children));
};
module.exports["GradientCTAButton"] = $ce55fe36479bc4cf$export$d1aef6466b5ecaa5;

});

parcelRegister("j4WDj", function(module, exports) {
const $67193f3c2d75b820$export$3ff4048780acdec9 = "var(--ds-chart-purple-bolder, #AF59E1)";
const $67193f3c2d75b820$export$ac8ee41608bff6f4 = "var(--ds-chart-blue-bolder, #357DE8)";
const $67193f3c2d75b820$export$12fbdde791205cea = "var(--ds-chart-purple-bolder-hovered, #964AC0)";
const $67193f3c2d75b820$export$7653c62635354aaf = "var(--ds-chart-blue-bolder-hovered, #1868DB)";
const $67193f3c2d75b820$export$d4accc94291dcf84 = "var(--ds-chart-purple-boldest, #803FA5)";
const $67193f3c2d75b820$export$16a15d5a9b73591b = "var(--ds-chart-blue-boldest, #1558BC)";
const $67193f3c2d75b820$export$fca70c3c81bb0f58 = "var(--ds-background-accent-blue-subtlest, #E9F2FE)";
const $67193f3c2d75b820$export$f737ffc625de304f = "var(--ds-background-accent-purple-subtlest, #F8EEFE)";
const $67193f3c2d75b820$export$b1ab5fb618714abb = "var(--ds-border-accent-purple, #AF59E1)";
const $67193f3c2d75b820$export$7a262e0e9c5a1e2a = "var(--ds-border-accent-blue, #357DE8)";
const $67193f3c2d75b820$export$71b6aed4f8256b2 = "var(--ds-background-discovery-bold-pressed, #673286)";
const $67193f3c2d75b820$export$c9d89eb8e0b59a5a = "var(--ds-background-selected-bold-pressed, #123263)";
module.exports["GRADIENT_CTA_BUTTON_DEFAULT_START"] = $67193f3c2d75b820$export$3ff4048780acdec9;
module.exports["GRADIENT_CTA_BUTTON_DEFAULT_END"] = $67193f3c2d75b820$export$ac8ee41608bff6f4;
module.exports["GRADIENT_CTA_BUTTON_HOVER_START"] = $67193f3c2d75b820$export$12fbdde791205cea;
module.exports["GRADIENT_CTA_BUTTON_HOVER_END"] = $67193f3c2d75b820$export$7653c62635354aaf;
module.exports["GRADIENT_CTA_BUTTON_ACTIVE_START"] = $67193f3c2d75b820$export$d4accc94291dcf84;
module.exports["GRADIENT_CTA_BUTTON_ACTIVE_END"] = $67193f3c2d75b820$export$16a15d5a9b73591b;
module.exports["GRADIENT_BACKGROUND_SUBTLEST_START"] = $67193f3c2d75b820$export$fca70c3c81bb0f58;
module.exports["GRADIENT_BACKGROUND_SUBTLEST_END"] = $67193f3c2d75b820$export$f737ffc625de304f;
module.exports["GRADIENT_CTA_BUTTON_INVERTED_BORDER_START"] = $67193f3c2d75b820$export$b1ab5fb618714abb;
module.exports["GRADIENT_CTA_BUTTON_INVERTED_BORDER_END"] = $67193f3c2d75b820$export$7a262e0e9c5a1e2a;
module.exports["GRADIENT_CTA_BUTTON_SELECTED_START"] = $67193f3c2d75b820$export$71b6aed4f8256b2;
module.exports["GRADIENT_CTA_BUTTON_SELECTED_END"] = $67193f3c2d75b820$export$c9d89eb8e0b59a5a;

});

parcelRegister("6J7Bn", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $eEA8O = parcelRequire("eEA8O");

const $e9beab952dc913a3$export$b0bb876e969289cd = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $eEA8O.default) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_d16p1ano _1dqt12x7 _1toh1r31 _5jyqglyw _mrqmnqa1 _if29116y _1kba1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_d16p1ano _1dqt12x7 _1toh1r31 _5jyqglyw _mrqmnqa1 _if29116y _1kba1h6o",
            __cmplp.className
        ])
    });
});
module.exports["ButtonBase"] = $e9beab952dc913a3$export$b0bb876e969289cd;

});

parcelRegister("fAD9L", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $6xdDU = parcelRequire("6xdDU");


var $TSbNa = parcelRequire("TSbNa");

const $71b8fe84901d80f2$var$RenderModal = ({ modal: modal })=>{
    const [shouldCloseOnOverlayClick, setShouldCloseOnOverlayClick] = (0, $42omo.useState)();
    const [shouldCloseOnEscapePress, setShouldCloseOnEscapePress] = (0, $42omo.useState)();
    const Component = modal.component;
    return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
        onClose: modal.close,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
        setShouldCloseOnEscapePress: setShouldCloseOnEscapePress
    });
};
function $71b8fe84901d80f2$export$7c9538f5f3c365e9({ children: children }) {
    const id = (0, $42omo.useRef)(1);
    const [modals, setModals] = (0, $42omo.useState)([]);
    const modalContext = (0, $42omo.useMemo)(()=>({
            openModal: (component)=>{
                const key = String(id.current++);
                const close = ()=>{
                    setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                };
                setModals((mdls)=>[
                        ...mdls,
                        {
                            close: close,
                            component: component,
                            key: key
                        }
                    ]);
            }
        }), []);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $TSbNa.ModalContext).Provider, {
        value: modalContext,
        children: [
            children,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
                children: modals.map((modal)=>/*#__PURE__*/ (0, $l998X.jsx)($71b8fe84901d80f2$var$RenderModal, {
                        modal: modal
                    }, modal.key))
            })
        ]
    });
}
module.exports["ModalContextProvider"] = $71b8fe84901d80f2$export$7c9538f5f3c365e9;

});

parcelRegister("TSbNa", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $645b684711965e78$export$ab57792b9b6974a6 = (0, $42omo.createContext)({
    openModal: ()=>{
        throw new Error("To show the modal, wrap your app's root component with a <ModalContextProvider />. import { ModalContextProvider } from '@atlassian/entry-point-modal-context/ModalContextProvider';");
    }
});
module.exports["ModalContext"] = $645b684711965e78$export$ab57792b9b6974a6;

});

parcelRegister("7wGk4", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fBMbo = parcelRequire("fBMbo");


var $irOoi = parcelRequire("irOoi");


var $iP9n7 = parcelRequire("iP9n7");


var $cQDYl = parcelRequire("cQDYl");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");


var $dh538 = parcelRequire("dh538");


var $eyWa4 = parcelRequire("eyWa4");


var $4M6GB = parcelRequire("4M6GB");


var $TSbNa = parcelRequire("TSbNa");


var $7wYo8 = parcelRequire("7wYo8");


var $48FEk = parcelRequire("48FEk");


var $gWF6I = parcelRequire("gWF6I");

const $abc57e0f1f470075$var$emptyEntryPointParams = {};
const $abc57e0f1f470075$var$emptyEntryPointProps = {};
function $abc57e0f1f470075$export$fb10b32cfe19f1e({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, Fallback: Fallback, title: title, modalProps: modalProps, forwardedRef: forwardedRef, onError: onError, preloadOnFocus: providedPreloadOnFocus }) {
    (0, $fBMbo.di)((0, $irOoi.loadEntryPoint));
    const { openModal: openModal } = (0, $42omo.useContext)((0, $TSbNa.ModalContext));
    const environmentProvider = (0, $gWF6I.useRelayEnvironmentProvider)();
    const { ModalErrorFallback: ModalErrorFallback } = (0, $4M6GB.useEntryPointConfig)();
    const preloadOnFocus = providedPreloadOnFocus ?? (0, $dh538.fg)('dst-a11y_preload-on-focus-default-true') ? true : false;
    const metricName = (0, $42omo.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const load = (0, $42omo.useCallback)(()=>(0, $irOoi.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $abc57e0f1f470075$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $42omo.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
        openModal(({ onClose: closeModal, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress, setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick, setShouldCloseOnEscapePress: setShouldCloseOnEscapePress })=>{
            const onClose = (extraInformation)=>{
                entryPointProps?.onClose?.(extraInformation);
                closeModal();
                dispose();
            };
            const defaultFallback = /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                        children: title ? /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                            children: title
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                            grow: "fill",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cQDYl.default), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $1DHa6.default), {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $cQDYl.default), {}),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $cQDYl.default), {}),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $cQDYl.default), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $8o1lj.default), {})
                ]
            });
            const container = /*#__PURE__*/ (0, $l998X.jsx)((0, $48FEk.InternalEntryPointContainer), {
                entryPointReference: entryPointReference,
                errorFallback: ({ error: error })=>/*#__PURE__*/ (0, $l998X.jsx)(ModalErrorFallback, {
                        error: error
                    }),
                onError: ({ error: error, errorInfo: errorInfo })=>{
                    onError?.({
                        error: error,
                        errorInfo: errorInfo
                    });
                    closeModal();
                },
                fallback: Fallback ? /*#__PURE__*/ (0, $l998X.jsx)(Fallback, {
                    onClose: closeModal
                }) : defaultFallback,
                id: metricName,
                placeholderName: "modal-entry-point-pressable-trigger-container",
                runtimeProps: {
                    ...entryPointProps ?? $abc57e0f1f470075$var$emptyEntryPointProps,
                    onClose: onClose,
                    setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
                    setShouldCloseOnEscapePress: setShouldCloseOnEscapePress,
                    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress
                }
            });
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $8CZUH.default), {
                ...modalProps,
                onClose: onClose,
                shouldCloseOnOverlayClick: shouldCloseOnOverlayClick ?? modalProps?.shouldCloseOnOverlayClick,
                shouldCloseOnEscapePress: shouldCloseOnEscapePress ?? modalProps?.shouldCloseOnEscapePress,
                children: container
            });
        });
    }, [
        openModal,
        title,
        modalProps,
        Fallback,
        metricName,
        entryPointProps,
        ModalErrorFallback,
        onError
    ]);
    const triggerRef = (0, $7wYo8.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad,
        preloadOnFocus: preloadOnFocus
    });
    const mergedRef = (0, $iP9n7.useMergeRefs)([
        triggerRef,
        forwardedRef || null
    ]);
    return children({
        ref: mergedRef
    });
}
module.exports["ModalTrigger"] = $abc57e0f1f470075$export$fb10b32cfe19f1e;

});

parcelRegister("cQDYl", function(module, exports) {
/* skeleton-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $e0b2ee147542345d$var$skeletonItemElemSize = 20;
const $e0b2ee147542345d$var$N20A = 'rgba(9, 30, 66, 0.04)';
const $e0b2ee147542345d$var$N30A = 'rgba(9, 30, 66, 0.08)';
const $e0b2ee147542345d$var$styles = {
    root: "_1rjcze3t _18zrv47k _1e0c1txw _1tke1ylp _4cvr1h6o _lcxvglyw _14mj53f4 _1qdgrdoj _1hfkizff _aetrb3bt _3mxot94y",
    defaultWidth: "_sf1e1n8h _4rfy1ssb _baud1nrf _mr7o1vuk _69tq19wn _kt4d1n05",
    customWidth: "_11w8rzut",
    beforeElement: "_1mp4gktf _kfgtgktf _7bjqidpf _1rusizff _1kt9b3bt _1mbqdlk8 _1rhxv77o",
    avatar: "_rfx31rr0",
    icon: "_rfx3fajl",
    sideNavSkeleton: "_18zru2gc _kfgt1k8s _1mbqpxbi _1mp41k8s"
};
/**
 * These styles are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 * packages/design-system/menu/src/menu-item/skeleton-heading-item.tsx
 *
 * Please update both.
 */ const $e0b2ee147542345d$var$shimmerKeyframes = null; /**
                                * These styles are defined using `css` rather than `cssMap` as there is a bug when using
                                * `cssMap` that causes a build failure due to the use of keyframes within this pseudo-element.
                                */ 
const $e0b2ee147542345d$var$shimmerStyles = null; /**
                             * __Skeleton item__
                             *
                             * A skeleton item is used in place of an item when its contents it not ready.
                             *
                             * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-item)
                             * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
                             */ 
const $e0b2ee147542345d$var$SkeletonItem = ({ hasAvatar: hasAvatar, hasIcon: hasIcon, isShimmering: isShimmering = false, isSideNavSkeleton: isSideNavSkeleton = false, testId: testId, width: width, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            $e0b2ee147542345d$var$styles.root,
            (hasAvatar || hasIcon) && $e0b2ee147542345d$var$styles.beforeElement,
            hasAvatar && $e0b2ee147542345d$var$styles.avatar,
            hasIcon && $e0b2ee147542345d$var$styles.icon,
            width ? $e0b2ee147542345d$var$styles.customWidth : $e0b2ee147542345d$var$styles.defaultWidth,
            isSideNavSkeleton && $e0b2ee147542345d$var$styles.sideNavSkeleton,
            isShimmering && "",
            isShimmering && "_unfq1yy8 _9nev1yy8 _kwc012o8 _joxl12o8 _18f312c5 _evp612c5 _19oh1254 _10881254 _18lgp3kn _zo24p3kn _1hfkizff _1rusizff",
            xcss
        ]),
        style: {
            '--width': width
        },
        "data-testid": testId
    });
};
var $e0b2ee147542345d$export$2e2bcd8739ae039 = $e0b2ee147542345d$var$SkeletonItem;
module.exports["default"] = $e0b2ee147542345d$export$2e2bcd8739ae039;

});

parcelRegister("f9jv7", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $b29e4bf652226e80$export$6ccdb59d3479f4f1 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '404');
module.exports["isNotFoundError"] = $b29e4bf652226e80$export$6ccdb59d3479f4f1;

});

parcelRegister("oCj79", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9oxdN = parcelRequire("9oxdN");


var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $1ytiN = parcelRequire("1ytiN");


var $4oZIh = parcelRequire("4oZIh");

var $17cf05e6ca75dcaf$export$e066903c3e0dc7e0 = /*#__PURE__*/ function(PremiumFeatureKey) {
    PremiumFeatureKey["ANALYTICS"] = "analytics-used";
    PremiumFeatureKey["AUTOMATION"] = "automation-used";
    PremiumFeatureKey["ADVANCED_PERMISSIONS"] = "advanced-permissions-used";
    PremiumFeatureKey["TEAM_CALENDAR"] = "team-calendar-used";
    PremiumFeatureKey["UNLIMITED_STORAGE"] = "unlimited-storage-used";
    return PremiumFeatureKey;
}({});
var $17cf05e6ca75dcaf$export$141b820167a497fa = /*#__PURE__*/ function(PremiumFeatureUsage) {
    PremiumFeatureUsage["ANALYTICS_VIEW_SPACE"] = "analyticsViewSpace";
    PremiumFeatureUsage["ANALYTICS_VIEW_PAGE"] = "analyticsViewPage";
    PremiumFeatureUsage["AUTOMATION_NEW_RULE"] = "automationNewRule";
    PremiumFeatureUsage["PERMISSIONS_INSPECT_PAGE"] = "permissionsInspectPage";
    PremiumFeatureUsage["TEAM_CALENDAR_CREATE"] = "teamCalendarCreate";
    PremiumFeatureUsage["TEAM_CALENDAR_VIEW"] = "teamCalendarView";
    return PremiumFeatureUsage;
}({});
const $17cf05e6ca75dcaf$var$PremiumFeatureUsage2FeatureDiscoveryKey = {
    ["analyticsViewSpace"]: "analytics-used",
    ["analyticsViewPage"]: "analytics-used",
    ["automationNewRule"]: "automation-used",
    ["permissionsInspectPage"]: "advanced-permissions-used",
    ["teamCalendarCreate"]: "team-calendar-used",
    ["teamCalendarView"]: "team-calendar-used"
};
const $17cf05e6ca75dcaf$export$c9275e1e18a77404 = (0, $3u0dr.isReactCompilerActiveV2)() ? (premiumFeatureUsage, t0)=>{
    const $ = (0, $frIzR.c)(11);
    const skip = t0 === undefined ? false : t0;
    const { edition: edition, activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== skip) {
        t1 = {
            skip: skip
        };
        $[0] = skip;
        $[1] = t1;
    } else t1 = $[1];
    const { trialDaysLeft: trialDaysLeft } = (0, $4oZIh.useTrialDetails)(t1);
    const isEligibleToMark = edition === (0, $euL71.ConfluenceEdition).PREMIUM && trialDaysLeft > 0;
    const [, markFeature] = (0, $9oxdN.useFeatureDiscovery)($17cf05e6ca75dcaf$var$PremiumFeatureUsage2FeatureDiscoveryKey[premiumFeatureUsage], !isEligibleToMark);
    let t2;
    if ($[2] !== activationId || $[3] !== createAnalyticsEvent || $[4] !== isEligibleToMark || $[5] !== isSiteAdmin || $[6] !== markFeature || $[7] !== premiumFeatureUsage) {
        t2 = ()=>{
            markFeature();
            if (isEligibleToMark) createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "used",
                    actionSubject: "premiumFeature",
                    source: premiumFeatureUsage,
                    attributes: {
                        activationId: activationId,
                        isSiteAdmin: isSiteAdmin
                    }
                }
            }).fire();
        };
        $[2] = activationId;
        $[3] = createAnalyticsEvent;
        $[4] = isEligibleToMark;
        $[5] = isSiteAdmin;
        $[6] = markFeature;
        $[7] = premiumFeatureUsage;
        $[8] = t2;
    } else t2 = $[8];
    const markFeatureAsUsed = t2;
    let t3;
    if ($[9] !== markFeatureAsUsed) {
        t3 = {
            markFeatureAsUsed: markFeatureAsUsed
        };
        $[9] = markFeatureAsUsed;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : (premiumFeatureUsage, skip = false)=>{
    const { edition: edition, activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { trialDaysLeft: trialDaysLeft } = (0, $4oZIh.useTrialDetails)({
        skip: skip
    });
    const isEligibleToMark = edition === (0, $euL71.ConfluenceEdition).PREMIUM && trialDaysLeft > 0;
    const [, markFeature] = (0, $9oxdN.useFeatureDiscovery)($17cf05e6ca75dcaf$var$PremiumFeatureUsage2FeatureDiscoveryKey[premiumFeatureUsage], /* skip */ !isEligibleToMark);
    const markFeatureAsUsed = (0, $42omo.useCallback)(()=>{
        markFeature();
        if (isEligibleToMark) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'used',
                actionSubject: 'premiumFeature',
                source: premiumFeatureUsage,
                attributes: {
                    activationId: activationId,
                    isSiteAdmin: isSiteAdmin
                }
            }
        }).fire();
    }, [
        activationId,
        createAnalyticsEvent,
        isEligibleToMark,
        isSiteAdmin,
        markFeature,
        premiumFeatureUsage
    ]);
    return {
        markFeatureAsUsed: markFeatureAsUsed
    };
};
module.exports["PremiumFeatureKey"] = $17cf05e6ca75dcaf$export$e066903c3e0dc7e0;
module.exports["PremiumFeatureUsage"] = $17cf05e6ca75dcaf$export$141b820167a497fa;
module.exports["useTrackPremiumFeatureUsage"] = $17cf05e6ca75dcaf$export$c9275e1e18a77404;

});

parcelRegister("9oxdN", function(module, exports) {

var $h1PDd = parcelRequire("h1PDd");


var $iaK3p = parcelRequire("iaK3p");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $fEmGS = parcelRequire("fEmGS");


var $l1uFv = parcelRequire("l1uFv");


var $7W8i8 = parcelRequire("7W8i8");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery = (0, $iaK3p.default);
const $112f5732a615f62f$var$useFeatureDiscoveryMarkFeatureDiscoveredMutation = (0, $h1PDd.default);
const $112f5732a615f62f$var$logger = (0, $7W8i8.getLogger)('useFeatureDiscovery');
const $112f5732a615f62f$export$2dd355223baa0569 = 'com.atlassian.confluence.plugins.confluence-frontend-support';
const $112f5732a615f62f$var$updateCache = (_, { data: data })=>{
    const newMarkedFeature = data?.markFeatureDiscovered;
    if (!newMarkedFeature) return;
    const cachedFeatureData = (0, $l1uFv.readQueryInterop)({
        query: $112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery
    });
    if (!cachedFeatureData?.featureDiscovery) return;
    (0, $fEmGS.writeQueryInterop)({
        query: $112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery,
        data: {
            featureDiscovery: cachedFeatureData.featureDiscovery.concat(newMarkedFeature)
        }
    });
};
const $112f5732a615f62f$var$getLocalOverrideValue = (featureKey)=>{
    try {
        if ((0, $17wUi.confluenceSessionStorageInstance).getItem((0, $9wGTI.fg)('confluence_browser_storage_prepended_keys') ? `${featureKey}-featureDiscoveryOverride` : `${(0, $1UApO.keys).FEATURE_DISCOVERY_OVERRIDE_PREFIX}-${featureKey}`)) return true;
    } catch (e) {
        $112f5732a615f62f$var$logger.error(e);
    }
    return false;
};
const $112f5732a615f62f$var$noop = ()=>{};
const $112f5732a615f62f$export$6de1a7573792d1a9 = (featureKey, skip)=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const skipFeatureDiscoveryQuery = !isLoggedIn || skip;
    const { data: data, loading: queryLoading, error: queryError } = (0, $jMyy4.useQueryInterop)($112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery, {
        skip: skipFeatureDiscoveryQuery
    });
    const [markFeatureDiscovered, { loading: mutationLoading, error: mutationError }] = (0, $308Wd.useMutationInterop)($112f5732a615f62f$var$useFeatureDiscoveryMarkFeatureDiscoveredMutation, {
        variables: {
            featureKey: featureKey,
            pluginKey: $112f5732a615f62f$export$2dd355223baa0569
        },
        update: $112f5732a615f62f$var$updateCache
    });
    const loading = queryLoading || mutationLoading;
    const error = queryError || mutationError;
    const showFeature = !loading && !error && !data?.featureDiscovery?.some((feature)=>feature?.pluginKey === $112f5732a615f62f$export$2dd355223baa0569 && feature?.featureKey === featureKey);
    const handleStop = (0, $42omo.useCallback)(()=>{
        if (showFeature) // error is handled in the useMutation result
        markFeatureDiscovered().catch(()=>{});
    }, [
        showFeature,
        markFeatureDiscovered
    ]);
    if (skipFeatureDiscoveryQuery) return [
        false,
        $112f5732a615f62f$var$noop,
        undefined
    ];
    // this is for dev/testing, since we cant easily remove data from the featureDiscovery array
    const forceShowFeature = showFeature || $112f5732a615f62f$var$getLocalOverrideValue(featureKey);
    return [
        forceShowFeature,
        handleStop,
        error
    ];
};
module.exports["useFeatureDiscovery"] = $112f5732a615f62f$export$6de1a7573792d1a9;

});

parcelRegister("h1PDd", function(module, exports) {
/**
 * @generated SignedSource<<1c52947b4a05fe02fc1b43b80c341c9c>>
 * @relayHash 7e3a97b41907f84e881bf7535b1379ce
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID aded1ac8c4d8c5f52bbd0e95ce0857860d2f9ccb92e721ad18f7b30caef06081
const $fca31db58911eb73$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "featureKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pluginKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "featureKey",
                    "variableName": "featureKey"
                },
                {
                    "kind": "Variable",
                    "name": "pluginKey",
                    "variableName": "pluginKey"
                }
            ],
            "concreteType": "FeatureDiscoveryPayload",
            "kind": "LinkedField",
            "name": "markFeatureDiscovered",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "pluginKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "featureKey"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFeatureDiscoveryMarkFeatureDiscoveredMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFeatureDiscoveryMarkFeatureDiscoveredMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "7e3a97b41907f84e881bf7535b1379ce",
            "id": "aded1ac8c4d8c5f52bbd0e95ce0857860d2f9ccb92e721ad18f7b30caef06081",
            "metadata": {},
            "name": "useFeatureDiscoveryMarkFeatureDiscoveredMutation",
            "operationKind": "mutation",
            "text": "mutation useFeatureDiscoveryMarkFeatureDiscoveredMutation($featureKey:String!,$pluginKey:String!){markFeatureDiscovered(featureKey:$featureKey,pluginKey:$pluginKey){pluginKey,featureKey}}"
        }
    };
}();
$fca31db58911eb73$var$node.hash = "55ae5a7186fb2a98e37da374a9b9784e";
var $fca31db58911eb73$export$2e2bcd8739ae039 = $fca31db58911eb73$var$node;
module.exports["default"] = $fca31db58911eb73$export$2e2bcd8739ae039;

});

parcelRegister("4oZIh", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $eSUdr = parcelRequire("eSUdr");


var $j1Ss3 = parcelRequire("j1Ss3");


var $1o4fX = parcelRequire("1o4fX");


var $8H5XZ = parcelRequire("8H5XZ");


var $7Sm4c = parcelRequire("7Sm4c");





var $bQm3c = parcelRequire("bQm3c");

const $539a9f290c7f1955$export$be2f13183561cb = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { skip: t1 } = t0;
    const skip = t1 === undefined ? true : t1;
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const shouldSkipQuery = skip || !isLoggedIn;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $eSUdr.default)`query useTrialDetailsTrialDetailsQuery{license{trialEndDate billingSourceSystem}}`;
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== shouldSkipQuery) {
        t3 = {
            skip: shouldSkipQuery
        };
        $[1] = shouldSkipQuery;
        $[2] = t3;
    } else t3 = $[2];
    const { data: trialData, loading: trialDetailsLoading, error: trialDetailsError } = (0, $j1Ss3.useQuery)(t2, t3);
    if ((0, $8H5XZ.isGraphQLError)(trialDetailsError) && !(0, $7Sm4c.isErrorMarkedAsHandled)(trialDetailsError)) (0, $7Sm4c.markErrorAsHandled)(trialDetailsError);
    let t4;
    if ($[3] !== trialData?.license?.trialEndDate) {
        t4 = (0, $1o4fX.getTrialDaysLeftFromTrialEndDate)(trialData?.license?.trialEndDate) ?? 0;
        $[3] = trialData?.license?.trialEndDate;
        $[4] = t4;
    } else t4 = $[4];
    const trialDaysLeft = t4;
    const t5 = trialDaysLeft > 0;
    const t6 = trialData?.license?.trialEndDate;
    const t7 = trialData?.license?.billingSourceSystem;
    let t8;
    if ($[5] !== t5 || $[6] !== t6 || $[7] !== t7 || $[8] !== trialData || $[9] !== trialDaysLeft || $[10] !== trialDetailsError || $[11] !== trialDetailsLoading) {
        t8 = {
            trialData: trialData,
            trialDetailsLoading: trialDetailsLoading,
            trialDetailsError: trialDetailsError,
            isInstanceInTrial: t5,
            trialDaysLeft: trialDaysLeft,
            trialEndDate: t6,
            billingSourceSystem: t7
        };
        $[5] = t5;
        $[6] = t6;
        $[7] = t7;
        $[8] = trialData;
        $[9] = trialDaysLeft;
        $[10] = trialDetailsError;
        $[11] = trialDetailsLoading;
        $[12] = t8;
    } else t8 = $[12];
    return t8;
} : ({ skip: skip = true })=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const shouldSkipQuery = skip || !isLoggedIn;
    const { data: trialData, loading: trialDetailsLoading, error: trialDetailsError } = (0, $j1Ss3.useQuery)((0, $eSUdr.default)`query useTrialDetailsTrialDetailsQuery{license{trialEndDate billingSourceSystem}}`, {
        skip: shouldSkipQuery
    });
    if ((0, $8H5XZ.isGraphQLError)(trialDetailsError) && !(0, $7Sm4c.isErrorMarkedAsHandled)(trialDetailsError)) (0, $7Sm4c.markErrorAsHandled)(trialDetailsError);
    const trialDaysLeft = (0, $1o4fX.getTrialDaysLeftFromTrialEndDate)(trialData?.license?.trialEndDate) ?? 0;
    return {
        trialData: trialData,
        trialDetailsLoading: trialDetailsLoading,
        trialDetailsError: trialDetailsError,
        isInstanceInTrial: trialDaysLeft > 0,
        trialDaysLeft: trialDaysLeft,
        trialEndDate: trialData?.license?.trialEndDate,
        billingSourceSystem: trialData?.license?.billingSourceSystem
    };
};
module.exports["useTrialDetails"] = $539a9f290c7f1955$export$be2f13183561cb;

});

parcelRegister("fdPUP", function(module, exports) {
const $73fa77a308d85fef$export$219d516b185caa05 = 'ShareAndRestrictDialog';
const $73fa77a308d85fef$export$b1e4cd5fa4074c7a = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions';
const $73fa77a308d85fef$export$ce504fce6cf8855f = 'https://support.atlassian.com/confluence-cloud/docs/manage-permissions-on-the-page-level/';
module.exports["SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE"] = $73fa77a308d85fef$export$219d516b185caa05;
module.exports["SAC_CONTENT_PERMS_MANAGEMENT_DOCUMENTATION"] = $73fa77a308d85fef$export$ce504fce6cf8855f;

});

parcelRegister("ePExc", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ec704748a0115052$export$9542b2119eeb5eb4 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "327gI",
    name: "ShareAndRestrictDialogController",
    loader: async ()=>(await (parcelRequire("7aHNB"))).Controller
});
module.exports["ShareAndRestrictDialogController"] = $ec704748a0115052$export$9542b2119eeb5eb4;

});

parcelRegister("7aHNB", function(module, exports) {

let $538b712a8f615478$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $538b712a8f615478$var$load("jbxHq"),
    $538b712a8f615478$var$load("jXx9i"),
    $538b712a8f615478$var$load("6wr18"),
    $538b712a8f615478$var$load("k55bj"),
    $538b712a8f615478$var$load("jrCdz"),
    $538b712a8f615478$var$load("6alNH"),
    $538b712a8f615478$var$load("fSobj"),
    $538b712a8f615478$var$load("74u2y"),
    $538b712a8f615478$var$load("ffEVr"),
    $538b712a8f615478$var$load("7EorR"),
    $538b712a8f615478$var$load("Wowvf"),
    $538b712a8f615478$var$load("cJcjb"),
    $538b712a8f615478$var$load("beE2d"),
    $538b712a8f615478$var$load("hhss7"),
    $538b712a8f615478$var$load("bunf9")
]).then(()=>parcelRequire('4adOe'));

});

parcelRegister("7CeAz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cEgMD = parcelRequire("cEgMD");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $1ytiN = parcelRequire("1ytiN");


var $8NC5Z = parcelRequire("8NC5Z");

const $16ea73778f65e8da$export$1d4394ae12760637 = ()=>{
    const { frontCoverState: frontCoverState, isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
    const canPublish = isSiteAdmin || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const isAdminDiscoverable = // 1. If entitled (e.g. Premium), both site admin and product admin have the
    //    entry point in the top nav, because it leads to COMPANY_HUB.
    // 2. If not entitled (e.g. Free or Standard):
    //   a. only site admin has the entry point in the top nav, because it
    //      renders an upsell;
    //   b. product admin doesn't have the entry point in the top nav, because
    //      it automatically redirects to HOME.
    shouldShowPremiumUpsell ? isSiteAdmin : canPublish;
    const isCompanyHubFeatureAvailable = !shouldShowPremiumUpsell;
    const isCompanyHubPublished = Boolean(isCompanyHubFeatureAvailable && frontCoverState === (0, $cEgMD.FrontCoverStateEnum).SHOWN);
    const isCompanyHubShownToEditors = Boolean(isCompanyHubFeatureAvailable && frontCoverState === (0, $cEgMD.FrontCoverStateEnum).EDITORS_ONLY || isCompanyHubPublished);
    const isCompanyHubEntryPointEnabled = Boolean(isCompanyHubFeatureAvailable && (isCompanyHubPublished || isCompanyHubShownToEditors) || isAdminDiscoverable);
    return {
        canPublish: isCompanyHubFeatureAvailable && canPublish,
        isCompanyHubPublished: isCompanyHubPublished,
        isCompanyHubShownToEditors: isCompanyHubShownToEditors,
        isCompanyHubEntryPointEnabled: isCompanyHubEntryPointEnabled
    };
};
module.exports["useIsCompanyHubEnabled"] = $16ea73778f65e8da$export$1d4394ae12760637;

});

parcelRegister("8NC5Z", function(module, exports) {

var $896gY = parcelRequire("896gY");


var $7Sm4c = parcelRequire("7Sm4c");


var $euL71 = parcelRequire("euL71");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $5ZqQS = parcelRequire("5ZqQS");


var $bQm3c = parcelRequire("bQm3c");


var $jMyy4 = parcelRequire("jMyy4");

const $1de3a5511529eed3$export$f032b5e8b485da1d = ({ skip: skip = false } = {})=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const shouldSkip = skip || edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $896gY.default), {
        skip: shouldSkip
    });
    if (error) {
        if (!((0, $1uFM6.isUnauthorizedError)(error) || (0, $f9jv7.isNotFoundError)(error))) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PERFORMANCE_INSIGHTS
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    return !shouldSkip && !data?.entitlements?.companyHub?.isEntitled;
};
module.exports["useCompanyHubPremiumGate"] = $1de3a5511529eed3$export$f032b5e8b485da1d;

});

parcelRegister("896gY", function(module, exports) {
/**
 * @generated SignedSource<<f7fbc559eec5624709ee73b4742b3b2c>>
 * @relayHash c31aa70a9a01e2207eb48c0b9be8b493
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 46122cb94f25a4d113917d2f15feffbc32da4a3126240723b7ca4eed1bf9dbd6
const $983e77d68212dc57$var$node = function() {
    var v0 = [
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "CompanyHubFeature",
                    "kind": "LinkedField",
                    "name": "companyHub",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useCompanyHubPremiumGateCompanyHubPremiumGateQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useCompanyHubPremiumGateCompanyHubPremiumGateQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "c31aa70a9a01e2207eb48c0b9be8b493",
            "id": "46122cb94f25a4d113917d2f15feffbc32da4a3126240723b7ca4eed1bf9dbd6",
            "metadata": {},
            "name": "useCompanyHubPremiumGateCompanyHubPremiumGateQuery",
            "operationKind": "query",
            "text": "query useCompanyHubPremiumGateCompanyHubPremiumGateQuery{entitlements{companyHub{isEntitled}}}"
        }
    };
}();
$983e77d68212dc57$var$node.hash = "a5508e7e7123c5675909c4f9214a5be2";
var $983e77d68212dc57$export$2e2bcd8739ae039 = $983e77d68212dc57$var$node;
module.exports["default"] = $983e77d68212dc57$export$2e2bcd8739ae039;

});

parcelRegister("5qxqN", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $95fd3920e3fd73a4$var$initialState = {
    // doing localStorage check in case it is undefined in testing.
    // localStorage can't be initialized in testing because this block of code is executed first
    isEnabled: (0, $17wUi.confluenceLocalStorageInstance) ? (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_PREMIUM_FEATURE_HIGHLIGHT) === null || (0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_PREMIUM_FEATURE_HIGHLIGHT) : true
};
const $95fd3920e3fd73a4$var$actions = {
    update: ()=>({ setState: setState, getState: getState })=>{
            const prevState = getState();
            const isEnabled = !prevState.isEnabled;
            setState({
                isEnabled: isEnabled
            });
            (0, $17wUi.confluenceLocalStorageInstance)?.setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_PREMIUM_FEATURE_HIGHLIGHT, isEnabled);
        }
};
const $95fd3920e3fd73a4$var$store = (0, $1P1Tu.createStore)({
    initialState: $95fd3920e3fd73a4$var$initialState,
    actions: $95fd3920e3fd73a4$var$actions,
    name: 'PremiumFeatureHighlightStore'
});
const $95fd3920e3fd73a4$export$8f188abde04b9781 = (0, $9zUhf.createHook)($95fd3920e3fd73a4$var$store);
module.exports["usePremiumFeatureHighlight"] = $95fd3920e3fd73a4$export$8f188abde04b9781;

});

parcelRegister("bC5Yk", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $lzcvT = parcelRequire("lzcvT");


var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $bnGIh = parcelRequire("bnGIh");


var $8gbsh = parcelRequire("8gbsh");


var $4oZIh = parcelRequire("4oZIh");

const $06ae01438faf2d07$export$aea6e52a413de9e6 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(15);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { isPremiumOnboardingEnabled: t2, shouldCheckIsInTrial: t3 } = t1;
    const isPremiumOnboardingEnabled = t2 === undefined ? true : t2;
    const shouldCheckIsInTrial = t3 === undefined ? true : t3;
    const { edition: edition, isLoggedIn: isLoggedIn, isLicensed: isLicensed, userId: userId } = (0, $bQm3c.useSessionData)();
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $lzcvT.isFedRamp)();
        $[2] = t4;
    } else t4 = $[2];
    const isFedrampEnv = t4;
    const isUserAndInstanceEligible = isPremiumOnboardingEnabled && edition === (0, $euL71.ConfluenceEdition).PREMIUM && isLoggedIn && isLicensed && Boolean(userId) && !isFedrampEnv;
    const t5 = !isUserAndInstanceEligible;
    let t6;
    if ($[3] !== t5) {
        t6 = {
            skip: t5
        };
        $[3] = t5;
        $[4] = t6;
    } else t6 = $[4];
    const { loading: reverseTrialLoading, error: reverseTrialError, reverseTrialCohort: reverseTrialCohort } = (0, $bnGIh.useReverseTrialEligible)(t6);
    const t7 = !shouldCheckIsInTrial || !isUserAndInstanceEligible;
    let t8;
    if ($[5] !== t7) {
        t8 = {
            skip: t7
        };
        $[5] = t7;
        $[6] = t8;
    } else t8 = $[6];
    const { trialData: trialData, trialDetailsError: trialDetailsError, trialDetailsLoading: trialDetailsLoading, trialDaysLeft: trialDaysLeft, isInstanceInTrial: isInstanceInTrial } = (0, $4oZIh.useTrialDetails)(t8);
    const isReverseTrialEnrolled = reverseTrialCohort === (0, $8gbsh.ReverseTrialCohort).ENROLLED;
    const isPTOEligible = isUserAndInstanceEligible && !reverseTrialLoading && !reverseTrialError;
    const isPTORTEligible = isPTOEligible && isReverseTrialEnrolled;
    const isPremiumOnboardingFeatureDiscoveryEnabled = isPTOEligible && (!shouldCheckIsInTrial || !trialDetailsLoading && !trialDetailsError && isInstanceInTrial);
    const isPTORTEnabled = isPTORTEligible && isPremiumOnboardingFeatureDiscoveryEnabled;
    const t9 = trialDetailsLoading || reverseTrialLoading;
    const t10 = trialData?.license?.trialEndDate;
    let t11;
    if ($[7] !== isPTORTEnabled || $[8] !== isPremiumOnboardingFeatureDiscoveryEnabled || $[9] !== reverseTrialError || $[10] !== t10 || $[11] !== t9 || $[12] !== trialDaysLeft || $[13] !== trialDetailsError) {
        t11 = {
            loading: t9,
            inTrialError: trialDetailsError,
            reverseTrialError: reverseTrialError,
            isPremiumOnboardingFeatureDiscoveryEnabled: isPremiumOnboardingFeatureDiscoveryEnabled,
            isPTORTEnabled: isPTORTEnabled,
            trialDaysLeft: trialDaysLeft,
            trialEndDate: t10
        };
        $[7] = isPTORTEnabled;
        $[8] = isPremiumOnboardingFeatureDiscoveryEnabled;
        $[9] = reverseTrialError;
        $[10] = t10;
        $[11] = t9;
        $[12] = trialDaysLeft;
        $[13] = trialDetailsError;
        $[14] = t11;
    } else t11 = $[14];
    return t11;
} : ({ isPremiumOnboardingEnabled: isPremiumOnboardingEnabled = true, shouldCheckIsInTrial: shouldCheckIsInTrial = true } = {})=>{
    const { edition: edition, isLoggedIn: isLoggedIn, isLicensed: isLicensed, userId: userId } = (0, $bQm3c.useSessionData)();
    const isFedrampEnv = (0, $lzcvT.isFedRamp)();
    const isUserAndInstanceEligible = isPremiumOnboardingEnabled && edition === (0, $euL71.ConfluenceEdition).PREMIUM && isLoggedIn && isLicensed && Boolean(userId) && // FedRamp shouldn't have any premium trial customer but we are excluding it just in case
    !isFedrampEnv;
    const { loading: reverseTrialLoading, error: reverseTrialError, reverseTrialCohort: reverseTrialCohort } = (0, $bnGIh.useReverseTrialEligible)({
        skip: !isUserAndInstanceEligible
    });
    const { trialData: trialData, trialDetailsError: trialDetailsError, trialDetailsLoading: trialDetailsLoading, trialDaysLeft: trialDaysLeft, isInstanceInTrial: isInstanceInTrial } = (0, $4oZIh.useTrialDetails)({
        skip: !shouldCheckIsInTrial || !isUserAndInstanceEligible
    });
    const isReverseTrialEnrolled = reverseTrialCohort === (0, $8gbsh.ReverseTrialCohort).ENROLLED; // checks if it is RT instance
    const isPTOEligible = isUserAndInstanceEligible && !reverseTrialLoading && !reverseTrialError;
    const isPTORTEligible = isPTOEligible && isReverseTrialEnrolled;
    const isPremiumOnboardingFeatureDiscoveryEnabled = isPTOEligible && (!shouldCheckIsInTrial || !trialDetailsLoading && !trialDetailsError && isInstanceInTrial);
    const isPTORTEnabled = isPTORTEligible && isPremiumOnboardingFeatureDiscoveryEnabled;
    return {
        loading: trialDetailsLoading || reverseTrialLoading,
        inTrialError: trialDetailsError,
        reverseTrialError: reverseTrialError,
        isPremiumOnboardingFeatureDiscoveryEnabled: isPremiumOnboardingFeatureDiscoveryEnabled,
        isPTORTEnabled: isPTORTEnabled,
        trialDaysLeft: trialDaysLeft,
        trialEndDate: trialData?.license?.trialEndDate
    };
};
module.exports["useIsPremiumOnboardingFeatureDiscoveryEnabled"] = $06ae01438faf2d07$export$aea6e52a413de9e6;

});

parcelRegister("bnGIh", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $eSUdr = parcelRequire("eSUdr");


var $j1Ss3 = parcelRequire("j1Ss3");


var $8H5XZ = parcelRequire("8H5XZ");


var $7Sm4c = parcelRequire("7Sm4c");




const $96463d3f4390f0c4$export$4695bad538a258b4 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {
            skip: false
        } : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { skip: skip } = t1;
    const skipQuery = skip || Boolean(undefined);
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $eSUdr.default)`query useReverseTrialEligibleSignUpPropertiesQuery{signUpProperties{reverseTrial}}`;
        $[2] = t2;
    } else t2 = $[2];
    const QUERY_DOC = t2;
    let t3;
    if ($[3] !== skipQuery) {
        t3 = {
            skip: skipQuery
        };
        $[3] = skipQuery;
        $[4] = t3;
    } else t3 = $[4];
    const { data: data, loading: loading, error: error } = (0, $j1Ss3.useQuery)(QUERY_DOC, t3);
    if ((0, $8H5XZ.isGraphQLError)(error) && !(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    const t4 = data?.signUpProperties?.reverseTrial;
    const t5 = skipQuery ? false : loading;
    const t6 = skipQuery ? null : error;
    let t7;
    if ($[5] !== t4 || $[6] !== t5 || $[7] !== t6) {
        t7 = {
            reverseTrialCohort: t4,
            loading: t5,
            error: t6
        };
        $[5] = t4;
        $[6] = t5;
        $[7] = t6;
        $[8] = t7;
    } else t7 = $[8];
    return t7;
} : ({ skip: skip } = {
    skip: false
})=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const skipQuery = skip || Boolean(undefined); // Query is not preloaded and can be skipped during SSR to avoid unnecessary requests
    const QUERY_DOC = (0, $eSUdr.default)`query useReverseTrialEligibleSignUpPropertiesQuery{signUpProperties{reverseTrial}}`;
    const { data: data, loading: loading, error: error } = (0, $j1Ss3.useQuery)(QUERY_DOC, {
        skip: skipQuery
    });
    if ((0, $8H5XZ.isGraphQLError)(error) && !(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    return {
        reverseTrialCohort: data?.signUpProperties?.reverseTrial,
        loading: skipQuery ? false : loading,
        error: skipQuery ? null : error
    };
};
module.exports["useReverseTrialEligible"] = $96463d3f4390f0c4$export$4695bad538a258b4;

});

parcelRegister("8gbsh", function(module, exports) {
/**
 * @generated SignedSource<<59bdf6903d6eebf2e54af64858adbdfe>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: cc
 *
 * @see https://go/typsy
 **/ var $14320b27f2be49ff$export$8798225e6f84b893 = /*#__PURE__*/ function(ReverseTrialCohort) {
    ReverseTrialCohort["CONTROL"] = "CONTROL";
    ReverseTrialCohort["ENROLLED"] = "ENROLLED";
    ReverseTrialCohort["NOT_ENROLLED"] = "NOT_ENROLLED";
    ReverseTrialCohort["UNASSIGNED"] = "UNASSIGNED";
    ReverseTrialCohort["UNKNOWN"] = "UNKNOWN";
    ReverseTrialCohort["VARIANT"] = "VARIANT";
    return ReverseTrialCohort;
}({});
module.exports["ReverseTrialCohort"] = $14320b27f2be49ff$export$8798225e6f84b893;

});

parcelRegister("5QjrO", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $2Fndw = parcelRequire("2Fndw");


var $inPa6 = parcelRequire("inPa6");


var $dh538 = parcelRequire("dh538");


var $aXjWU = parcelRequire("aXjWU");


var $lwNi3 = parcelRequire("lwNi3");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $lsxnT = parcelRequire("lsxnT");


var $eXOow = parcelRequire("eXOow");








var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $lbbQA = parcelRequire("lbbQA");


var $c1nt3 = parcelRequire("c1nt3");

/**
 * @generated SignedSource<<f2317478dae40a28ca8d7b128eed0d6a>>
 * @relayHash cc595dc85439b19b542554f98838badb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9fb44502df802b60ce601a47a194fb68f205b0d895c01324d3313c0b69929970
const $54df41c2bf092516$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "entitlementId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "transactionAccountId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "invoiceable"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useBillingDetailsBillingDetailsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "concreteType": "CcpSubscription",
                                                    "kind": "LinkedField",
                                                    "name": "subscription",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "CcpAccountDetails",
                                                            "kind": "LinkedField",
                                                            "name": "accountDetails",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "CcpInvoiceGroup",
                                                                    "kind": "LinkedField",
                                                                    "name": "invoiceGroup",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "CcpEntitlement"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useBillingDetailsBillingDetailsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "concreteType": "CcpSubscription",
                                                    "kind": "LinkedField",
                                                    "name": "subscription",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "CcpAccountDetails",
                                                            "kind": "LinkedField",
                                                            "name": "accountDetails",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "CcpInvoiceGroup",
                                                                    "kind": "LinkedField",
                                                                    "name": "invoiceGroup",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        v7 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v7 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "CcpEntitlement"
                                        },
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "cc595dc85439b19b542554f98838badb",
            "id": "9fb44502df802b60ce601a47a194fb68f205b0d895c01324d3313c0b69929970",
            "metadata": {},
            "name": "useBillingDetailsBillingDetailsQuery",
            "operationKind": "query",
            "text": "query useBillingDetailsBillingDetailsQuery($cloudId:ID!,$hamsProductKey:String!){tenantContexts(cloudIds:[$cloudId]){entitlementInfo(hamsProductKey:$hamsProductKey){__typename,entitlementId,entitlement{__typename,...on CcpEntitlement{transactionAccountId,subscription{accountDetails{invoiceGroup{invoiceable,id}},id}},id}}}}"
        }
    };
}();
$54df41c2bf092516$var$node.hash = "42ca154ec21171eda287b098497734cb";
var $54df41c2bf092516$export$2e2bcd8739ae039 = $54df41c2bf092516$var$node;



var $8H5XZ = parcelRequire("8H5XZ");


var $gKr8t = parcelRequire("gKr8t");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $jMyy4 = parcelRequire("jMyy4");

const $a5097bce9f4ba19e$export$55c3fab863f061c7 = ({ cloudId: cloudId, skip: skip = false })=>{
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $54df41c2bf092516$export$2e2bcd8739ae039), {
        variables: {
            cloudId: cloudId,
            hamsProductKey: 'confluence.ondemand'
        },
        skip: skip,
        client: (0, $gKr8t.getAGGClient)(),
        onError: (error)=>{
            if ((0, $1uFM6.isUnauthorizedError)(error) || (0, $8H5XZ.isGraphQLError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        }
    });
    const result = {
        loading: loading,
        hasPaymentDetails: false
    };
    if (!loading && error) return result;
    const entitlementInfo = data?.tenantContexts?.[0]?.entitlementInfo;
    if (entitlementInfo) {
        const { entitlement: entitlement, entitlementId: entitlementId } = entitlementInfo;
        result.entitlementId = entitlementId;
        if (entitlement?.__typename === 'CcpEntitlement') {
            result.hasPaymentDetails = entitlement.subscription?.accountDetails?.invoiceGroup?.invoiceable ?? false;
            result.transactionAccountId = entitlement.transactionAccountId;
        }
    }
    return result;
};


const $66dd850e377c0faa$export$5d3e9044de751b4 = ()=>{
    const { cloudId: cloudId, edition: edition } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { hasPaymentDetails: hasPaymentDetails } = (0, $a5097bce9f4ba19e$export$55c3fab863f061c7)({
        cloudId: cloudId
    });
    const [isEligible, setIsEligible] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        const fetchEligibility = async ()=>{
            try {
                const trait = await (0, $lbbQA.getAutoProvisioningTapTrait)(cloudId);
                const isConfluenceEditionPaid = edition === (0, $d9tcB.ConfluenceEdition).STANDARD || edition === (0, $d9tcB.ConfluenceEdition).PREMIUM;
                const isEligible = isConfluenceEditionPaid && hasPaymentDetails && !!trait;
                setIsEligible(isEligible);
            } catch (error) {
                (0, $c1nt3.fireErrorAnalytics)(createAnalyticsEvent, 'Error fetching eligibility checks', error);
            }
        };
        fetchEligibility();
    }, [
        hasPaymentDetails,
        edition,
        cloudId,
        createAnalyticsEvent
    ]);
    return isEligible;
};


const $b90be900bfcd6f1a$var$AUTO_PROVISIONING_CONFLUENCE_UPGRADE_EP_MESSAGE = 'auto-provisioning-confluence-upgrade';
/* eslint-disable check-i18n-id-prefix/i18n-id-prefix-with-package-name-defineMessages */ const $b90be900bfcd6f1a$var$i18n = (0, $cgtv4.defineMessages)({
    manageYourTrial: {
        id: "experiment-auto-provisioning-edition-parity.manage-your-trial.title",
        defaultMessage: "Manage your trial"
    },
    learnMoreDescription: {
        id: "experiment-auto-provisioning-edition-parity.trial-description",
        defaultMessage: "Learn about your Premium features and manage your trial at any time."
    },
    okButton: {
        id: "experiment-auto-provisioning-edition-parity.ok.button",
        defaultMessage: "Ok"
    },
    // Duplicated with package-prefix ids for valid i18n for switching from experiment to auto-provisioning, will switch after these messages are translated
    manageYourTrialTitle: {
        id: "auto-provisioning-edition-parity.manage-your-trial.title",
        defaultMessage: "Manage your trial"
    },
    trialDescription: {
        id: "auto-provisioning-edition-parity.trial-description",
        defaultMessage: "Learn about your Premium features and manage your trial at any time."
    },
    okButtonLabel: {
        id: "auto-provisioning-edition-parity.ok.button",
        defaultMessage: "Ok"
    }
});
const $b90be900bfcd6f1a$export$944cc7f764e4762a = ({ onClose: onClose })=>{
    const coordinationClient = (0, $lwNi3.useCoordinationClient)();
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [shouldRenderSpotlight, setShouldRenderSpotlight] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isEligible = (0, $66dd850e377c0faa$export$5d3e9044de751b4)();
    const { hasMessageStarted: hasMessageStarted, requestMessageStart: requestMessageStart, dismissMessage: dismissMessage } = (0, $aXjWU.usePostOfficeExernalMessageProxy)($b90be900bfcd6f1a$var$AUTO_PROVISIONING_CONFLUENCE_UPGRADE_EP_MESSAGE);
    (0, $42omo.useEffect)(()=>{
        const fetchEligibility = async ()=>{
            if (isEligible) {
                if ((0, $dh538.fg)('post_office_ep_migration_auto-provisioning-confl')) requestMessageStart();
                else coordinationClient.start($b90be900bfcd6f1a$var$AUTO_PROVISIONING_CONFLUENCE_UPGRADE_EP_MESSAGE).then(async (data)=>{
                    setShouldRenderSpotlight(data);
                }).catch(async ()=>setShouldRenderSpotlight(false));
            }
        };
        fetchEligibility();
    }, [
        coordinationClient,
        isEligible,
        requestMessageStart
    ]);
    (0, $42omo.useEffect)(()=>{
        if (hasMessageStarted) setShouldRenderSpotlight(true);
    }, [
        hasMessageStarted
    ]);
    const closeModal = (0, $42omo.useCallback)(async ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'confluenceTrialUpgradeSpotlightOkButton',
                source: 'confluenceTrialUpgradeSpotlight'
            }
        }).fire();
        if ((0, $dh538.fg)('post_office_ep_migration_auto-provisioning-confl')) dismissMessage();
        else coordinationClient.stop($b90be900bfcd6f1a$var$AUTO_PROVISIONING_CONFLUENCE_UPGRADE_EP_MESSAGE);
        onClose();
        setShouldRenderSpotlight(false);
    }, [
        createAnalyticsEvent,
        onClose,
        coordinationClient,
        dismissMessage
    ]);
    (0, $42omo.useEffect)(()=>{
        shouldRenderSpotlight && createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'confluenceTrialUpgradeSpotlight'
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        shouldRenderSpotlight
    ]);
    const handleErrorBoundary = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'unhandledConfluenceTrialUpgradeError',
                source: 'confluenceTrialUpgradeSpotlight',
                actionSubject: 'ui'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const actions = (0, $42omo.useMemo)(()=>[
            {
                onClick: closeModal,
                text: formatMessage($b90be900bfcd6f1a$var$i18n.okButton),
                appearance: 'default'
            }
        ], [
        closeModal,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, shouldRenderSpotlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).GROWTH_STARBURST,
        onError: handleErrorBoundary
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Spotlight, {
        target: (0, $eXOow.PTO_PHASE_TWO_SPOTLIGHT_TARGET),
        key: (0, $eXOow.PTO_PHASE_TWO_SPOTLIGHT_TARGET),
        shouldWatchTarget: true,
        targetRadius: 3,
        heading: formatMessage($b90be900bfcd6f1a$var$i18n.manageYourTrial),
        dialogPlacement: "bottom left",
        dialogWidth: 289,
        targetBgColor: "var(--ds-icon-inverse, #FFFFFF)",
        actions: actions
    }, formatMessage($b90be900bfcd6f1a$var$i18n.learnMoreDescription)))));
};
module.exports["ConfluenceTrialSpotlight"] = $b90be900bfcd6f1a$export$944cc7f764e4762a;

});


//# sourceMappingURL=EditionAwareness.87ea116e.js.map
